var AcademicTitle = /* @__PURE__ */ ((AcademicTitle2) => {
  AcademicTitle2["None"] = "NONE";
  AcademicTitle2["Dr"] = "DR";
  AcademicTitle2["Prof"] = "PROF";
  AcademicTitle2["ProfDr"] = "PROF_DR";
  AcademicTitle2["Ing"] = "ING";
  AcademicTitle2["DiplIng"] = "DIPL_ING";
  AcademicTitle2["Mag"] = "MAG";
  return AcademicTitle2;
})(AcademicTitle || {});
var Accessibility = /* @__PURE__ */ ((Accessibility2) => {
  Accessibility2["Unknown"] = "UNKNOWN";
  Accessibility2["BarrierFree"] = "BARRIER_FREE";
  Accessibility2["NotBarrierFree"] = "NOT_BARRIER_FREE";
  Accessibility2["Unselected"] = "UNSELECTED";
  return Accessibility2;
})(Accessibility || {});
var AdSenderTypes = /* @__PURE__ */ ((AdSenderTypes2) => {
  AdSenderTypes2["User"] = "user";
  AdSenderTypes2["Company"] = "company";
  AdSenderTypes2["PublisherPage"] = "publisher_page";
  AdSenderTypes2["Page"] = "page";
  AdSenderTypes2["EntityPage"] = "entity_page";
  return AdSenderTypes2;
})(AdSenderTypes || {});
var AdTypes = /* @__PURE__ */ ((AdTypes2) => {
  AdTypes2["EventAd"] = "EventAd";
  AdTypes2["WebsiteAd"] = "WebsiteAd";
  AdTypes2["VideoAd"] = "VideoAd";
  AdTypes2["LeadAd"] = "LeadAd";
  AdTypes2["PostingAd"] = "PostingAd";
  AdTypes2["EntityPageAd"] = "EntityPageAd";
  return AdTypes2;
})(AdTypes || {});
var ArticleMediaInputType = /* @__PURE__ */ ((ArticleMediaInputType2) => {
  ArticleMediaInputType2["ImageCacheUuid"] = "IMAGE_CACHE_UUID";
  ArticleMediaInputType2["UploadId"] = "UPLOAD_ID";
  return ArticleMediaInputType2;
})(ArticleMediaInputType || {});
var ArticlePublicationState = /* @__PURE__ */ ((ArticlePublicationState2) => {
  ArticlePublicationState2["Draft"] = "DRAFT";
  ArticlePublicationState2["Published"] = "PUBLISHED";
  return ArticlePublicationState2;
})(ArticlePublicationState || {});
var ArticleSupportedBlockTypes = /* @__PURE__ */ ((ArticleSupportedBlockTypes2) => {
  ArticleSupportedBlockTypes2["ArticleParagraph"] = "ARTICLE_PARAGRAPH";
  ArticleSupportedBlockTypes2["ArticleH2"] = "ARTICLE_H2";
  ArticleSupportedBlockTypes2["ArticleH3"] = "ARTICLE_H3";
  ArticleSupportedBlockTypes2["ArticleH4"] = "ARTICLE_H4";
  ArticleSupportedBlockTypes2["ArticleUnorderedListItem"] = "ARTICLE_UNORDERED_LIST_ITEM";
  ArticleSupportedBlockTypes2["ArticleOrderedListItem"] = "ARTICLE_ORDERED_LIST_ITEM";
  ArticleSupportedBlockTypes2["ArticleQuote"] = "ARTICLE_QUOTE";
  ArticleSupportedBlockTypes2["ArticleEmphasis"] = "ARTICLE_EMPHASIS";
  ArticleSupportedBlockTypes2["ArticleBodyImage"] = "ARTICLE_BODY_IMAGE";
  return ArticleSupportedBlockTypes2;
})(ArticleSupportedBlockTypes || {});
var AvailableAction = /* @__PURE__ */ ((AvailableAction2) => {
  AvailableAction2["AddContact"] = "ADD_CONTACT";
  AvailableAction2["AddLead"] = "ADD_LEAD";
  AvailableAction2["RemoveLead"] = "REMOVE_LEAD";
  AvailableAction2["BlockUser"] = "BLOCK_USER";
  AvailableAction2["BookmarkUser"] = "BOOKMARK_USER";
  AvailableAction2["Call"] = "CALL";
  AvailableAction2["ConfirmContact"] = "CONFIRM_CONTACT";
  AvailableAction2["DeleteContact"] = "DELETE_CONTACT";
  AvailableAction2["DeclineContactRequest"] = "DECLINE_CONTACT_REQUEST";
  AvailableAction2["EditXingId"] = "EDIT_XING_ID";
  AvailableAction2["Follow"] = "FOLLOW";
  AvailableAction2["ImportVcard"] = "IMPORT_VCARD";
  AvailableAction2["InviteGroup"] = "INVITE_GROUP";
  AvailableAction2["LaunchWizard"] = "LAUNCH_WIZARD";
  AvailableAction2["OpenSettings"] = "OPEN_SETTINGS";
  AvailableAction2["OpenXtm"] = "OPEN_XTM";
  AvailableAction2["ReportProfile"] = "REPORT_PROFILE";
  AvailableAction2["SendMessage"] = "SEND_MESSAGE";
  AvailableAction2["Share"] = "SHARE";
  AvailableAction2["ShowContactDetails"] = "SHOW_CONTACT_DETAILS";
  AvailableAction2["UnblockUser"] = "UNBLOCK_USER";
  AvailableAction2["UnbookmarkUser"] = "UNBOOKMARK_USER";
  AvailableAction2["Unfollow"] = "UNFOLLOW";
  AvailableAction2["MyCareerWishes"] = "MY_CAREER_WISHES";
  AvailableAction2["ShowCareerWishes"] = "SHOW_CAREER_WISHES";
  AvailableAction2["Print"] = "PRINT";
  AvailableAction2["OpenInsiderCollection"] = "OPEN_INSIDER_COLLECTION";
  AvailableAction2["OpenLoPreview"] = "OPEN_LO_PREVIEW";
  return AvailableAction2;
})(AvailableAction || {});
var BpayPaymentMethodTypeInput = /* @__PURE__ */ ((BpayPaymentMethodTypeInput2) => {
  BpayPaymentMethodTypeInput2["Invoice"] = "INVOICE";
  BpayPaymentMethodTypeInput2["Sepa"] = "SEPA";
  return BpayPaymentMethodTypeInput2;
})(BpayPaymentMethodTypeInput || {});
var BriefingCandidateClientStatus = /* @__PURE__ */ ((BriefingCandidateClientStatus2) => {
  BriefingCandidateClientStatus2["Contacted"] = "CONTACTED";
  BriefingCandidateClientStatus2["NotContacted"] = "NOT_CONTACTED";
  BriefingCandidateClientStatus2["Interested"] = "INTERESTED";
  BriefingCandidateClientStatus2["Uninterested"] = "UNINTERESTED";
  BriefingCandidateClientStatus2["Rejected"] = "REJECTED";
  return BriefingCandidateClientStatus2;
})(BriefingCandidateClientStatus || {});
var ClickReasonsEnum = /* @__PURE__ */ ((ClickReasonsEnum2) => {
  ClickReasonsEnum2["MatchSearch"] = "MATCH_SEARCH";
  ClickReasonsEnum2["MatchTestimonial"] = "MATCH_TESTIMONIAL";
  ClickReasonsEnum2["MatchContactlist"] = "MATCH_CONTACTLIST";
  ClickReasonsEnum2["MatchRandomFoaf"] = "MATCH_RANDOM_FOAF";
  ClickReasonsEnum2["MatchLatest"] = "MATCH_LATEST";
  ClickReasonsEnum2["MatchLoggedin"] = "MATCH_LOGGEDIN";
  ClickReasonsEnum2["MatchVisitedmycp"] = "MATCH_VISITEDMYCP";
  ClickReasonsEnum2["MatchRandom"] = "MATCH_RANDOM";
  ClickReasonsEnum2["MatchNearby"] = "MATCH_NEARBY";
  ClickReasonsEnum2["MatchMessages"] = "MATCH_MESSAGES";
  ClickReasonsEnum2["MatchFriendpath"] = "MATCH_FRIENDPATH";
  ClickReasonsEnum2["MatchContactlistOf"] = "MATCH_CONTACTLIST_OF";
  ClickReasonsEnum2["MatchGuestbookOf"] = "MATCH_GUESTBOOK_OF";
  ClickReasonsEnum2["MatchWeeklyStats"] = "MATCH_WEEKLY_STATS";
  ClickReasonsEnum2["MatchContactRecommendation"] = "MATCH_CONTACT_RECOMMENDATION";
  ClickReasonsEnum2["MatchInvitation"] = "MATCH_INVITATION";
  ClickReasonsEnum2["MatchNetworkModerator"] = "MATCH_NETWORK_MODERATOR";
  ClickReasonsEnum2["MatchNetworkMember"] = "MATCH_NETWORK_MEMBER";
  ClickReasonsEnum2["MatchNetworkArticleAuthor"] = "MATCH_NETWORK_ARTICLE_AUTHOR";
  ClickReasonsEnum2["MatchOutlookComparison"] = "MATCH_OUTLOOK_COMPARISON";
  ClickReasonsEnum2["MatchBirthday"] = "MATCH_BIRTHDAY";
  ClickReasonsEnum2["MatchRandomHomepage"] = "MATCH_RANDOM_HOMEPAGE";
  ClickReasonsEnum2["MatchFoaflist"] = "MATCH_FOAFLIST";
  ClickReasonsEnum2["MatchVisitedcp"] = "MATCH_VISITEDCP";
  ClickReasonsEnum2["MatchSuggestionmail"] = "MATCH_SUGGESTIONMAIL";
  ClickReasonsEnum2["MatchVisitedcompanymatcher"] = "MATCH_VISITEDCOMPANYMATCHER";
  ClickReasonsEnum2["MatchVisitedorgamatcher"] = "MATCH_VISITEDORGAMATCHER";
  ClickReasonsEnum2["MatchVisitededumatcher"] = "MATCH_VISITEDEDUMATCHER";
  ClickReasonsEnum2["MatchCompanyUrl"] = "MATCH_COMPANY_URL";
  ClickReasonsEnum2["MatchExcompanyUrl"] = "MATCH_EXCOMPANY_URL";
  ClickReasonsEnum2["MatchHomepage"] = "MATCH_HOMEPAGE";
  ClickReasonsEnum2["MatchHavesWantsMatcher"] = "MATCH_HAVES_WANTS_MATCHER";
  ClickReasonsEnum2["MatchWantsHavesMatcher"] = "MATCH_WANTS_HAVES_MATCHER";
  ClickReasonsEnum2["MatchKnownUsers"] = "MATCH_KNOWN_USERS";
  ClickReasonsEnum2["MatchChangedContacts"] = "MATCH_CHANGED_CONTACTS";
  ClickReasonsEnum2["MatchPassedBirthday"] = "MATCH_PASSED_BIRTHDAY";
  ClickReasonsEnum2["MatchMarketplace"] = "MATCH_MARKETPLACE";
  ClickReasonsEnum2["MatchSuccessStory"] = "MATCH_SUCCESS_STORY";
  ClickReasonsEnum2["MatchGroupsOfContacts"] = "MATCH_GROUPS_OF_CONTACTS";
  ClickReasonsEnum2["MatchFriendshipStory"] = "MATCH_FRIENDSHIP_STORY";
  ClickReasonsEnum2["MatchSameGroups"] = "MATCH_SAME_GROUPS";
  ClickReasonsEnum2["MatchEventsGuestlist"] = "MATCH_EVENTS_GUESTLIST";
  ClickReasonsEnum2["MatchEventsMyContactsGoTo"] = "MATCH_EVENTS_MY_CONTACTS_GO_TO";
  ClickReasonsEnum2["MatchEventsSearchResults"] = "MATCH_EVENTS_SEARCH_RESULTS";
  ClickReasonsEnum2["MatchEventPage"] = "MATCH_EVENT_PAGE";
  ClickReasonsEnum2["MatchMembersYouMayKnow"] = "MATCH_MEMBERS_YOU_MAY_KNOW";
  ClickReasonsEnum2["MatchCompanyProfile"] = "MATCH_COMPANY_PROFILE";
  ClickReasonsEnum2["MatchCompanyProfileFriendpath"] = "MATCH_COMPANY_PROFILE_FRIENDPATH";
  ClickReasonsEnum2["MatchMembersAlsoVisited"] = "MATCH_MEMBERS_ALSO_VISITED";
  ClickReasonsEnum2["MatchCompanyProfileUpdateLiker"] = "MATCH_COMPANY_PROFILE_UPDATE_LIKER";
  ClickReasonsEnum2["MatchCompanyProfileFollower"] = "MATCH_COMPANY_PROFILE_FOLLOWER";
  ClickReasonsEnum2["MatchOutlookConnector"] = "MATCH_OUTLOOK_CONNECTOR";
  ClickReasonsEnum2["MatchXingBrowserToolbar"] = "MATCH_XING_BROWSER_TOOLBAR";
  ClickReasonsEnum2["MatchJobsMatching"] = "MATCH_JOBS_MATCHING";
  ClickReasonsEnum2["MatchActivityboxContactlist"] = "MATCH_ACTIVITYBOX_CONTACTLIST";
  ClickReasonsEnum2["MatchActivityboxMessages"] = "MATCH_ACTIVITYBOX_MESSAGES";
  ClickReasonsEnum2["MatchActivityboxEvents"] = "MATCH_ACTIVITYBOX_EVENTS";
  ClickReasonsEnum2["MatchActivityboxNewsletters"] = "MATCH_ACTIVITYBOX_NEWSLETTERS";
  ClickReasonsEnum2["MatchKnowInCompany"] = "MATCH_KNOW_IN_COMPANY";
  ClickReasonsEnum2["MatchAppMobile"] = "MATCH_APP_MOBILE";
  ClickReasonsEnum2["MatchAppDesktop"] = "MATCH_APP_DESKTOP";
  ClickReasonsEnum2["MatchAppWidget"] = "MATCH_APP_WIDGET";
  ClickReasonsEnum2["MatchJobSearch"] = "MATCH_JOB_SEARCH";
  ClickReasonsEnum2["MatchGroupSearch"] = "MATCH_GROUP_SEARCH";
  ClickReasonsEnum2["MatchEventSearch"] = "MATCH_EVENT_SEARCH";
  ClickReasonsEnum2["MatchNetworkOverviewAuthor"] = "MATCH_NETWORK_OVERVIEW_AUTHOR";
  ClickReasonsEnum2["MatchNetworkStartpageAuthor"] = "MATCH_NETWORK_STARTPAGE_AUTHOR";
  ClickReasonsEnum2["MatchProfileOf"] = "MATCH_PROFILE_OF";
  ClickReasonsEnum2["MatchTopicsStartpage"] = "MATCH_TOPICS_STARTPAGE";
  ClickReasonsEnum2["MatchTopicsTopicpage"] = "MATCH_TOPICS_TOPICPAGE";
  ClickReasonsEnum2["MatchTopicsPost"] = "MATCH_TOPICS_POST";
  ClickReasonsEnum2["MatchProjects"] = "MATCH_PROJECTS";
  ClickReasonsEnum2["MatchPoll"] = "MATCH_POLL";
  ClickReasonsEnum2["MatchSameIndustry"] = "MATCH_SAME_INDUSTRY";
  ClickReasonsEnum2["MatchSameInterests"] = "MATCH_SAME_INTERESTS";
  ClickReasonsEnum2["MatchContactLoggedin"] = "MATCH_CONTACT_LOGGEDIN";
  ClickReasonsEnum2["MatchVisitedMyPortfolio"] = "MATCH_VISITED_MY_PORTFOLIO";
  ClickReasonsEnum2["MatchCurrentColleagues"] = "MATCH_CURRENT_COLLEAGUES";
  ClickReasonsEnum2["MatchSimilarProfiles"] = "MATCH_SIMILAR_PROFILES";
  ClickReasonsEnum2["MatchProfileChangeJobTitle"] = "MATCH_PROFILE_CHANGE_JOB_TITLE";
  ClickReasonsEnum2["MatchProfileChangeCompany"] = "MATCH_PROFILE_CHANGE_COMPANY";
  ClickReasonsEnum2["MatchProfileChangeAddress"] = "MATCH_PROFILE_CHANGE_ADDRESS";
  ClickReasonsEnum2["MatchTalentmanager"] = "MATCH_TALENTMANAGER";
  ClickReasonsEnum2["MatchLinkRecommended"] = "MATCH_LINK_RECOMMENDED";
  ClickReasonsEnum2["MatchCommunitiesMembersList"] = "MATCH_COMMUNITIES_MEMBERS_LIST";
  ClickReasonsEnum2["MatchCommunitiesPost"] = "MATCH_COMMUNITIES_POST";
  ClickReasonsEnum2["MatchCommunitiesPostLiker"] = "MATCH_COMMUNITIES_POST_LIKER";
  ClickReasonsEnum2["MatchCommunitiesPostComment"] = "MATCH_COMMUNITIES_POST_COMMENT";
  ClickReasonsEnum2["MatchCommunitiesPostCommentLiker"] = "MATCH_COMMUNITIES_POST_COMMENT_LIKER";
  ClickReasonsEnum2["MatchFuturemeProfession"] = "MATCH_FUTUREME_PROFESSION";
  ClickReasonsEnum2["MatchXasAd"] = "MATCH_XAS_AD";
  ClickReasonsEnum2["MatchIncrementalSearchList"] = "MATCH_INCREMENTAL_SEARCH_LIST";
  ClickReasonsEnum2["MatchContent"] = "MATCH_CONTENT";
  ClickReasonsEnum2["MatchEventsMobileApp"] = "MATCH_EVENTS_MOBILE_APP";
  ClickReasonsEnum2["MatchReferences"] = "MATCH_REFERENCES";
  ClickReasonsEnum2["MatchSameName"] = "MATCH_SAME_NAME";
  ClickReasonsEnum2["MatchContentKlartext"] = "MATCH_CONTENT_KLARTEXT";
  ClickReasonsEnum2["MatchBiggerSearchTopHave"] = "MATCH_BIGGER_SEARCH_TOP_HAVE";
  ClickReasonsEnum2["MatchCommunitiesClassified"] = "MATCH_COMMUNITIES_CLASSIFIED";
  ClickReasonsEnum2["MatchCommunitiesClassifiedLiker"] = "MATCH_COMMUNITIES_CLASSIFIED_LIKER";
  ClickReasonsEnum2["MatchCommunitiesClassifiedComment"] = "MATCH_COMMUNITIES_CLASSIFIED_COMMENT";
  ClickReasonsEnum2["MatchCommunitiesClassifiedCommentLiker"] = "MATCH_COMMUNITIES_CLASSIFIED_COMMENT_LIKER";
  ClickReasonsEnum2["MatchCommunitiesGroupInvitation"] = "MATCH_COMMUNITIES_GROUP_INVITATION";
  ClickReasonsEnum2["MatchXbpVombpList"] = "MATCH_XBP_VOMBP_LIST";
  ClickReasonsEnum2["MatchXbpContactPersonModule"] = "MATCH_XBP_CONTACT_PERSON_MODULE";
  ClickReasonsEnum2["MatchEmails"] = "MATCH_EMAILS";
  ClickReasonsEnum2["MatchMyprojobsRecruiterClick"] = "MATCH_MYPROJOBS_RECRUITER_CLICK";
  ClickReasonsEnum2["MatchContentInsiderFollowersClick"] = "MATCH_CONTENT_INSIDER_FOLLOWERS_CLICK";
  ClickReasonsEnum2["MatchContentInsiderClick"] = "MATCH_CONTENT_INSIDER_CLICK";
  ClickReasonsEnum2["MatchContentArticleInteractionClick"] = "MATCH_CONTENT_ARTICLE_INTERACTION_CLICK";
  ClickReasonsEnum2["MatchProjobsProfileClickInXtm"] = "MATCH_PROJOBS_PROFILE_CLICK_IN_XTM";
  ClickReasonsEnum2["MatchOutlookAddinReadProfileClick"] = "MATCH_OUTLOOK_ADDIN_READ_PROFILE_CLICK";
  ClickReasonsEnum2["CrUnkown"] = "CR_UNKOWN";
  ClickReasonsEnum2["CrWebStory"] = "CR_WEB_STORY";
  ClickReasonsEnum2["CrWebStoryMentioning"] = "CR_WEB_STORY_MENTIONING";
  ClickReasonsEnum2["CrWebConversationStarter"] = "CR_WEB_CONVERSATION_STARTER";
  ClickReasonsEnum2["CrWebContactRequestReceived"] = "CR_WEB_CONTACT_REQUEST_RECEIVED";
  ClickReasonsEnum2["CrWebContactRequestSent"] = "CR_WEB_CONTACT_REQUEST_SENT";
  ClickReasonsEnum2["CrWebOwnContactList"] = "CR_WEB_OWN_CONTACT_LIST";
  ClickReasonsEnum2["CrWebBirthdayList"] = "CR_WEB_BIRTHDAY_LIST";
  ClickReasonsEnum2["CrWebAroundYouList"] = "CR_WEB_AROUND_YOU_LIST";
  ClickReasonsEnum2["CrWebMymkContacts"] = "CR_WEB_MYMK_CONTACTS";
  ClickReasonsEnum2["CrWebMymk"] = "CR_WEB_MYMK";
  ClickReasonsEnum2["CrWebNetworkHomeMessage"] = "CR_WEB_NETWORK_HOME_MESSAGE";
  ClickReasonsEnum2["CrWebChatview"] = "CR_WEB_CHATVIEW";
  ClickReasonsEnum2["CrWebMessenger"] = "CR_WEB_MESSENGER";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherPostComment"] = "CR_WEB_NETUPDT_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherJobPostComment"] = "CR_WEB_NETUPDT_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherEventPostComment"] = "CR_WEB_NETUPDT_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherArticlePostComment"] = "CR_WEB_NETUPDT_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnPostComment"] = "CR_WEB_NETUPDT_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnJobPostComment"] = "CR_WEB_NETUPDT_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnEventPostComment"] = "CR_WEB_NETUPDT_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnArticlePostComment"] = "CR_WEB_NETUPDT_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherPostLike"] = "CR_WEB_NETUPDT_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherJobPostLike"] = "CR_WEB_NETUPDT_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherEventPostLike"] = "CR_WEB_NETUPDT_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrWebNetupdtDiscoOtherArticlePostLike"] = "CR_WEB_NETUPDT_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrWebNetupdtDiscoPostShared"] = "CR_WEB_NETUPDT_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrWebNetupdtDiscoJobPostShared"] = "CR_WEB_NETUPDT_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrWebNetupdtDiscoEventPostShared"] = "CR_WEB_NETUPDT_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrWebNetupdtDiscoEventArticleShared"] = "CR_WEB_NETUPDT_DISCO_EVENT_ARTICLE_SHARED";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnPost"] = "CR_WEB_NETUPDT_DISCO_OWN_POST";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnJobPost"] = "CR_WEB_NETUPDT_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnEventPost"] = "CR_WEB_NETUPDT_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrWebNetupdtDiscoOwnArticlePost"] = "CR_WEB_NETUPDT_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrWebNetupdtDiscoFollowing"] = "CR_WEB_NETUPDT_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrWebNetupdtDiscoProfileUpdate"] = "CR_WEB_NETUPDT_DISCO_PROFILE_UPDATE";
  ClickReasonsEnum2["CrWebNetupdtDiscoProfilePictUpdate"] = "CR_WEB_NETUPDT_DISCO_PROFILE_PICT_UPDATE";
  ClickReasonsEnum2["CrWebNetupdtDiscoBusinessCardUpdate"] = "CR_WEB_NETUPDT_DISCO_BUSINESS_CARD_UPDATE";
  ClickReasonsEnum2["CrWebNetupdtDiscoPersonalUpdate"] = "CR_WEB_NETUPDT_DISCO_PERSONAL_UPDATE";
  ClickReasonsEnum2["CrWebNetupdtDiscoWorkExpUpdate"] = "CR_WEB_NETUPDT_DISCO_WORK_EXP_UPDATE";
  ClickReasonsEnum2["CrWebNetupdtDiscoHeaderImgUpdate"] = "CR_WEB_NETUPDT_DISCO_HEADER_IMG_UPDATE";
  ClickReasonsEnum2["CrWebNetupdtDiscoContactReco"] = "CR_WEB_NETUPDT_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrWebNetupdtDiscoNewContactUpdate"] = "CR_WEB_NETUPDT_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrWebNetupdtDiscoSharedContacts"] = "CR_WEB_NETUPDT_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrWebNetupdtDiscoInterestingJobs"] = "CR_WEB_NETUPDT_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrWebNetupdtDiscoAnniversary"] = "CR_WEB_NETUPDT_DISCO_ANNIVERSARY";
  ClickReasonsEnum2["CrWebNetupdtDiscoGroupCreation"] = "CR_WEB_NETUPDT_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrWebNetupdtDiscoGroupJoined"] = "CR_WEB_NETUPDT_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrWebNetupdtDiscoEventCreation"] = "CR_WEB_NETUPDT_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrWebNetupdtDiscoEventAttending"] = "CR_WEB_NETUPDT_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrWebExploreDiscoOtherPostComment"] = "CR_WEB_EXPLORE_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOtherJobPostComment"] = "CR_WEB_EXPLORE_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOtherEventPostComment"] = "CR_WEB_EXPLORE_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOtherArticlePostComment"] = "CR_WEB_EXPLORE_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOwnPostComment"] = "CR_WEB_EXPLORE_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOwnJobPostComment"] = "CR_WEB_EXPLORE_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOwnEventPostComment"] = "CR_WEB_EXPLORE_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOwnArticlePostComment"] = "CR_WEB_EXPLORE_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrWebExploreDiscoOtherPostLike"] = "CR_WEB_EXPLORE_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrWebExploreDiscoOtherJobPostLike"] = "CR_WEB_EXPLORE_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrWebExploreDiscoOtherEventPostLike"] = "CR_WEB_EXPLORE_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrWebExploreDiscoOtherArticlePostLike"] = "CR_WEB_EXPLORE_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrWebExploreDiscoPostShared"] = "CR_WEB_EXPLORE_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrWebExploreDiscoJobPostShared"] = "CR_WEB_EXPLORE_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrWebExploreDiscoEventPostShared"] = "CR_WEB_EXPLORE_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrWebExploreDiscoArticlePostShared"] = "CR_WEB_EXPLORE_DISCO_ARTICLE_POST_SHARED";
  ClickReasonsEnum2["CrWebExploreDiscoOwnPost"] = "CR_WEB_EXPLORE_DISCO_OWN_POST";
  ClickReasonsEnum2["CrWebExploreDiscoOwnJobPost"] = "CR_WEB_EXPLORE_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrWebExploreDiscoOwnEventPost"] = "CR_WEB_EXPLORE_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrWebExploreDiscoOwnArticlePost"] = "CR_WEB_EXPLORE_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrWebExploreDiscoFollowing"] = "CR_WEB_EXPLORE_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrWebExploreDiscoProfileUpdate"] = "CR_WEB_EXPLORE_DISCO_PROFILE_UPDATE";
  ClickReasonsEnum2["CrWebExploreDiscoProfilePictUpdate"] = "CR_WEB_EXPLORE_DISCO_PROFILE_PICT_UPDATE";
  ClickReasonsEnum2["CrWebExploreDiscoBusinessCardUpdate"] = "CR_WEB_EXPLORE_DISCO_BUSINESS_CARD_UPDATE";
  ClickReasonsEnum2["CrWebExploreDiscoPersonalUpdate"] = "CR_WEB_EXPLORE_DISCO_PERSONAL_UPDATE";
  ClickReasonsEnum2["CrWebExploreDiscoWorkExpUpdate"] = "CR_WEB_EXPLORE_DISCO_WORK_EXP_UPDATE";
  ClickReasonsEnum2["CrWebExploreDiscoHeaderImageUpdate"] = "CR_WEB_EXPLORE_DISCO_HEADER_IMAGE_UPDATE";
  ClickReasonsEnum2["CrWebExploreDiscoContactReco"] = "CR_WEB_EXPLORE_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrWebExploreDiscoNewContactUpdate"] = "CR_WEB_EXPLORE_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrWebExploreDiscoSharedContacts"] = "CR_WEB_EXPLORE_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrWebExploreDiscoInterestingJobs"] = "CR_WEB_EXPLORE_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrWebExploreDiscoAnniversary"] = "CR_WEB_EXPLORE_DISCO_ANNIVERSARY";
  ClickReasonsEnum2["CrWebExploreDiscoGroupCreation"] = "CR_WEB_EXPLORE_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrWebExploreDiscoGroupJoined"] = "CR_WEB_EXPLORE_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrWebExploreDiscoEventCreation"] = "CR_WEB_EXPLORE_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrWebExploreDiscoEventAttending"] = "CR_WEB_EXPLORE_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrWebEntitypageDiscoCompanyPage"] = "CR_WEB_ENTITYPAGE_DISCO_COMPANY_PAGE";
  ClickReasonsEnum2["CrWebDiscoSearch"] = "CR_WEB_DISCO_SEARCH";
  ClickReasonsEnum2["CrWebDiscoMemberSearch"] = "CR_WEB_DISCO_MEMBER_SEARCH";
  ClickReasonsEnum2["CrWebTopicDiscoChannelFollowing"] = "CR_WEB_TOPIC_DISCO_CHANNEL_FOLLOWING";
  ClickReasonsEnum2["CrWebTopicDiscoOtherPostComment"] = "CR_WEB_TOPIC_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOtherJobPostComment"] = "CR_WEB_TOPIC_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOtherEventPostComment"] = "CR_WEB_TOPIC_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOtherArticlePostComment"] = "CR_WEB_TOPIC_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOwnPostComment"] = "CR_WEB_TOPIC_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOwnJobPostComment"] = "CR_WEB_TOPIC_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOwnEventPostComment"] = "CR_WEB_TOPIC_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOwnArticlePostComment"] = "CR_WEB_TOPIC_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrWebTopicDiscoOtherPostLike"] = "CR_WEB_TOPIC_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrWebTopicDiscoOtherJobPostLike"] = "CR_WEB_TOPIC_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrWebTopicDiscoOtherEventPostLike"] = "CR_WEB_TOPIC_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrWebTopicDiscoOtherArticlePostLike"] = "CR_WEB_TOPIC_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrWebTopicDiscoPostShared"] = "CR_WEB_TOPIC_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrWebTopicDiscoJobPostShared"] = "CR_WEB_TOPIC_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrWebTopicDiscoEventPostShared"] = "CR_WEB_TOPIC_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrWebTopicDiscoArticlePostShared"] = "CR_WEB_TOPIC_DISCO_ARTICLE_POST_SHARED";
  ClickReasonsEnum2["CrWebTopicDiscoOwnPost"] = "CR_WEB_TOPIC_DISCO_OWN_POST";
  ClickReasonsEnum2["CrWebTopicDiscoOwnJobPost"] = "CR_WEB_TOPIC_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrWebTopicDiscoOwnEventPost"] = "CR_WEB_TOPIC_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrWebTopicDiscoOwnArticlePost"] = "CR_WEB_TOPIC_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrWebTopicDiscoFollowing"] = "CR_WEB_TOPIC_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrWebTopicDiscoContactReco"] = "CR_WEB_TOPIC_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrWebTopicDiscoNewContactUpdate"] = "CR_WEB_TOPIC_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrWebTopicDiscoSharedContacts"] = "CR_WEB_TOPIC_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrWebTopicDiscoInterestingJobs"] = "CR_WEB_TOPIC_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrWebTopicDiscoGroupCreation"] = "CR_WEB_TOPIC_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrWebTopicDiscoGroupJoined"] = "CR_WEB_TOPIC_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrWebTopicDiscoEventCreation"] = "CR_WEB_TOPIC_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrWebTopicDiscoEventAttending"] = "CR_WEB_TOPIC_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrWebMehubVomp"] = "CR_WEB_MEHUB_VOMP";
  ClickReasonsEnum2["CrWebMehubContactsList"] = "CR_WEB_MEHUB_CONTACTS_LIST";
  ClickReasonsEnum2["CrWebVompPage"] = "CR_WEB_VOMP_PAGE";
  ClickReasonsEnum2["CrWebVompPageCommonContacts"] = "CR_WEB_VOMP_PAGE_COMMON_CONTACTS";
  ClickReasonsEnum2["CrWebJobsCompanyContacts"] = "CR_WEB_JOBS_COMPANY_CONTACTS";
  ClickReasonsEnum2["CrWebJobsCompanyContactsContact"] = "CR_WEB_JOBS_COMPANY_CONTACTS_CONTACT";
  ClickReasonsEnum2["CrWebJobsCompanyContactsCommonContact"] = "CR_WEB_JOBS_COMPANY_CONTACTS_COMMON_CONTACT";
  ClickReasonsEnum2["CrWebEventsGuestList"] = "CR_WEB_EVENTS_GUEST_LIST";
  ClickReasonsEnum2["CrWebEventsOrganizer"] = "CR_WEB_EVENTS_ORGANIZER";
  ClickReasonsEnum2["CrWebEventsContactPerson"] = "CR_WEB_EVENTS_CONTACT_PERSON";
  ClickReasonsEnum2["CrWebEventsSpeaker"] = "CR_WEB_EVENTS_SPEAKER";
  ClickReasonsEnum2["CrWebEventsComment"] = "CR_WEB_EVENTS_COMMENT";
  ClickReasonsEnum2["CrWebNewsComment"] = "CR_WEB_NEWS_COMMENT";
  ClickReasonsEnum2["CrWebNewsLike"] = "CR_WEB_NEWS_LIKE";
  ClickReasonsEnum2["CrWebNewsAuthor"] = "CR_WEB_NEWS_AUTHOR";
  ClickReasonsEnum2["CrWebNewsAuthorFollowers"] = "CR_WEB_NEWS_AUTHOR_FOLLOWERS";
  ClickReasonsEnum2["CrWebNewsFollowers"] = "CR_WEB_NEWS_FOLLOWERS";
  ClickReasonsEnum2["CrWebKlartextComment"] = "CR_WEB_KLARTEXT_COMMENT";
  ClickReasonsEnum2["CrWebKlartextCommentLike"] = "CR_WEB_KLARTEXT_COMMENT_LIKE";
  ClickReasonsEnum2["CrWebKlartextApprovedList"] = "CR_WEB_KLARTEXT_APPROVED_LIST";
  ClickReasonsEnum2["CrWebKlartextAuthor"] = "CR_WEB_KLARTEXT_AUTHOR";
  ClickReasonsEnum2["CrWebGroupsMembersList"] = "CR_WEB_GROUPS_MEMBERS_LIST";
  ClickReasonsEnum2["CrWebGroupsDiscussions"] = "CR_WEB_GROUPS_DISCUSSIONS";
  ClickReasonsEnum2["CrWebCompaniesEmployeeList"] = "CR_WEB_COMPANIES_EMPLOYEE_LIST";
  ClickReasonsEnum2["CrWebCompaniesFollowersList"] = "CR_WEB_COMPANIES_FOLLOWERS_LIST";
  ClickReasonsEnum2["CrWebCompaniesContacts"] = "CR_WEB_COMPANIES_CONTACTS";
  ClickReasonsEnum2["CrWebProfileContactsList"] = "CR_WEB_PROFILE_CONTACTS_LIST";
  ClickReasonsEnum2["CrWebProfileSharedContacts"] = "CR_WEB_PROFILE_SHARED_CONTACTS";
  ClickReasonsEnum2["CrWebOnboardingContactsReco"] = "CR_WEB_ONBOARDING_CONTACTS_RECO";
  ClickReasonsEnum2["CrWebUpboardingContactsReco"] = "CR_WEB_UPBOARDING_CONTACTS_RECO";
  ClickReasonsEnum2["CrWebTalentManager"] = "CR_WEB_TALENT_MANAGER";
  ClickReasonsEnum2["CrWebProjobsRecruiterReco"] = "CR_WEB_PROJOBS_RECRUITER_RECO";
  ClickReasonsEnum2["CrWebProjobsVomp"] = "CR_WEB_PROJOBS_VOMP";
  ClickReasonsEnum2["CrWebProjobs"] = "CR_WEB_PROJOBS";
  ClickReasonsEnum2["CrWebProbusinessContacts"] = "CR_WEB_PROBUSINESS_CONTACTS";
  ClickReasonsEnum2["CrWebProbusinessSearch"] = "CR_WEB_PROBUSINESS_SEARCH";
  ClickReasonsEnum2["CrWebProbusinessAdvancedSearch"] = "CR_WEB_PROBUSINESS_ADVANCED_SEARCH";
  ClickReasonsEnum2["CrWebTalentService"] = "CR_WEB_TALENT_SERVICE";
  ClickReasonsEnum2["CrWebJobsFutureColleaguesModule"] = "CR_WEB_JOBS_FUTURE_COLLEAGUES_MODULE";
  ClickReasonsEnum2["CrWebJobsFutureColleaguesList"] = "CR_WEB_JOBS_FUTURE_COLLEAGUES_LIST";
  ClickReasonsEnum2["CrWebEventsLikes"] = "CR_WEB_EVENTS_LIKES";
  ClickReasonsEnum2["CrWebPublisherSocialProofHeader"] = "CR_WEB_PUBLISHER_SOCIAL_PROOF_HEADER";
  ClickReasonsEnum2["CrWebPublisherEmployeesModule"] = "CR_WEB_PUBLISHER_EMPLOYEES_MODULE";
  ClickReasonsEnum2["CrWebPublisherEventsModule"] = "CR_WEB_PUBLISHER_EVENTS_MODULE";
  ClickReasonsEnum2["CrWebPublisherContactsModule"] = "CR_WEB_PUBLISHER_CONTACTS_MODULE";
  ClickReasonsEnum2["CrWebPublisherComments"] = "CR_WEB_PUBLISHER_COMMENTS";
  ClickReasonsEnum2["CrWebPublisherLikesComment"] = "CR_WEB_PUBLISHER_LIKES_COMMENT";
  ClickReasonsEnum2["CrWebPublisherLikesPost"] = "CR_WEB_PUBLISHER_LIKES_POST";
  ClickReasonsEnum2["CrWebGroupsSocialProofHeaderMembers"] = "CR_WEB_GROUPS_SOCIAL_PROOF_HEADER_MEMBERS";
  ClickReasonsEnum2["CrWebGroupsModerators"] = "CR_WEB_GROUPS_MODERATORS";
  ClickReasonsEnum2["CrWebCompaniesCompanyContactList"] = "CR_WEB_COMPANIES_COMPANY_CONTACT_LIST";
  ClickReasonsEnum2["CrWebSocialMentionComment"] = "CR_WEB_SOCIAL_MENTION_COMMENT";
  ClickReasonsEnum2["CrWebSocialMentionPost"] = "CR_WEB_SOCIAL_MENTION_POST";
  ClickReasonsEnum2["CrAndroidStory"] = "CR_ANDROID_STORY";
  ClickReasonsEnum2["CrAndroidStoryMentioning"] = "CR_ANDROID_STORY_MENTIONING";
  ClickReasonsEnum2["CrAndroidConversationStarter"] = "CR_ANDROID_CONVERSATION_STARTER";
  ClickReasonsEnum2["CrAndroidContactRequestReceived"] = "CR_ANDROID_CONTACT_REQUEST_RECEIVED";
  ClickReasonsEnum2["CrAndroidContactRequestSent"] = "CR_ANDROID_CONTACT_REQUEST_SENT";
  ClickReasonsEnum2["CrAndroidOwnContactList"] = "CR_ANDROID_OWN_CONTACT_LIST";
  ClickReasonsEnum2["CrAndroidBirthdayList"] = "CR_ANDROID_BIRTHDAY_LIST";
  ClickReasonsEnum2["CrAndroidAroundYouList"] = "CR_ANDROID_AROUND_YOU_LIST";
  ClickReasonsEnum2["CrAndroidMymkContacts"] = "CR_ANDROID_MYMK_CONTACTS";
  ClickReasonsEnum2["CrAndroidMymk"] = "CR_ANDROID_MYMK";
  ClickReasonsEnum2["CrAndroidNetworkHomeMessage"] = "CR_ANDROID_NETWORK_HOME_MESSAGE";
  ClickReasonsEnum2["CrAndroidChatview"] = "CR_ANDROID_CHATVIEW";
  ClickReasonsEnum2["CrAndroidMessenger"] = "CR_ANDROID_MESSENGER";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherPostComment"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherJobPostComment"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherEventPostComment"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherArticlePostComment"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnPostComment"] = "CR_ANDROID_NETUPDT_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnJobPostComment"] = "CR_ANDROID_NETUPDT_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnEventPostComment"] = "CR_ANDROID_NETUPDT_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnArticlePostComment"] = "CR_ANDROID_NETUPDT_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherPostLike"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherJobPostLike"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherEventPostLike"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOtherArticlePostLike"] = "CR_ANDROID_NETUPDT_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoPostShared"] = "CR_ANDROID_NETUPDT_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoJobPostShared"] = "CR_ANDROID_NETUPDT_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoEventPostShared"] = "CR_ANDROID_NETUPDT_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoEventArticleShared"] = "CR_ANDROID_NETUPDT_DISCO_EVENT_ARTICLE_SHARED";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnPost"] = "CR_ANDROID_NETUPDT_DISCO_OWN_POST";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnJobPost"] = "CR_ANDROID_NETUPDT_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnEventPost"] = "CR_ANDROID_NETUPDT_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoOwnArticlePost"] = "CR_ANDROID_NETUPDT_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoFollowing"] = "CR_ANDROID_NETUPDT_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoProfileUpdate"] = "CR_ANDROID_NETUPDT_DISCO_PROFILE_UPDATE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoProfilePictUpdate"] = "CR_ANDROID_NETUPDT_DISCO_PROFILE_PICT_UPDATE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoBusinessCardUpdate"] = "CR_ANDROID_NETUPDT_DISCO_BUSINESS_CARD_UPDATE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoPersonalUpdate"] = "CR_ANDROID_NETUPDT_DISCO_PERSONAL_UPDATE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoWorkExpUpdate"] = "CR_ANDROID_NETUPDT_DISCO_WORK_EXP_UPDATE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoHeaderImgUpdate"] = "CR_ANDROID_NETUPDT_DISCO_HEADER_IMG_UPDATE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoContactReco"] = "CR_ANDROID_NETUPDT_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoNewContactUpdate"] = "CR_ANDROID_NETUPDT_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoSharedContacts"] = "CR_ANDROID_NETUPDT_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoInterestingJobs"] = "CR_ANDROID_NETUPDT_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoAnniversary"] = "CR_ANDROID_NETUPDT_DISCO_ANNIVERSARY";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoGroupCreation"] = "CR_ANDROID_NETUPDT_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoGroupJoined"] = "CR_ANDROID_NETUPDT_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoEventCreation"] = "CR_ANDROID_NETUPDT_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrAndroidNetupdtDiscoEventAttending"] = "CR_ANDROID_NETUPDT_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherPostComment"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherJobPostComment"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherEventPostComment"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherArticlePostComment"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnPostComment"] = "CR_ANDROID_EXPLORE_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnJobPostComment"] = "CR_ANDROID_EXPLORE_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnEventPostComment"] = "CR_ANDROID_EXPLORE_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnArticlePostComment"] = "CR_ANDROID_EXPLORE_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherPostLike"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherJobPostLike"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherEventPostLike"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrAndroidExploreDiscoOtherArticlePostLike"] = "CR_ANDROID_EXPLORE_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrAndroidExploreDiscoPostShared"] = "CR_ANDROID_EXPLORE_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrAndroidExploreDiscoJobPostShared"] = "CR_ANDROID_EXPLORE_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrAndroidExploreDiscoEventPostShared"] = "CR_ANDROID_EXPLORE_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrAndroidExploreDiscoArticlePostShared"] = "CR_ANDROID_EXPLORE_DISCO_ARTICLE_POST_SHARED";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnPost"] = "CR_ANDROID_EXPLORE_DISCO_OWN_POST";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnJobPost"] = "CR_ANDROID_EXPLORE_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnEventPost"] = "CR_ANDROID_EXPLORE_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrAndroidExploreDiscoOwnArticlePost"] = "CR_ANDROID_EXPLORE_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrAndroidExploreDiscoFollowing"] = "CR_ANDROID_EXPLORE_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrAndroidExploreDiscoProfileUpdate"] = "CR_ANDROID_EXPLORE_DISCO_PROFILE_UPDATE";
  ClickReasonsEnum2["CrAndroidExploreDiscoProfilePictUpdate"] = "CR_ANDROID_EXPLORE_DISCO_PROFILE_PICT_UPDATE";
  ClickReasonsEnum2["CrAndroidExploreDiscoBusinessCardUpdate"] = "CR_ANDROID_EXPLORE_DISCO_BUSINESS_CARD_UPDATE";
  ClickReasonsEnum2["CrAndroidExploreDiscoPersonalUpdate"] = "CR_ANDROID_EXPLORE_DISCO_PERSONAL_UPDATE";
  ClickReasonsEnum2["CrAndroidExploreDiscoWorkExpUpdate"] = "CR_ANDROID_EXPLORE_DISCO_WORK_EXP_UPDATE";
  ClickReasonsEnum2["CrAndroidExploreDiscoHeaderImageUpdate"] = "CR_ANDROID_EXPLORE_DISCO_HEADER_IMAGE_UPDATE";
  ClickReasonsEnum2["CrAndroidExploreDiscoContactReco"] = "CR_ANDROID_EXPLORE_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrAndroidExploreDiscoNewContactUpdate"] = "CR_ANDROID_EXPLORE_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrAndroidExploreDiscoSharedContacts"] = "CR_ANDROID_EXPLORE_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrAndroidExploreDiscoInterestingJobs"] = "CR_ANDROID_EXPLORE_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrAndroidExploreDiscoAnniversary"] = "CR_ANDROID_EXPLORE_DISCO_ANNIVERSARY";
  ClickReasonsEnum2["CrAndroidExploreDiscoGroupCreation"] = "CR_ANDROID_EXPLORE_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrAndroidExploreDiscoGroupJoined"] = "CR_ANDROID_EXPLORE_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrAndroidExploreDiscoEventCreation"] = "CR_ANDROID_EXPLORE_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrAndroidExploreDiscoEventAttending"] = "CR_ANDROID_EXPLORE_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrAndroidEntitypageDiscoCompanyPage"] = "CR_ANDROID_ENTITYPAGE_DISCO_COMPANY_PAGE";
  ClickReasonsEnum2["CrAndroidDiscoSearch"] = "CR_ANDROID_DISCO_SEARCH";
  ClickReasonsEnum2["CrAndroidDiscoMemberSearch"] = "CR_ANDROID_DISCO_MEMBER_SEARCH";
  ClickReasonsEnum2["CrAndroidTopicDiscoChannelFollowing"] = "CR_ANDROID_TOPIC_DISCO_CHANNEL_FOLLOWING";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherPostComment"] = "CR_ANDROID_TOPIC_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherJobPostComment"] = "CR_ANDROID_TOPIC_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherEventPostComment"] = "CR_ANDROID_TOPIC_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherArticlePostComment"] = "CR_ANDROID_TOPIC_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnPostComment"] = "CR_ANDROID_TOPIC_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnJobPostComment"] = "CR_ANDROID_TOPIC_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnEventPostComment"] = "CR_ANDROID_TOPIC_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnArticlePostComment"] = "CR_ANDROID_TOPIC_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherPostLike"] = "CR_ANDROID_TOPIC_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherJobPostLike"] = "CR_ANDROID_TOPIC_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherEventPostLike"] = "CR_ANDROID_TOPIC_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrAndroidTopicDiscoOtherArticlePostLike"] = "CR_ANDROID_TOPIC_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrAndroidTopicDiscoPostShared"] = "CR_ANDROID_TOPIC_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrAndroidTopicDiscoJobPostShared"] = "CR_ANDROID_TOPIC_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrAndroidTopicDiscoEventPostShared"] = "CR_ANDROID_TOPIC_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrAndroidTopicDiscoArticlePostShared"] = "CR_ANDROID_TOPIC_DISCO_ARTICLE_POST_SHARED";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnPost"] = "CR_ANDROID_TOPIC_DISCO_OWN_POST";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnJobPost"] = "CR_ANDROID_TOPIC_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnEventPost"] = "CR_ANDROID_TOPIC_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrAndroidTopicDiscoOwnArticlePost"] = "CR_ANDROID_TOPIC_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrAndroidTopicDiscoFollowing"] = "CR_ANDROID_TOPIC_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrAndroidTopicDiscoContactReco"] = "CR_ANDROID_TOPIC_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrAndroidTopicDiscoNewContactUpdate"] = "CR_ANDROID_TOPIC_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrAndroidTopicDiscoSharedContacts"] = "CR_ANDROID_TOPIC_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrAndroidTopicDiscoInterestingJobs"] = "CR_ANDROID_TOPIC_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrAndroidTopicDiscoGroupCreation"] = "CR_ANDROID_TOPIC_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrAndroidTopicDiscoGroupJoined"] = "CR_ANDROID_TOPIC_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrAndroidTopicDiscoEventCreation"] = "CR_ANDROID_TOPIC_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrAndroidTopicDiscoEventAttending"] = "CR_ANDROID_TOPIC_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrAndroidMehubVomp"] = "CR_ANDROID_MEHUB_VOMP";
  ClickReasonsEnum2["CrAndroidMehubContactsList"] = "CR_ANDROID_MEHUB_CONTACTS_LIST";
  ClickReasonsEnum2["CrAndroidVompPage"] = "CR_ANDROID_VOMP_PAGE";
  ClickReasonsEnum2["CrAndroidVompPageCommonContacts"] = "CR_ANDROID_VOMP_PAGE_COMMON_CONTACTS";
  ClickReasonsEnum2["CrAndroidJobsCompanyContacts"] = "CR_ANDROID_JOBS_COMPANY_CONTACTS";
  ClickReasonsEnum2["CrAndroidJobsCompanyContactsContact"] = "CR_ANDROID_JOBS_COMPANY_CONTACTS_CONTACT";
  ClickReasonsEnum2["CrAndroidJobsCompanyContactsCommonContact"] = "CR_ANDROID_JOBS_COMPANY_CONTACTS_COMMON_CONTACT";
  ClickReasonsEnum2["CrAndroidEventsGuestList"] = "CR_ANDROID_EVENTS_GUEST_LIST";
  ClickReasonsEnum2["CrAndroidEventsOrganizer"] = "CR_ANDROID_EVENTS_ORGANIZER";
  ClickReasonsEnum2["CrAndroidEventsContactPerson"] = "CR_ANDROID_EVENTS_CONTACT_PERSON";
  ClickReasonsEnum2["CrAndroidEventsSpeaker"] = "CR_ANDROID_EVENTS_SPEAKER";
  ClickReasonsEnum2["CrAndroidEventsComment"] = "CR_ANDROID_EVENTS_COMMENT";
  ClickReasonsEnum2["CrAndroidNewsComment"] = "CR_ANDROID_NEWS_COMMENT";
  ClickReasonsEnum2["CrAndroidNewsLike"] = "CR_ANDROID_NEWS_LIKE";
  ClickReasonsEnum2["CrAndroidNewsAuthor"] = "CR_ANDROID_NEWS_AUTHOR";
  ClickReasonsEnum2["CrAndroidNewsAuthorFollowers"] = "CR_ANDROID_NEWS_AUTHOR_FOLLOWERS";
  ClickReasonsEnum2["CrAndroidNewsFollowers"] = "CR_ANDROID_NEWS_FOLLOWERS";
  ClickReasonsEnum2["CrAndroidKlartextComment"] = "CR_ANDROID_KLARTEXT_COMMENT";
  ClickReasonsEnum2["CrAndroidKlartextCommentLike"] = "CR_ANDROID_KLARTEXT_COMMENT_LIKE";
  ClickReasonsEnum2["CrAndroidKlartextApprovedList"] = "CR_ANDROID_KLARTEXT_APPROVED_LIST";
  ClickReasonsEnum2["CrAndroidKlartextAuthor"] = "CR_ANDROID_KLARTEXT_AUTHOR";
  ClickReasonsEnum2["CrAndroidGroupsMembersList"] = "CR_ANDROID_GROUPS_MEMBERS_LIST";
  ClickReasonsEnum2["CrAndroidGroupsDiscussions"] = "CR_ANDROID_GROUPS_DISCUSSIONS";
  ClickReasonsEnum2["CrAndroidCompaniesEmployeeList"] = "CR_ANDROID_COMPANIES_EMPLOYEE_LIST";
  ClickReasonsEnum2["CrAndroidCompaniesFollowersList"] = "CR_ANDROID_COMPANIES_FOLLOWERS_LIST";
  ClickReasonsEnum2["CrAndroidCompaniesContacts"] = "CR_ANDROID_COMPANIES_CONTACTS";
  ClickReasonsEnum2["CrAndroidProfileContactsList"] = "CR_ANDROID_PROFILE_CONTACTS_LIST";
  ClickReasonsEnum2["CrAndroidProfileSharedContacts"] = "CR_ANDROID_PROFILE_SHARED_CONTACTS";
  ClickReasonsEnum2["CrAndroidOnboardingContactsReco"] = "CR_ANDROID_ONBOARDING_CONTACTS_RECO";
  ClickReasonsEnum2["CrAndroidUpboardingContactsReco"] = "CR_ANDROID_UPBOARDING_CONTACTS_RECO";
  ClickReasonsEnum2["CrAndroidTalentManager"] = "CR_ANDROID_TALENT_MANAGER";
  ClickReasonsEnum2["CrAndroidProjobsRecruiterReco"] = "CR_ANDROID_PROJOBS_RECRUITER_RECO";
  ClickReasonsEnum2["CrAndroidProjobsVomp"] = "CR_ANDROID_PROJOBS_VOMP";
  ClickReasonsEnum2["CrAndroidProjobs"] = "CR_ANDROID_PROJOBS";
  ClickReasonsEnum2["CrAndroidProbusinessContacts"] = "CR_ANDROID_PROBUSINESS_CONTACTS";
  ClickReasonsEnum2["CrAndroidProbusinessSearch"] = "CR_ANDROID_PROBUSINESS_SEARCH";
  ClickReasonsEnum2["CrAndroidProbusinessAdvancedSearch"] = "CR_ANDROID_PROBUSINESS_ADVANCED_SEARCH";
  ClickReasonsEnum2["CrAndroidTalentService"] = "CR_ANDROID_TALENT_SERVICE";
  ClickReasonsEnum2["CrAndroidJobsFutureColleaguesModule"] = "CR_ANDROID_JOBS_FUTURE_COLLEAGUES_MODULE";
  ClickReasonsEnum2["CrAndroidJobsFutureColleaguesList"] = "CR_ANDROID_JOBS_FUTURE_COLLEAGUES_LIST";
  ClickReasonsEnum2["CrAndroidEventsLikes"] = "CR_ANDROID_EVENTS_LIKES";
  ClickReasonsEnum2["CrAndroidPublisherSocialProofHeader"] = "CR_ANDROID_PUBLISHER_SOCIAL_PROOF_HEADER";
  ClickReasonsEnum2["CrAndroidPublisherEmployeesModule"] = "CR_ANDROID_PUBLISHER_EMPLOYEES_MODULE";
  ClickReasonsEnum2["CrAndroidPublisherEventsModule"] = "CR_ANDROID_PUBLISHER_EVENTS_MODULE";
  ClickReasonsEnum2["CrAndroidPublisherContactsModule"] = "CR_ANDROID_PUBLISHER_CONTACTS_MODULE";
  ClickReasonsEnum2["CrAndroidPublisherComments"] = "CR_ANDROID_PUBLISHER_COMMENTS";
  ClickReasonsEnum2["CrAndroidPublisherLikesComment"] = "CR_ANDROID_PUBLISHER_LIKES_COMMENT";
  ClickReasonsEnum2["CrAndroidPublisherLikesPost"] = "CR_ANDROID_PUBLISHER_LIKES_POST";
  ClickReasonsEnum2["CrAndroidGroupsSocialProofHeaderMembers"] = "CR_ANDROID_GROUPS_SOCIAL_PROOF_HEADER_MEMBERS";
  ClickReasonsEnum2["CrAndroidGroupsModerators"] = "CR_ANDROID_GROUPS_MODERATORS";
  ClickReasonsEnum2["CrAndroidCompaniesCompanyContactList"] = "CR_ANDROID_COMPANIES_COMPANY_CONTACT_LIST";
  ClickReasonsEnum2["CrAndroidSocialMentionComment"] = "CR_ANDROID_SOCIAL_MENTION_COMMENT";
  ClickReasonsEnum2["CrAndroidSocialMentionPost"] = "CR_ANDROID_SOCIAL_MENTION_POST";
  ClickReasonsEnum2["CrIosStory"] = "CR_IOS_STORY";
  ClickReasonsEnum2["CrIosStoryMentioning"] = "CR_IOS_STORY_MENTIONING";
  ClickReasonsEnum2["CrIosConversationStarter"] = "CR_IOS_CONVERSATION_STARTER";
  ClickReasonsEnum2["CrIosContactRequestReceived"] = "CR_IOS_CONTACT_REQUEST_RECEIVED";
  ClickReasonsEnum2["CrIosContactRequestSent"] = "CR_IOS_CONTACT_REQUEST_SENT";
  ClickReasonsEnum2["CrIosOwnContactList"] = "CR_IOS_OWN_CONTACT_LIST";
  ClickReasonsEnum2["CrIosBirthdayList"] = "CR_IOS_BIRTHDAY_LIST";
  ClickReasonsEnum2["CrIosAroundYouList"] = "CR_IOS_AROUND_YOU_LIST";
  ClickReasonsEnum2["CrIosMymkContacts"] = "CR_IOS_MYMK_CONTACTS";
  ClickReasonsEnum2["CrIosMymk"] = "CR_IOS_MYMK";
  ClickReasonsEnum2["CrIosNetworkHomeMessage"] = "CR_IOS_NETWORK_HOME_MESSAGE";
  ClickReasonsEnum2["CrIosChatview"] = "CR_IOS_CHATVIEW";
  ClickReasonsEnum2["CrIosMessenger"] = "CR_IOS_MESSENGER";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherPostComment"] = "CR_IOS_NETUPDT_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherJobPostComment"] = "CR_IOS_NETUPDT_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherEventPostComment"] = "CR_IOS_NETUPDT_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherArticlePostComment"] = "CR_IOS_NETUPDT_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnPostComment"] = "CR_IOS_NETUPDT_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnJobPostComment"] = "CR_IOS_NETUPDT_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnEventPostComment"] = "CR_IOS_NETUPDT_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnArticlePostComment"] = "CR_IOS_NETUPDT_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherPostLike"] = "CR_IOS_NETUPDT_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherJobPostLike"] = "CR_IOS_NETUPDT_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherEventPostLike"] = "CR_IOS_NETUPDT_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrIosNetupdtDiscoOtherArticlePostLike"] = "CR_IOS_NETUPDT_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrIosNetupdtDiscoPostShared"] = "CR_IOS_NETUPDT_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrIosNetupdtDiscoJobPostShared"] = "CR_IOS_NETUPDT_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrIosNetupdtDiscoEventPostShared"] = "CR_IOS_NETUPDT_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrIosNetupdtDiscoEventArticleShared"] = "CR_IOS_NETUPDT_DISCO_EVENT_ARTICLE_SHARED";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnPost"] = "CR_IOS_NETUPDT_DISCO_OWN_POST";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnJobPost"] = "CR_IOS_NETUPDT_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnEventPost"] = "CR_IOS_NETUPDT_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrIosNetupdtDiscoOwnArticlePost"] = "CR_IOS_NETUPDT_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrIosNetupdtDiscoFollowing"] = "CR_IOS_NETUPDT_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrIosNetupdtDiscoProfileUpdate"] = "CR_IOS_NETUPDT_DISCO_PROFILE_UPDATE";
  ClickReasonsEnum2["CrIosNetupdtDiscoProfilePictUpdate"] = "CR_IOS_NETUPDT_DISCO_PROFILE_PICT_UPDATE";
  ClickReasonsEnum2["CrIosNetupdtDiscoBusinessCardUpdate"] = "CR_IOS_NETUPDT_DISCO_BUSINESS_CARD_UPDATE";
  ClickReasonsEnum2["CrIosNetupdtDiscoPersonalUpdate"] = "CR_IOS_NETUPDT_DISCO_PERSONAL_UPDATE";
  ClickReasonsEnum2["CrIosNetupdtDiscoWorkExpUpdate"] = "CR_IOS_NETUPDT_DISCO_WORK_EXP_UPDATE";
  ClickReasonsEnum2["CrIosNetupdtDiscoHeaderImgUpdate"] = "CR_IOS_NETUPDT_DISCO_HEADER_IMG_UPDATE";
  ClickReasonsEnum2["CrIosNetupdtDiscoContactReco"] = "CR_IOS_NETUPDT_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrIosNetupdtDiscoNewContactUpdate"] = "CR_IOS_NETUPDT_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrIosNetupdtDiscoSharedContacts"] = "CR_IOS_NETUPDT_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrIosNetupdtDiscoInterestingJobs"] = "CR_IOS_NETUPDT_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrIosNetupdtDiscoAnniversary"] = "CR_IOS_NETUPDT_DISCO_ANNIVERSARY";
  ClickReasonsEnum2["CrIosNetupdtDiscoGroupCreation"] = "CR_IOS_NETUPDT_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrIosNetupdtDiscoGroupJoined"] = "CR_IOS_NETUPDT_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrIosNetupdtDiscoEventCreation"] = "CR_IOS_NETUPDT_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrIosNetupdtDiscoEventAttending"] = "CR_IOS_NETUPDT_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrIosExploreDiscoOtherPostComment"] = "CR_IOS_EXPLORE_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOtherJobPostComment"] = "CR_IOS_EXPLORE_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOtherEventPostComment"] = "CR_IOS_EXPLORE_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOtherArticlePostComment"] = "CR_IOS_EXPLORE_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOwnPostComment"] = "CR_IOS_EXPLORE_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOwnJobPostComment"] = "CR_IOS_EXPLORE_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOwnEventPostComment"] = "CR_IOS_EXPLORE_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOwnArticlePostComment"] = "CR_IOS_EXPLORE_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrIosExploreDiscoOtherPostLike"] = "CR_IOS_EXPLORE_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrIosExploreDiscoOtherJobPostLike"] = "CR_IOS_EXPLORE_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrIosExploreDiscoOtherEventPostLike"] = "CR_IOS_EXPLORE_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrIosExploreDiscoOtherArticlePostLike"] = "CR_IOS_EXPLORE_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrIosExploreDiscoPostShared"] = "CR_IOS_EXPLORE_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrIosExploreDiscoJobPostShared"] = "CR_IOS_EXPLORE_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrIosExploreDiscoEventPostShared"] = "CR_IOS_EXPLORE_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrIosExploreDiscoArticlePostShared"] = "CR_IOS_EXPLORE_DISCO_ARTICLE_POST_SHARED";
  ClickReasonsEnum2["CrIosExploreDiscoOwnPost"] = "CR_IOS_EXPLORE_DISCO_OWN_POST";
  ClickReasonsEnum2["CrIosExploreDiscoOwnJobPost"] = "CR_IOS_EXPLORE_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrIosExploreDiscoOwnEventPost"] = "CR_IOS_EXPLORE_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrIosExploreDiscoOwnArticlePost"] = "CR_IOS_EXPLORE_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrIosExploreDiscoFollowing"] = "CR_IOS_EXPLORE_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrIosExploreDiscoProfileUpdate"] = "CR_IOS_EXPLORE_DISCO_PROFILE_UPDATE";
  ClickReasonsEnum2["CrIosExploreDiscoProfilePictUpdate"] = "CR_IOS_EXPLORE_DISCO_PROFILE_PICT_UPDATE";
  ClickReasonsEnum2["CrIosExploreDiscoBusinessCardUpdate"] = "CR_IOS_EXPLORE_DISCO_BUSINESS_CARD_UPDATE";
  ClickReasonsEnum2["CrIosExploreDiscoPersonalUpdate"] = "CR_IOS_EXPLORE_DISCO_PERSONAL_UPDATE";
  ClickReasonsEnum2["CrIosExploreDiscoWorkExpUpdate"] = "CR_IOS_EXPLORE_DISCO_WORK_EXP_UPDATE";
  ClickReasonsEnum2["CrIosExploreDiscoHeaderImageUpdate"] = "CR_IOS_EXPLORE_DISCO_HEADER_IMAGE_UPDATE";
  ClickReasonsEnum2["CrIosExploreDiscoContactReco"] = "CR_IOS_EXPLORE_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrIosExploreDiscoNewContactUpdate"] = "CR_IOS_EXPLORE_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrIosExploreDiscoSharedContacts"] = "CR_IOS_EXPLORE_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrIosExploreDiscoInterestingJobs"] = "CR_IOS_EXPLORE_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrIosExploreDiscoAnniversary"] = "CR_IOS_EXPLORE_DISCO_ANNIVERSARY";
  ClickReasonsEnum2["CrIosExploreDiscoGroupCreation"] = "CR_IOS_EXPLORE_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrIosExploreDiscoGroupJoined"] = "CR_IOS_EXPLORE_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrIosExploreDiscoEventCreation"] = "CR_IOS_EXPLORE_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrIosExploreDiscoEventAttending"] = "CR_IOS_EXPLORE_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrIosEntitypageDiscoCompanyPage"] = "CR_IOS_ENTITYPAGE_DISCO_COMPANY_PAGE";
  ClickReasonsEnum2["CrIosDiscoSearch"] = "CR_IOS_DISCO_SEARCH";
  ClickReasonsEnum2["CrIosDiscoMemberSearch"] = "CR_IOS_DISCO_MEMBER_SEARCH";
  ClickReasonsEnum2["CrIosTopicDiscoChannelFollowing"] = "CR_IOS_TOPIC_DISCO_CHANNEL_FOLLOWING";
  ClickReasonsEnum2["CrIosTopicDiscoOtherPostComment"] = "CR_IOS_TOPIC_DISCO_OTHER_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOtherJobPostComment"] = "CR_IOS_TOPIC_DISCO_OTHER_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOtherEventPostComment"] = "CR_IOS_TOPIC_DISCO_OTHER_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOtherArticlePostComment"] = "CR_IOS_TOPIC_DISCO_OTHER_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOwnPostComment"] = "CR_IOS_TOPIC_DISCO_OWN_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOwnJobPostComment"] = "CR_IOS_TOPIC_DISCO_OWN_JOB_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOwnEventPostComment"] = "CR_IOS_TOPIC_DISCO_OWN_EVENT_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOwnArticlePostComment"] = "CR_IOS_TOPIC_DISCO_OWN_ARTICLE_POST_COMMENT";
  ClickReasonsEnum2["CrIosTopicDiscoOtherPostLike"] = "CR_IOS_TOPIC_DISCO_OTHER_POST_LIKE";
  ClickReasonsEnum2["CrIosTopicDiscoOtherJobPostLike"] = "CR_IOS_TOPIC_DISCO_OTHER_JOB_POST_LIKE";
  ClickReasonsEnum2["CrIosTopicDiscoOtherEventPostLike"] = "CR_IOS_TOPIC_DISCO_OTHER_EVENT_POST_LIKE";
  ClickReasonsEnum2["CrIosTopicDiscoOtherArticlePostLike"] = "CR_IOS_TOPIC_DISCO_OTHER_ARTICLE_POST_LIKE";
  ClickReasonsEnum2["CrIosTopicDiscoPostShared"] = "CR_IOS_TOPIC_DISCO_POST_SHARED";
  ClickReasonsEnum2["CrIosTopicDiscoJobPostShared"] = "CR_IOS_TOPIC_DISCO_JOB_POST_SHARED";
  ClickReasonsEnum2["CrIosTopicDiscoEventPostShared"] = "CR_IOS_TOPIC_DISCO_EVENT_POST_SHARED";
  ClickReasonsEnum2["CrIosTopicDiscoArticlePostShared"] = "CR_IOS_TOPIC_DISCO_ARTICLE_POST_SHARED";
  ClickReasonsEnum2["CrIosTopicDiscoOwnPost"] = "CR_IOS_TOPIC_DISCO_OWN_POST";
  ClickReasonsEnum2["CrIosTopicDiscoOwnJobPost"] = "CR_IOS_TOPIC_DISCO_OWN_JOB_POST";
  ClickReasonsEnum2["CrIosTopicDiscoOwnEventPost"] = "CR_IOS_TOPIC_DISCO_OWN_EVENT_POST";
  ClickReasonsEnum2["CrIosTopicDiscoOwnArticlePost"] = "CR_IOS_TOPIC_DISCO_OWN_ARTICLE_POST";
  ClickReasonsEnum2["CrIosTopicDiscoFollowing"] = "CR_IOS_TOPIC_DISCO_FOLLOWING";
  ClickReasonsEnum2["CrIosTopicDiscoContactReco"] = "CR_IOS_TOPIC_DISCO_CONTACT_RECO";
  ClickReasonsEnum2["CrIosTopicDiscoNewContactUpdate"] = "CR_IOS_TOPIC_DISCO_NEW_CONTACT_UPDATE";
  ClickReasonsEnum2["CrIosTopicDiscoSharedContacts"] = "CR_IOS_TOPIC_DISCO_SHARED_CONTACTS";
  ClickReasonsEnum2["CrIosTopicDiscoInterestingJobs"] = "CR_IOS_TOPIC_DISCO_INTERESTING_JOBS";
  ClickReasonsEnum2["CrIosTopicDiscoGroupCreation"] = "CR_IOS_TOPIC_DISCO_GROUP_CREATION";
  ClickReasonsEnum2["CrIosTopicDiscoGroupJoined"] = "CR_IOS_TOPIC_DISCO_GROUP_JOINED";
  ClickReasonsEnum2["CrIosTopicDiscoEventCreation"] = "CR_IOS_TOPIC_DISCO_EVENT_CREATION";
  ClickReasonsEnum2["CrIosTopicDiscoEventAttending"] = "CR_IOS_TOPIC_DISCO_EVENT_ATTENDING";
  ClickReasonsEnum2["CrIosMehubVomp"] = "CR_IOS_MEHUB_VOMP";
  ClickReasonsEnum2["CrIosMehubContactsList"] = "CR_IOS_MEHUB_CONTACTS_LIST";
  ClickReasonsEnum2["CrIosVompPage"] = "CR_IOS_VOMP_PAGE";
  ClickReasonsEnum2["CrIosVompPageCommonContacts"] = "CR_IOS_VOMP_PAGE_COMMON_CONTACTS";
  ClickReasonsEnum2["CrIosJobsCompanyContacts"] = "CR_IOS_JOBS_COMPANY_CONTACTS";
  ClickReasonsEnum2["CrIosJobsCompanyContactsContact"] = "CR_IOS_JOBS_COMPANY_CONTACTS_CONTACT";
  ClickReasonsEnum2["CrIosJobsCompanyContactsCommonContact"] = "CR_IOS_JOBS_COMPANY_CONTACTS_COMMON_CONTACT";
  ClickReasonsEnum2["CrIosEventsGuestList"] = "CR_IOS_EVENTS_GUEST_LIST";
  ClickReasonsEnum2["CrIosEventsOrganizer"] = "CR_IOS_EVENTS_ORGANIZER";
  ClickReasonsEnum2["CrIosEventsContactPerson"] = "CR_IOS_EVENTS_CONTACT_PERSON";
  ClickReasonsEnum2["CrIosEventsSpeaker"] = "CR_IOS_EVENTS_SPEAKER";
  ClickReasonsEnum2["CrIosEventsComment"] = "CR_IOS_EVENTS_COMMENT";
  ClickReasonsEnum2["CrIosNewsComment"] = "CR_IOS_NEWS_COMMENT";
  ClickReasonsEnum2["CrIosNewsLike"] = "CR_IOS_NEWS_LIKE";
  ClickReasonsEnum2["CrIosNewsAuthor"] = "CR_IOS_NEWS_AUTHOR";
  ClickReasonsEnum2["CrIosNewsAuthorFollowers"] = "CR_IOS_NEWS_AUTHOR_FOLLOWERS";
  ClickReasonsEnum2["CrIosNewsFollowers"] = "CR_IOS_NEWS_FOLLOWERS";
  ClickReasonsEnum2["CrIosKlartextComment"] = "CR_IOS_KLARTEXT_COMMENT";
  ClickReasonsEnum2["CrIosKlartextCommentLike"] = "CR_IOS_KLARTEXT_COMMENT_LIKE";
  ClickReasonsEnum2["CrIosKlartextApprovedList"] = "CR_IOS_KLARTEXT_APPROVED_LIST";
  ClickReasonsEnum2["CrIosKlartextAuthor"] = "CR_IOS_KLARTEXT_AUTHOR";
  ClickReasonsEnum2["CrIosGroupsMembersList"] = "CR_IOS_GROUPS_MEMBERS_LIST";
  ClickReasonsEnum2["CrIosGroupsDiscussions"] = "CR_IOS_GROUPS_DISCUSSIONS";
  ClickReasonsEnum2["CrIosCompaniesEmployeeList"] = "CR_IOS_COMPANIES_EMPLOYEE_LIST";
  ClickReasonsEnum2["CrIosCompaniesFollowersList"] = "CR_IOS_COMPANIES_FOLLOWERS_LIST";
  ClickReasonsEnum2["CrIosCompaniesContacts"] = "CR_IOS_COMPANIES_CONTACTS";
  ClickReasonsEnum2["CrIosProfileContactsList"] = "CR_IOS_PROFILE_CONTACTS_LIST";
  ClickReasonsEnum2["CrIosProfileSharedContacts"] = "CR_IOS_PROFILE_SHARED_CONTACTS";
  ClickReasonsEnum2["CrIosOnboardingContactsReco"] = "CR_IOS_ONBOARDING_CONTACTS_RECO";
  ClickReasonsEnum2["CrIosUpboardingContactsReco"] = "CR_IOS_UPBOARDING_CONTACTS_RECO";
  ClickReasonsEnum2["CrIosTalentManager"] = "CR_IOS_TALENT_MANAGER";
  ClickReasonsEnum2["CrIosProjobsRecruiterReco"] = "CR_IOS_PROJOBS_RECRUITER_RECO";
  ClickReasonsEnum2["CrIosProjobsVomp"] = "CR_IOS_PROJOBS_VOMP";
  ClickReasonsEnum2["CrIosProjobs"] = "CR_IOS_PROJOBS";
  ClickReasonsEnum2["CrIosProbusinessContacts"] = "CR_IOS_PROBUSINESS_CONTACTS";
  ClickReasonsEnum2["CrIosProbusinessSearch"] = "CR_IOS_PROBUSINESS_SEARCH";
  ClickReasonsEnum2["CrIosProbusinessAdvancedSearch"] = "CR_IOS_PROBUSINESS_ADVANCED_SEARCH";
  ClickReasonsEnum2["CrIosTalentService"] = "CR_IOS_TALENT_SERVICE";
  ClickReasonsEnum2["CrIosJobsFutureColleaguesModule"] = "CR_IOS_JOBS_FUTURE_COLLEAGUES_MODULE";
  ClickReasonsEnum2["CrIosJobsFutureColleaguesList"] = "CR_IOS_JOBS_FUTURE_COLLEAGUES_LIST";
  ClickReasonsEnum2["CrIosEventsLikes"] = "CR_IOS_EVENTS_LIKES";
  ClickReasonsEnum2["CrIosPublisherSocialProofHeader"] = "CR_IOS_PUBLISHER_SOCIAL_PROOF_HEADER";
  ClickReasonsEnum2["CrIosPublisherEmployeesModule"] = "CR_IOS_PUBLISHER_EMPLOYEES_MODULE";
  ClickReasonsEnum2["CrIosPublisherEventsModule"] = "CR_IOS_PUBLISHER_EVENTS_MODULE";
  ClickReasonsEnum2["CrIosPublisherContactsModule"] = "CR_IOS_PUBLISHER_CONTACTS_MODULE";
  ClickReasonsEnum2["CrIosPublisherComments"] = "CR_IOS_PUBLISHER_COMMENTS";
  ClickReasonsEnum2["CrIosPublisherLikesComment"] = "CR_IOS_PUBLISHER_LIKES_COMMENT";
  ClickReasonsEnum2["CrIosPublisherLikesPost"] = "CR_IOS_PUBLISHER_LIKES_POST";
  ClickReasonsEnum2["CrIosGroupsSocialProofHeaderMembers"] = "CR_IOS_GROUPS_SOCIAL_PROOF_HEADER_MEMBERS";
  ClickReasonsEnum2["CrIosGroupsModerators"] = "CR_IOS_GROUPS_MODERATORS";
  ClickReasonsEnum2["CrIosCompaniesCompanyContactList"] = "CR_IOS_COMPANIES_COMPANY_CONTACT_LIST";
  ClickReasonsEnum2["CrIosSocialMentionComment"] = "CR_IOS_SOCIAL_MENTION_COMMENT";
  ClickReasonsEnum2["CrIosSocialMentionPost"] = "CR_IOS_SOCIAL_MENTION_POST";
  ClickReasonsEnum2["CrEmailVomp"] = "CR_EMAIL_VOMP";
  ClickReasonsEnum2["CrEmailContactRequest"] = "CR_EMAIL_CONTACT_REQUEST";
  ClickReasonsEnum2["CrEmailContactUpdate"] = "CR_EMAIL_CONTACT_UPDATE";
  ClickReasonsEnum2["CrEmailContactMessage"] = "CR_EMAIL_CONTACT_MESSAGE";
  ClickReasonsEnum2["CrEmailBirthdayList"] = "CR_EMAIL_BIRTHDAY_LIST";
  return ClickReasonsEnum2;
})(ClickReasonsEnum || {});
var ClientPaymentInvoiceStatus = /* @__PURE__ */ ((ClientPaymentInvoiceStatus2) => {
  ClientPaymentInvoiceStatus2["Open"] = "OPEN";
  ClientPaymentInvoiceStatus2["Paid"] = "PAID";
  ClientPaymentInvoiceStatus2["Cancelled"] = "CANCELLED";
  ClientPaymentInvoiceStatus2["Issued"] = "ISSUED";
  ClientPaymentInvoiceStatus2["FirstReminder"] = "FIRST_REMINDER";
  ClientPaymentInvoiceStatus2["SecondReminder"] = "SECOND_REMINDER";
  ClientPaymentInvoiceStatus2["Encashment"] = "ENCASHMENT";
  return ClientPaymentInvoiceStatus2;
})(ClientPaymentInvoiceStatus || {});
var CommunityCategory = /* @__PURE__ */ ((CommunityCategory2) => {
  CommunityCategory2["RegionalAmbassador"] = "REGIONAL_AMBASSADOR";
  CommunityCategory2["XpertAmbassador"] = "XPERT_AMBASSADOR";
  CommunityCategory2["Themen"] = "THEMEN";
  CommunityCategory2["Partnered"] = "PARTNERED";
  CommunityCategory2["Franchised"] = "FRANCHISED";
  CommunityCategory2["OwnedAndOperated"] = "OWNED_AND_OPERATED";
  return CommunityCategory2;
})(CommunityCategory || {});
var CommunityCommentTypes = /* @__PURE__ */ ((CommunityCommentTypes2) => {
  CommunityCommentTypes2["Classified"] = "CLASSIFIED";
  CommunityCommentTypes2["Post"] = "POST";
  return CommunityCommentTypes2;
})(CommunityCommentTypes || {});
var CommunityInterationDialogType = /* @__PURE__ */ ((CommunityInterationDialogType2) => {
  CommunityInterationDialogType2["Message"] = "MESSAGE";
  CommunityInterationDialogType2["Confirmation"] = "CONFIRMATION";
  return CommunityInterationDialogType2;
})(CommunityInterationDialogType || {});
var CommunityInterationMethod = /* @__PURE__ */ ((CommunityInterationMethod2) => {
  CommunityInterationMethod2["Post"] = "POST";
  CommunityInterationMethod2["Delete"] = "DELETE";
  return CommunityInterationMethod2;
})(CommunityInterationMethod || {});
var CommunityInterationType = /* @__PURE__ */ ((CommunityInterationType2) => {
  CommunityInterationType2["Primary"] = "PRIMARY";
  return CommunityInterationType2;
})(CommunityInterationType || {});
var CommunityMeetupFrequency = /* @__PURE__ */ ((CommunityMeetupFrequency2) => {
  CommunityMeetupFrequency2["Once"] = "ONCE";
  CommunityMeetupFrequency2["TwoOrThreeTimes"] = "TWO_OR_THREE_TIMES";
  CommunityMeetupFrequency2["FourOrFiveTimes"] = "FOUR_OR_FIVE_TIMES";
  CommunityMeetupFrequency2["SixOrMoreTimes"] = "SIX_OR_MORE_TIMES";
  return CommunityMeetupFrequency2;
})(CommunityMeetupFrequency || {});
var CommunityMemberState = /* @__PURE__ */ ((CommunityMemberState2) => {
  CommunityMemberState2["Owner"] = "OWNER";
  CommunityMemberState2["Moderator"] = "MODERATOR";
  CommunityMemberState2["Blocked"] = "BLOCKED";
  CommunityMemberState2["Member"] = "MEMBER";
  CommunityMemberState2["Pending"] = "PENDING";
  CommunityMemberState2["Kicked"] = "KICKED";
  return CommunityMemberState2;
})(CommunityMemberState || {});
var CommunityMigrationState = /* @__PURE__ */ ((CommunityMigrationState2) => {
  CommunityMigrationState2["Pending"] = "PENDING";
  CommunityMigrationState2["InProgress"] = "IN_PROGRESS";
  CommunityMigrationState2["GroupDeleted"] = "GROUP_DELETED";
  CommunityMigrationState2["Error"] = "ERROR";
  CommunityMigrationState2["MigrationCompleted"] = "MIGRATION_COMPLETED";
  CommunityMigrationState2["ContentMigrationInProgress"] = "CONTENT_MIGRATION_IN_PROGRESS";
  return CommunityMigrationState2;
})(CommunityMigrationState || {});
var CommunityPostCrosspostingStatus = /* @__PURE__ */ ((CommunityPostCrosspostingStatus2) => {
  CommunityPostCrosspostingStatus2["InfoSameGroup"] = "INFO_SAME_GROUP";
  CommunityPostCrosspostingStatus2["InfoDifferentGroup_2Posts"] = "INFO_DIFFERENT_GROUP_2_POSTS";
  CommunityPostCrosspostingStatus2["InfoDifferentGroup_3Posts"] = "INFO_DIFFERENT_GROUP_3_POSTS";
  return CommunityPostCrosspostingStatus2;
})(CommunityPostCrosspostingStatus || {});
var CommunityStatus = /* @__PURE__ */ ((CommunityStatus2) => {
  CommunityStatus2["Closed"] = "CLOSED";
  CommunityStatus2["Open"] = "OPEN";
  return CommunityStatus2;
})(CommunityStatus || {});
var CommunityTileStates = /* @__PURE__ */ ((CommunityTileStates2) => {
  CommunityTileStates2["Active"] = "ACTIVE";
  CommunityTileStates2["Inactive"] = "INACTIVE";
  return CommunityTileStates2;
})(CommunityTileStates || {});
var CommunityTileTypes = /* @__PURE__ */ ((CommunityTileTypes2) => {
  CommunityTileTypes2["Texttile"] = "TEXTTILE";
  CommunityTileTypes2["Imagetile"] = "IMAGETILE";
  CommunityTileTypes2["Pdftile"] = "PDFTILE";
  CommunityTileTypes2["Videotile"] = "VIDEOTILE";
  return CommunityTileTypes2;
})(CommunityTileTypes || {});
var CompaniesIndustriesSortOptions = /* @__PURE__ */ ((CompaniesIndustriesSortOptions2) => {
  CompaniesIndustriesSortOptions2["Id"] = "ID";
  CompaniesIndustriesSortOptions2["Total"] = "TOTAL";
  return CompaniesIndustriesSortOptions2;
})(CompaniesIndustriesSortOptions || {});
var CompaniesRecentlyClaimedOrder = /* @__PURE__ */ ((CompaniesRecentlyClaimedOrder2) => {
  CompaniesRecentlyClaimedOrder2["IdDesc"] = "ID_DESC";
  CompaniesRecentlyClaimedOrder2["Random"] = "RANDOM";
  return CompaniesRecentlyClaimedOrder2;
})(CompaniesRecentlyClaimedOrder || {});
var CompanyAffiliateCategory = /* @__PURE__ */ ((CompanyAffiliateCategory2) => {
  CompanyAffiliateCategory2["Parent"] = "PARENT";
  CompanyAffiliateCategory2["Subsidiary"] = "SUBSIDIARY";
  CompanyAffiliateCategory2["Associate"] = "ASSOCIATE";
  CompanyAffiliateCategory2["Partner"] = "PARTNER";
  CompanyAffiliateCategory2["Client"] = "CLIENT";
  CompanyAffiliateCategory2["ServiceProvider"] = "SERVICE_PROVIDER";
  CompanyAffiliateCategory2["JointVenture"] = "JOINT_VENTURE";
  CompanyAffiliateCategory2["Franchise"] = "FRANCHISE";
  CompanyAffiliateCategory2["RegionalBranch"] = "REGIONAL_BRANCH";
  return CompanyAffiliateCategory2;
})(CompanyAffiliateCategory || {});
var CompanyContractPackage = /* @__PURE__ */ ((CompanyContractPackage2) => {
  CompanyContractPackage2["None"] = "NONE";
  CompanyContractPackage2["Basic"] = "BASIC";
  CompanyContractPackage2["Ebp"] = "EBP";
  CompanyContractPackage2["Plus"] = "PLUS";
  CompanyContractPackage2["Standard"] = "STANDARD";
  return CompanyContractPackage2;
})(CompanyContractPackage || {});
var CompanyCreateFeedErrorType = /* @__PURE__ */ ((CompanyCreateFeedErrorType2) => {
  CompanyCreateFeedErrorType2["RssUrlInvalid"] = "RSS_URL_INVALID";
  CompanyCreateFeedErrorType2["RssFeedNotValid"] = "RSS_FEED_NOT_VALID";
  CompanyCreateFeedErrorType2["TwitterTagInvalid"] = "TWITTER_TAG_INVALID";
  CompanyCreateFeedErrorType2["TwitterFeedNotValid"] = "TWITTER_FEED_NOT_VALID";
  return CompanyCreateFeedErrorType2;
})(CompanyCreateFeedErrorType || {});
var CompanyDemographicsKpi = /* @__PURE__ */ ((CompanyDemographicsKpi2) => {
  CompanyDemographicsKpi2["Visitors"] = "VISITORS";
  CompanyDemographicsKpi2["Followers"] = "FOLLOWERS";
  return CompanyDemographicsKpi2;
})(CompanyDemographicsKpi || {});
var CompanyEmployeesContactLevel = /* @__PURE__ */ ((CompanyEmployeesContactLevel2) => {
  CompanyEmployeesContactLevel2["ConnectionNone"] = "CONNECTION_NONE";
  CompanyEmployeesContactLevel2["Connection_1"] = "CONNECTION_1";
  CompanyEmployeesContactLevel2["Connection_2"] = "CONNECTION_2";
  CompanyEmployeesContactLevel2["Connection_2_1"] = "CONNECTION_2_1";
  return CompanyEmployeesContactLevel2;
})(CompanyEmployeesContactLevel || {});
var CompanyEmployeesSort = /* @__PURE__ */ ((CompanyEmployeesSort2) => {
  CompanyEmployeesSort2["LastName"] = "LAST_NAME";
  CompanyEmployeesSort2["ConnectionDegree"] = "CONNECTION_DEGREE";
  return CompanyEmployeesSort2;
})(CompanyEmployeesSort || {});
var CompanyFeedType = /* @__PURE__ */ ((CompanyFeedType2) => {
  CompanyFeedType2["Rss"] = "RSS";
  CompanyFeedType2["Twitter"] = "TWITTER";
  return CompanyFeedType2;
})(CompanyFeedType || {});
var CompanyInsightsGranularity = /* @__PURE__ */ ((CompanyInsightsGranularity2) => {
  CompanyInsightsGranularity2["Day"] = "DAY";
  CompanyInsightsGranularity2["Week"] = "WEEK";
  CompanyInsightsGranularity2["Month"] = "MONTH";
  return CompanyInsightsGranularity2;
})(CompanyInsightsGranularity || {});
var CompanyKununuReviewJobStatus = /* @__PURE__ */ ((CompanyKununuReviewJobStatus2) => {
  CompanyKununuReviewJobStatus2["Current"] = "CURRENT";
  CompanyKununuReviewJobStatus2["Internship"] = "INTERNSHIP";
  CompanyKununuReviewJobStatus2["Previous"] = "PREVIOUS";
  CompanyKununuReviewJobStatus2["NotSpecified"] = "NOT_SPECIFIED";
  return CompanyKununuReviewJobStatus2;
})(CompanyKununuReviewJobStatus || {});
var CompanyMappedBenefitType = /* @__PURE__ */ ((CompanyMappedBenefitType2) => {
  CompanyMappedBenefitType2["Flexitime"] = "FLEXITIME";
  CompanyMappedBenefitType2["HomeOffice"] = "HOME_OFFICE";
  CompanyMappedBenefitType2["Canteen"] = "CANTEEN";
  CompanyMappedBenefitType2["RestaurantTickets"] = "RESTAURANT_TICKETS";
  CompanyMappedBenefitType2["Childcare"] = "CHILDCARE";
  CompanyMappedBenefitType2["CompanyPension"] = "COMPANY_PENSION";
  CompanyMappedBenefitType2["Accessibility"] = "ACCESSIBILITY";
  CompanyMappedBenefitType2["HealthInTheWorkplace"] = "HEALTH_IN_THE_WORKPLACE";
  CompanyMappedBenefitType2["CompanyDoctor"] = "COMPANY_DOCTOR";
  CompanyMappedBenefitType2["Training"] = "TRAINING";
  CompanyMappedBenefitType2["CarPark"] = "CAR_PARK";
  CompanyMappedBenefitType2["ConvenientTransportLinks"] = "CONVENIENT_TRANSPORT_LINKS";
  CompanyMappedBenefitType2["DiscountsSpecialOffers"] = "DISCOUNTS_SPECIAL_OFFERS";
  CompanyMappedBenefitType2["CompanyCar"] = "COMPANY_CAR";
  CompanyMappedBenefitType2["MobileDevice"] = "MOBILE_DEVICE";
  CompanyMappedBenefitType2["ProfitSharing"] = "PROFIT_SHARING";
  CompanyMappedBenefitType2["EventsForEmployees"] = "EVENTS_FOR_EMPLOYEES";
  CompanyMappedBenefitType2["PrivateInternetUse"] = "PRIVATE_INTERNET_USE";
  CompanyMappedBenefitType2["DogsWelcome"] = "DOGS_WELCOME";
  return CompanyMappedBenefitType2;
})(CompanyMappedBenefitType || {});
var CompanyMembership = /* @__PURE__ */ ((CompanyMembership2) => {
  CompanyMembership2["Current"] = "CURRENT";
  CompanyMembership2["Previous"] = "PREVIOUS";
  return CompanyMembership2;
})(CompanyMembership || {});
var CompanyOffers = /* @__PURE__ */ ((CompanyOffers2) => {
  CompanyOffers2["WithPostings"] = "WITH_POSTINGS";
  CompanyOffers2["WithoutPostings"] = "WITHOUT_POSTINGS";
  return CompanyOffers2;
})(CompanyOffers || {});
var CompanyUpdateAdStatus = /* @__PURE__ */ ((CompanyUpdateAdStatus2) => {
  CompanyUpdateAdStatus2["Active"] = "ACTIVE";
  CompanyUpdateAdStatus2["Archived"] = "ARCHIVED";
  CompanyUpdateAdStatus2["Completed"] = "COMPLETED";
  CompanyUpdateAdStatus2["Draft"] = "DRAFT";
  CompanyUpdateAdStatus2["Paused"] = "PAUSED";
  CompanyUpdateAdStatus2["Pending"] = "PENDING";
  CompanyUpdateAdStatus2["Rejected"] = "REJECTED";
  CompanyUpdateAdStatus2["Scheduled"] = "SCHEDULED";
  CompanyUpdateAdStatus2["TakenDown"] = "TAKEN_DOWN";
  CompanyUpdateAdStatus2["TakenDownCompletely"] = "TAKEN_DOWN_COMPLETELY";
  CompanyUpdateAdStatus2["Terminated"] = "TERMINATED";
  return CompanyUpdateAdStatus2;
})(CompanyUpdateAdStatus || {});
var CompanyUpdateInformationErrorType = /* @__PURE__ */ ((CompanyUpdateInformationErrorType2) => {
  CompanyUpdateInformationErrorType2["SlugInvalid"] = "SLUG_INVALID";
  return CompanyUpdateInformationErrorType2;
})(CompanyUpdateInformationErrorType || {});
var CompanyUpdateOrder = /* @__PURE__ */ ((CompanyUpdateOrder2) => {
  CompanyUpdateOrder2["Asc"] = "ASC";
  CompanyUpdateOrder2["Desc"] = "DESC";
  return CompanyUpdateOrder2;
})(CompanyUpdateOrder || {});
var CompanyUserRole = /* @__PURE__ */ ((CompanyUserRole2) => {
  CompanyUserRole2["AdditionalAdmin"] = "ADDITIONAL_ADMIN";
  CompanyUserRole2["Admin"] = "ADMIN";
  CompanyUserRole2["Editor"] = "EDITOR";
  CompanyUserRole2["XingCsAdmin"] = "XING_CS_ADMIN";
  return CompanyUserRole2;
})(CompanyUserRole || {});
var ContactsListOrderBy = /* @__PURE__ */ ((ContactsListOrderBy2) => {
  ContactsListOrderBy2["FirstName"] = "FIRST_NAME";
  ContactsListOrderBy2["LastName"] = "LAST_NAME";
  ContactsListOrderBy2["ContactCreatedAt"] = "CONTACT_CREATED_AT";
  return ContactsListOrderBy2;
})(ContactsListOrderBy || {});
var ContactsMatchField = /* @__PURE__ */ ((ContactsMatchField2) => {
  ContactsMatchField2["Name"] = "NAME";
  return ContactsMatchField2;
})(ContactsMatchField || {});
var ContentArticleStatus = /* @__PURE__ */ ((ContentArticleStatus2) => {
  ContentArticleStatus2["Published"] = "PUBLISHED";
  ContentArticleStatus2["Draft"] = "DRAFT";
  ContentArticleStatus2["Scheduled"] = "SCHEDULED";
  ContentArticleStatus2["Disabled"] = "DISABLED";
  return ContentArticleStatus2;
})(ContentArticleStatus || {});
var ContentChannelFollowState = /* @__PURE__ */ ((ContentChannelFollowState2) => {
  ContentChannelFollowState2["FollowedWithEmail"] = "FOLLOWED_WITH_EMAIL";
  ContentChannelFollowState2["FollowedWithoutEmail"] = "FOLLOWED_WITHOUT_EMAIL";
  ContentChannelFollowState2["Unfollowed"] = "UNFOLLOWED";
  return ContentChannelFollowState2;
})(ContentChannelFollowState || {});
var ContentPageType = /* @__PURE__ */ ((ContentPageType2) => {
  ContentPageType2["Insider"] = "insider";
  ContentPageType2["Industry"] = "industry";
  ContentPageType2["PressReview"] = "press_review";
  ContentPageType2["Topic"] = "topic";
  ContentPageType2["Publisher"] = "publisher";
  return ContentPageType2;
})(ContentPageType || {});
var ContentPurchaseType = /* @__PURE__ */ ((ContentPurchaseType2) => {
  ContentPurchaseType2["All"] = "ALL";
  ContentPurchaseType2["Article"] = "ARTICLE";
  ContentPurchaseType2["Bundle"] = "BUNDLE";
  ContentPurchaseType2["Subscription"] = "SUBSCRIPTION";
  ContentPurchaseType2["Daypass"] = "DAYPASS";
  ContentPurchaseType2["Daypass365"] = "DAYPASS365";
  return ContentPurchaseType2;
})(ContentPurchaseType || {});
var ContentResourceType = /* @__PURE__ */ ((ContentResourceType2) => {
  ContentResourceType2["ContentFulltextArticle"] = "CONTENT_FULLTEXT_ARTICLE";
  ContentResourceType2["ContentVideoArticle"] = "CONTENT_VIDEO_ARTICLE";
  ContentResourceType2["ContentLinkShareArticle"] = "CONTENT_LINK_SHARE_ARTICLE";
  ContentResourceType2["ContentKlarticle"] = "CONTENT_KLARTICLE";
  ContentResourceType2["ArticlesArticle"] = "ARTICLES_ARTICLE";
  return ContentResourceType2;
})(ContentResourceType || {});
var CountryCodesAlpha2 = /* @__PURE__ */ ((CountryCodesAlpha22) => {
  CountryCodesAlpha22["Af"] = "AF";
  CountryCodesAlpha22["Ax"] = "AX";
  CountryCodesAlpha22["Al"] = "AL";
  CountryCodesAlpha22["Dz"] = "DZ";
  CountryCodesAlpha22["As"] = "AS";
  CountryCodesAlpha22["Ad"] = "AD";
  CountryCodesAlpha22["An"] = "AN";
  CountryCodesAlpha22["Ao"] = "AO";
  CountryCodesAlpha22["Ai"] = "AI";
  CountryCodesAlpha22["Aq"] = "AQ";
  CountryCodesAlpha22["Ag"] = "AG";
  CountryCodesAlpha22["Ar"] = "AR";
  CountryCodesAlpha22["Am"] = "AM";
  CountryCodesAlpha22["Aw"] = "AW";
  CountryCodesAlpha22["Au"] = "AU";
  CountryCodesAlpha22["At"] = "AT";
  CountryCodesAlpha22["Az"] = "AZ";
  CountryCodesAlpha22["Bs"] = "BS";
  CountryCodesAlpha22["Bh"] = "BH";
  CountryCodesAlpha22["Bd"] = "BD";
  CountryCodesAlpha22["Bb"] = "BB";
  CountryCodesAlpha22["By"] = "BY";
  CountryCodesAlpha22["Be"] = "BE";
  CountryCodesAlpha22["Bz"] = "BZ";
  CountryCodesAlpha22["Bj"] = "BJ";
  CountryCodesAlpha22["Bm"] = "BM";
  CountryCodesAlpha22["Bt"] = "BT";
  CountryCodesAlpha22["Bo"] = "BO";
  CountryCodesAlpha22["Bq"] = "BQ";
  CountryCodesAlpha22["Ba"] = "BA";
  CountryCodesAlpha22["Bw"] = "BW";
  CountryCodesAlpha22["Bv"] = "BV";
  CountryCodesAlpha22["Br"] = "BR";
  CountryCodesAlpha22["Io"] = "IO";
  CountryCodesAlpha22["Bn"] = "BN";
  CountryCodesAlpha22["Bg"] = "BG";
  CountryCodesAlpha22["Bf"] = "BF";
  CountryCodesAlpha22["Bi"] = "BI";
  CountryCodesAlpha22["Kh"] = "KH";
  CountryCodesAlpha22["Cm"] = "CM";
  CountryCodesAlpha22["Ca"] = "CA";
  CountryCodesAlpha22["Cv"] = "CV";
  CountryCodesAlpha22["Ky"] = "KY";
  CountryCodesAlpha22["Cf"] = "CF";
  CountryCodesAlpha22["Td"] = "TD";
  CountryCodesAlpha22["Cl"] = "CL";
  CountryCodesAlpha22["Cn"] = "CN";
  CountryCodesAlpha22["Cx"] = "CX";
  CountryCodesAlpha22["Cc"] = "CC";
  CountryCodesAlpha22["Co"] = "CO";
  CountryCodesAlpha22["Km"] = "KM";
  CountryCodesAlpha22["Cg"] = "CG";
  CountryCodesAlpha22["Cd"] = "CD";
  CountryCodesAlpha22["Ck"] = "CK";
  CountryCodesAlpha22["Cr"] = "CR";
  CountryCodesAlpha22["Ci"] = "CI";
  CountryCodesAlpha22["Hr"] = "HR";
  CountryCodesAlpha22["Cu"] = "CU";
  CountryCodesAlpha22["Cw"] = "CW";
  CountryCodesAlpha22["Cy"] = "CY";
  CountryCodesAlpha22["Cz"] = "CZ";
  CountryCodesAlpha22["Dk"] = "DK";
  CountryCodesAlpha22["Dj"] = "DJ";
  CountryCodesAlpha22["Dm"] = "DM";
  CountryCodesAlpha22["Do"] = "DO";
  CountryCodesAlpha22["Ec"] = "EC";
  CountryCodesAlpha22["Eg"] = "EG";
  CountryCodesAlpha22["Sv"] = "SV";
  CountryCodesAlpha22["Gq"] = "GQ";
  CountryCodesAlpha22["Er"] = "ER";
  CountryCodesAlpha22["Ee"] = "EE";
  CountryCodesAlpha22["Et"] = "ET";
  CountryCodesAlpha22["Fk"] = "FK";
  CountryCodesAlpha22["Fo"] = "FO";
  CountryCodesAlpha22["Fj"] = "FJ";
  CountryCodesAlpha22["Fi"] = "FI";
  CountryCodesAlpha22["Fr"] = "FR";
  CountryCodesAlpha22["Gf"] = "GF";
  CountryCodesAlpha22["Pf"] = "PF";
  CountryCodesAlpha22["Tf"] = "TF";
  CountryCodesAlpha22["Ga"] = "GA";
  CountryCodesAlpha22["Gm"] = "GM";
  CountryCodesAlpha22["Ge"] = "GE";
  CountryCodesAlpha22["De"] = "DE";
  CountryCodesAlpha22["Gh"] = "GH";
  CountryCodesAlpha22["Gi"] = "GI";
  CountryCodesAlpha22["Gr"] = "GR";
  CountryCodesAlpha22["Gl"] = "GL";
  CountryCodesAlpha22["Gd"] = "GD";
  CountryCodesAlpha22["Gp"] = "GP";
  CountryCodesAlpha22["Gu"] = "GU";
  CountryCodesAlpha22["Gt"] = "GT";
  CountryCodesAlpha22["Gg"] = "GG";
  CountryCodesAlpha22["Gn"] = "GN";
  CountryCodesAlpha22["Gw"] = "GW";
  CountryCodesAlpha22["Gy"] = "GY";
  CountryCodesAlpha22["Ht"] = "HT";
  CountryCodesAlpha22["Hm"] = "HM";
  CountryCodesAlpha22["Va"] = "VA";
  CountryCodesAlpha22["Hn"] = "HN";
  CountryCodesAlpha22["Hk"] = "HK";
  CountryCodesAlpha22["Hu"] = "HU";
  CountryCodesAlpha22["Is"] = "IS";
  CountryCodesAlpha22["In"] = "IN";
  CountryCodesAlpha22["Id"] = "ID";
  CountryCodesAlpha22["Ir"] = "IR";
  CountryCodesAlpha22["Iq"] = "IQ";
  CountryCodesAlpha22["Ie"] = "IE";
  CountryCodesAlpha22["Im"] = "IM";
  CountryCodesAlpha22["Il"] = "IL";
  CountryCodesAlpha22["It"] = "IT";
  CountryCodesAlpha22["Jm"] = "JM";
  CountryCodesAlpha22["Jp"] = "JP";
  CountryCodesAlpha22["Je"] = "JE";
  CountryCodesAlpha22["Jo"] = "JO";
  CountryCodesAlpha22["Kz"] = "KZ";
  CountryCodesAlpha22["Ke"] = "KE";
  CountryCodesAlpha22["Ki"] = "KI";
  CountryCodesAlpha22["Kp"] = "KP";
  CountryCodesAlpha22["Kr"] = "KR";
  CountryCodesAlpha22["Kw"] = "KW";
  CountryCodesAlpha22["Kg"] = "KG";
  CountryCodesAlpha22["La"] = "LA";
  CountryCodesAlpha22["Lv"] = "LV";
  CountryCodesAlpha22["Lb"] = "LB";
  CountryCodesAlpha22["Ls"] = "LS";
  CountryCodesAlpha22["Lr"] = "LR";
  CountryCodesAlpha22["Ly"] = "LY";
  CountryCodesAlpha22["Li"] = "LI";
  CountryCodesAlpha22["Lt"] = "LT";
  CountryCodesAlpha22["Lu"] = "LU";
  CountryCodesAlpha22["Mo"] = "MO";
  CountryCodesAlpha22["Mk"] = "MK";
  CountryCodesAlpha22["Mg"] = "MG";
  CountryCodesAlpha22["Mw"] = "MW";
  CountryCodesAlpha22["My"] = "MY";
  CountryCodesAlpha22["Mv"] = "MV";
  CountryCodesAlpha22["Ml"] = "ML";
  CountryCodesAlpha22["Mt"] = "MT";
  CountryCodesAlpha22["Mh"] = "MH";
  CountryCodesAlpha22["Mq"] = "MQ";
  CountryCodesAlpha22["Mr"] = "MR";
  CountryCodesAlpha22["Mu"] = "MU";
  CountryCodesAlpha22["Yt"] = "YT";
  CountryCodesAlpha22["Mx"] = "MX";
  CountryCodesAlpha22["Fm"] = "FM";
  CountryCodesAlpha22["Md"] = "MD";
  CountryCodesAlpha22["Mc"] = "MC";
  CountryCodesAlpha22["Mn"] = "MN";
  CountryCodesAlpha22["Me"] = "ME";
  CountryCodesAlpha22["Ms"] = "MS";
  CountryCodesAlpha22["Ma"] = "MA";
  CountryCodesAlpha22["Mz"] = "MZ";
  CountryCodesAlpha22["Mm"] = "MM";
  CountryCodesAlpha22["Na"] = "NA";
  CountryCodesAlpha22["Nr"] = "NR";
  CountryCodesAlpha22["Np"] = "NP";
  CountryCodesAlpha22["Nl"] = "NL";
  CountryCodesAlpha22["Nc"] = "NC";
  CountryCodesAlpha22["Nz"] = "NZ";
  CountryCodesAlpha22["Ni"] = "NI";
  CountryCodesAlpha22["Ne"] = "NE";
  CountryCodesAlpha22["Ng"] = "NG";
  CountryCodesAlpha22["Nu"] = "NU";
  CountryCodesAlpha22["Nf"] = "NF";
  CountryCodesAlpha22["Mp"] = "MP";
  CountryCodesAlpha22["No"] = "NO";
  CountryCodesAlpha22["Om"] = "OM";
  CountryCodesAlpha22["Pk"] = "PK";
  CountryCodesAlpha22["Pw"] = "PW";
  CountryCodesAlpha22["Ps"] = "PS";
  CountryCodesAlpha22["Pa"] = "PA";
  CountryCodesAlpha22["Pg"] = "PG";
  CountryCodesAlpha22["Py"] = "PY";
  CountryCodesAlpha22["Pe"] = "PE";
  CountryCodesAlpha22["Ph"] = "PH";
  CountryCodesAlpha22["Pn"] = "PN";
  CountryCodesAlpha22["Pl"] = "PL";
  CountryCodesAlpha22["Pt"] = "PT";
  CountryCodesAlpha22["Pr"] = "PR";
  CountryCodesAlpha22["Qa"] = "QA";
  CountryCodesAlpha22["Re"] = "RE";
  CountryCodesAlpha22["Ro"] = "RO";
  CountryCodesAlpha22["Ru"] = "RU";
  CountryCodesAlpha22["Rw"] = "RW";
  CountryCodesAlpha22["Bl"] = "BL";
  CountryCodesAlpha22["Sh"] = "SH";
  CountryCodesAlpha22["Kn"] = "KN";
  CountryCodesAlpha22["Lc"] = "LC";
  CountryCodesAlpha22["Mf"] = "MF";
  CountryCodesAlpha22["Pm"] = "PM";
  CountryCodesAlpha22["Vc"] = "VC";
  CountryCodesAlpha22["Ws"] = "WS";
  CountryCodesAlpha22["Sm"] = "SM";
  CountryCodesAlpha22["St"] = "ST";
  CountryCodesAlpha22["Sa"] = "SA";
  CountryCodesAlpha22["Sn"] = "SN";
  CountryCodesAlpha22["Rs"] = "RS";
  CountryCodesAlpha22["Sc"] = "SC";
  CountryCodesAlpha22["Sl"] = "SL";
  CountryCodesAlpha22["Sg"] = "SG";
  CountryCodesAlpha22["Sx"] = "SX";
  CountryCodesAlpha22["Sk"] = "SK";
  CountryCodesAlpha22["Si"] = "SI";
  CountryCodesAlpha22["Sb"] = "SB";
  CountryCodesAlpha22["So"] = "SO";
  CountryCodesAlpha22["Za"] = "ZA";
  CountryCodesAlpha22["Gs"] = "GS";
  CountryCodesAlpha22["Ss"] = "SS";
  CountryCodesAlpha22["Es"] = "ES";
  CountryCodesAlpha22["Lk"] = "LK";
  CountryCodesAlpha22["Sd"] = "SD";
  CountryCodesAlpha22["Sr"] = "SR";
  CountryCodesAlpha22["Sj"] = "SJ";
  CountryCodesAlpha22["Sz"] = "SZ";
  CountryCodesAlpha22["Se"] = "SE";
  CountryCodesAlpha22["Ch"] = "CH";
  CountryCodesAlpha22["Sy"] = "SY";
  CountryCodesAlpha22["Tw"] = "TW";
  CountryCodesAlpha22["Tj"] = "TJ";
  CountryCodesAlpha22["Tz"] = "TZ";
  CountryCodesAlpha22["Th"] = "TH";
  CountryCodesAlpha22["Tl"] = "TL";
  CountryCodesAlpha22["Tg"] = "TG";
  CountryCodesAlpha22["Tk"] = "TK";
  CountryCodesAlpha22["To"] = "TO";
  CountryCodesAlpha22["Tt"] = "TT";
  CountryCodesAlpha22["Tn"] = "TN";
  CountryCodesAlpha22["Tr"] = "TR";
  CountryCodesAlpha22["Tm"] = "TM";
  CountryCodesAlpha22["Tc"] = "TC";
  CountryCodesAlpha22["Tv"] = "TV";
  CountryCodesAlpha22["Ug"] = "UG";
  CountryCodesAlpha22["Ua"] = "UA";
  CountryCodesAlpha22["Ae"] = "AE";
  CountryCodesAlpha22["Gb"] = "GB";
  CountryCodesAlpha22["Us"] = "US";
  CountryCodesAlpha22["Um"] = "UM";
  CountryCodesAlpha22["Uy"] = "UY";
  CountryCodesAlpha22["Uz"] = "UZ";
  CountryCodesAlpha22["Vu"] = "VU";
  CountryCodesAlpha22["Ve"] = "VE";
  CountryCodesAlpha22["Vn"] = "VN";
  CountryCodesAlpha22["Vg"] = "VG";
  CountryCodesAlpha22["Vi"] = "VI";
  CountryCodesAlpha22["Wf"] = "WF";
  CountryCodesAlpha22["Eh"] = "EH";
  CountryCodesAlpha22["Ye"] = "YE";
  CountryCodesAlpha22["Zm"] = "ZM";
  CountryCodesAlpha22["Zw"] = "ZW";
  return CountryCodesAlpha22;
})(CountryCodesAlpha2 || {});
var CountryFilter = /* @__PURE__ */ ((CountryFilter2) => {
  CountryFilter2["Top"] = "TOP";
  CountryFilter2["Other"] = "OTHER";
  CountryFilter2["All"] = "ALL";
  return CountryFilter2;
})(CountryFilter || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["Aed"] = "AED";
  Currency2["Afn"] = "AFN";
  Currency2["All"] = "ALL";
  Currency2["Amd"] = "AMD";
  Currency2["Ang"] = "ANG";
  Currency2["Aoa"] = "AOA";
  Currency2["Ars"] = "ARS";
  Currency2["Aud"] = "AUD";
  Currency2["Awg"] = "AWG";
  Currency2["Azn"] = "AZN";
  Currency2["Bam"] = "BAM";
  Currency2["Bbd"] = "BBD";
  Currency2["Bdt"] = "BDT";
  Currency2["Bgn"] = "BGN";
  Currency2["Bhd"] = "BHD";
  Currency2["Bif"] = "BIF";
  Currency2["Bmd"] = "BMD";
  Currency2["Bnd"] = "BND";
  Currency2["Bob"] = "BOB";
  Currency2["Bov"] = "BOV";
  Currency2["Brl"] = "BRL";
  Currency2["Bsd"] = "BSD";
  Currency2["Btn"] = "BTN";
  Currency2["Bwp"] = "BWP";
  Currency2["Byn"] = "BYN";
  Currency2["Bzd"] = "BZD";
  Currency2["Cad"] = "CAD";
  Currency2["Cdf"] = "CDF";
  Currency2["Che"] = "CHE";
  Currency2["Chf"] = "CHF";
  Currency2["Chw"] = "CHW";
  Currency2["Clf"] = "CLF";
  Currency2["Clp"] = "CLP";
  Currency2["Cny"] = "CNY";
  Currency2["Cop"] = "COP";
  Currency2["Cou"] = "COU";
  Currency2["Crc"] = "CRC";
  Currency2["Cuc"] = "CUC";
  Currency2["Cup"] = "CUP";
  Currency2["Cve"] = "CVE";
  Currency2["Czk"] = "CZK";
  Currency2["Djf"] = "DJF";
  Currency2["Dkk"] = "DKK";
  Currency2["Dop"] = "DOP";
  Currency2["Dzd"] = "DZD";
  Currency2["Egp"] = "EGP";
  Currency2["Ern"] = "ERN";
  Currency2["Etb"] = "ETB";
  Currency2["Eur"] = "EUR";
  Currency2["Fjd"] = "FJD";
  Currency2["Fkp"] = "FKP";
  Currency2["Gbp"] = "GBP";
  Currency2["Gel"] = "GEL";
  Currency2["Ghs"] = "GHS";
  Currency2["Gip"] = "GIP";
  Currency2["Gmd"] = "GMD";
  Currency2["Gnf"] = "GNF";
  Currency2["Gtq"] = "GTQ";
  Currency2["Gyd"] = "GYD";
  Currency2["Hkd"] = "HKD";
  Currency2["Hnl"] = "HNL";
  Currency2["Hrk"] = "HRK";
  Currency2["Htg"] = "HTG";
  Currency2["Huf"] = "HUF";
  Currency2["Idr"] = "IDR";
  Currency2["Ils"] = "ILS";
  Currency2["Inr"] = "INR";
  Currency2["Iqd"] = "IQD";
  Currency2["Irr"] = "IRR";
  Currency2["Isk"] = "ISK";
  Currency2["Jmd"] = "JMD";
  Currency2["Jod"] = "JOD";
  Currency2["Jpy"] = "JPY";
  Currency2["Kes"] = "KES";
  Currency2["Kgs"] = "KGS";
  Currency2["Khr"] = "KHR";
  Currency2["Kmf"] = "KMF";
  Currency2["Kpw"] = "KPW";
  Currency2["Krw"] = "KRW";
  Currency2["Kwd"] = "KWD";
  Currency2["Kyd"] = "KYD";
  Currency2["Kzt"] = "KZT";
  Currency2["Lak"] = "LAK";
  Currency2["Lbp"] = "LBP";
  Currency2["Lkr"] = "LKR";
  Currency2["Lrd"] = "LRD";
  Currency2["Lsl"] = "LSL";
  Currency2["Lyd"] = "LYD";
  Currency2["Mad"] = "MAD";
  Currency2["Mdl"] = "MDL";
  Currency2["Mga"] = "MGA";
  Currency2["Mkd"] = "MKD";
  Currency2["Mmk"] = "MMK";
  Currency2["Mnt"] = "MNT";
  Currency2["Mop"] = "MOP";
  Currency2["Mru"] = "MRU";
  Currency2["Mur"] = "MUR";
  Currency2["Mvr"] = "MVR";
  Currency2["Mwk"] = "MWK";
  Currency2["Mxn"] = "MXN";
  Currency2["Mxv"] = "MXV";
  Currency2["Myr"] = "MYR";
  Currency2["Mzn"] = "MZN";
  Currency2["Nad"] = "NAD";
  Currency2["Ngn"] = "NGN";
  Currency2["Nio"] = "NIO";
  Currency2["Nok"] = "NOK";
  Currency2["Npr"] = "NPR";
  Currency2["Nzd"] = "NZD";
  Currency2["Omr"] = "OMR";
  Currency2["Pab"] = "PAB";
  Currency2["Pen"] = "PEN";
  Currency2["Pgk"] = "PGK";
  Currency2["Php"] = "PHP";
  Currency2["Pkr"] = "PKR";
  Currency2["Pln"] = "PLN";
  Currency2["Pyg"] = "PYG";
  Currency2["Qar"] = "QAR";
  Currency2["Ron"] = "RON";
  Currency2["Rsd"] = "RSD";
  Currency2["Rub"] = "RUB";
  Currency2["Rwf"] = "RWF";
  Currency2["Sar"] = "SAR";
  Currency2["Sbd"] = "SBD";
  Currency2["Scr"] = "SCR";
  Currency2["Sdg"] = "SDG";
  Currency2["Sek"] = "SEK";
  Currency2["Sgd"] = "SGD";
  Currency2["Shp"] = "SHP";
  Currency2["Sll"] = "SLL";
  Currency2["Sos"] = "SOS";
  Currency2["Srd"] = "SRD";
  Currency2["Ssp"] = "SSP";
  Currency2["Stn"] = "STN";
  Currency2["Svc"] = "SVC";
  Currency2["Syp"] = "SYP";
  Currency2["Szl"] = "SZL";
  Currency2["Thb"] = "THB";
  Currency2["Tjs"] = "TJS";
  Currency2["Tmt"] = "TMT";
  Currency2["Tnd"] = "TND";
  Currency2["Top"] = "TOP";
  Currency2["Try"] = "TRY";
  Currency2["Ttd"] = "TTD";
  Currency2["Twd"] = "TWD";
  Currency2["Tzs"] = "TZS";
  Currency2["Uah"] = "UAH";
  Currency2["Ugx"] = "UGX";
  Currency2["Usd"] = "USD";
  Currency2["Usn"] = "USN";
  Currency2["Uyi"] = "UYI";
  Currency2["Uyu"] = "UYU";
  Currency2["Uyw"] = "UYW";
  Currency2["Uzs"] = "UZS";
  Currency2["Ves"] = "VES";
  Currency2["Vnd"] = "VND";
  Currency2["Vuv"] = "VUV";
  Currency2["Wst"] = "WST";
  Currency2["Xaf"] = "XAF";
  Currency2["Xag"] = "XAG";
  Currency2["Xau"] = "XAU";
  Currency2["Xba"] = "XBA";
  Currency2["Xbb"] = "XBB";
  Currency2["Xbc"] = "XBC";
  Currency2["Xbd"] = "XBD";
  Currency2["Xcd"] = "XCD";
  Currency2["Xdr"] = "XDR";
  Currency2["Xof"] = "XOF";
  Currency2["Xpd"] = "XPD";
  Currency2["Xpf"] = "XPF";
  Currency2["Xpt"] = "XPT";
  Currency2["Xsu"] = "XSU";
  Currency2["Xts"] = "XTS";
  Currency2["Xua"] = "XUA";
  Currency2["Xxx"] = "XXX";
  Currency2["Yer"] = "YER";
  Currency2["Zar"] = "ZAR";
  Currency2["Zmw"] = "ZMW";
  Currency2["Zwl"] = "ZWL";
  return Currency2;
})(Currency || {});
var DataSharingExclusionType = /* @__PURE__ */ ((DataSharingExclusionType2) => {
  DataSharingExclusionType2["PrivateData"] = "PRIVATE_DATA";
  DataSharingExclusionType2["BusinessData"] = "BUSINESS_DATA";
  DataSharingExclusionType2["DateOfBirth"] = "DATE_OF_BIRTH";
  return DataSharingExclusionType2;
})(DataSharingExclusionType || {});
var DiscoFeature = /* @__PURE__ */ ((DiscoFeature2) => {
  DiscoFeature2["MultipleModulesOnNu"] = "Multiple_Modules_on_NU";
  DiscoFeature2["DiscoJobRecoType"] = "DISCO_JOB_RECO_TYPE";
  DiscoFeature2["JobRecoModule"] = "JOB_RECO_MODULE";
  return DiscoFeature2;
})(DiscoFeature || {});
var DiscoLoggingReason = /* @__PURE__ */ ((DiscoLoggingReason2) => {
  DiscoLoggingReason2["NullableField"] = "NULLABLE_FIELD";
  DiscoLoggingReason2["NullableModule"] = "NULLABLE_MODULE";
  DiscoLoggingReason2["UnsupportedType"] = "UNSUPPORTED_TYPE";
  return DiscoLoggingReason2;
})(DiscoLoggingReason || {});
var DiscoModuleRenderingType = /* @__PURE__ */ ((DiscoModuleRenderingType2) => {
  DiscoModuleRenderingType2["TypeA"] = "Type_A";
  DiscoModuleRenderingType2["TypeB"] = "Type_B";
  DiscoModuleRenderingType2["TypeC"] = "Type_C";
  return DiscoModuleRenderingType2;
})(DiscoModuleRenderingType || {});
var DiscoPlatform = /* @__PURE__ */ ((DiscoPlatform2) => {
  DiscoPlatform2["Web"] = "WEB";
  DiscoPlatform2["Android"] = "ANDROID";
  DiscoPlatform2["Ios"] = "IOS";
  DiscoPlatform2["Unknown"] = "UNKNOWN";
  return DiscoPlatform2;
})(DiscoPlatform || {});
var DiscoTopicSearchSorting = /* @__PURE__ */ ((DiscoTopicSearchSorting2) => {
  DiscoTopicSearchSorting2["Relevance"] = "RELEVANCE";
  DiscoTopicSearchSorting2["Alphabetical"] = "ALPHABETICAL";
  return DiscoTopicSearchSorting2;
})(DiscoTopicSearchSorting || {});
var DisplayFlag = /* @__PURE__ */ ((DisplayFlag2) => {
  DisplayFlag2["ModeratorPremium"] = "MODERATOR_PREMIUM";
  DisplayFlag2["Procoach"] = "PROCOACH";
  DisplayFlag2["Premium"] = "PREMIUM";
  DisplayFlag2["Executive"] = "EXECUTIVE";
  DisplayFlag2["Insider"] = "INSIDER";
  DisplayFlag2["Moderator"] = "MODERATOR";
  DisplayFlag2["Ambassador"] = "AMBASSADOR";
  DisplayFlag2["Basic"] = "BASIC";
  return DisplayFlag2;
})(DisplayFlag || {});
var EntityMediaType = /* @__PURE__ */ ((EntityMediaType2) => {
  EntityMediaType2["Image"] = "IMAGE";
  return EntityMediaType2;
})(EntityMediaType || {});
var EntityPageContractType = /* @__PURE__ */ ((EntityPageContractType2) => {
  EntityPageContractType2["None"] = "NONE";
  EntityPageContractType2["Free"] = "FREE";
  EntityPageContractType2["Paid"] = "PAID";
  EntityPageContractType2["PaidPlus"] = "PAID_PLUS";
  return EntityPageContractType2;
})(EntityPageContractType || {});
var EntityPageCoverMediaType = /* @__PURE__ */ ((EntityPageCoverMediaType2) => {
  EntityPageCoverMediaType2["Image"] = "IMAGE";
  return EntityPageCoverMediaType2;
})(EntityPageCoverMediaType || {});
var EntityPageDemographicsKpi = /* @__PURE__ */ ((EntityPageDemographicsKpi2) => {
  EntityPageDemographicsKpi2["Followers"] = "FOLLOWERS";
  EntityPageDemographicsKpi2["Visitors"] = "VISITORS";
  return EntityPageDemographicsKpi2;
})(EntityPageDemographicsKpi || {});
var EntityPageFocusType = /* @__PURE__ */ ((EntityPageFocusType2) => {
  EntityPageFocusType2["Company"] = "COMPANY";
  EntityPageFocusType2["IndustryPage"] = "INDUSTRY_PAGE";
  EntityPageFocusType2["Publisher"] = "PUBLISHER";
  EntityPageFocusType2["TopicPage"] = "TOPIC_PAGE";
  EntityPageFocusType2["GroupPage"] = "GROUP_PAGE";
  return EntityPageFocusType2;
})(EntityPageFocusType || {});
var EntityPageInsightsGranularity = /* @__PURE__ */ ((EntityPageInsightsGranularity2) => {
  EntityPageInsightsGranularity2["Day"] = "DAY";
  EntityPageInsightsGranularity2["Week"] = "WEEK";
  EntityPageInsightsGranularity2["Month"] = "MONTH";
  return EntityPageInsightsGranularity2;
})(EntityPageInsightsGranularity || {});
var EntityPageParentPage = /* @__PURE__ */ ((EntityPageParentPage2) => {
  EntityPageParentPage2["CompaniesLandingPage"] = "COMPANIES_LANDING_PAGE";
  EntityPageParentPage2["NewsLandingPage"] = "NEWS_LANDING_PAGE";
  EntityPageParentPage2["GroupPagesLandingPage"] = "GROUP_PAGES_LANDING_PAGE";
  return EntityPageParentPage2;
})(EntityPageParentPage || {});
var EntityPagePublicationStatus = /* @__PURE__ */ ((EntityPagePublicationStatus2) => {
  EntityPagePublicationStatus2["Created"] = "CREATED";
  EntityPagePublicationStatus2["Draft"] = "DRAFT";
  EntityPagePublicationStatus2["Published"] = "PUBLISHED";
  return EntityPagePublicationStatus2;
})(EntityPagePublicationStatus || {});
var EntityPageSocialProofType = /* @__PURE__ */ ((EntityPageSocialProofType2) => {
  EntityPageSocialProofType2["Followers"] = "FOLLOWERS";
  EntityPageSocialProofType2["Employees"] = "EMPLOYEES";
  EntityPageSocialProofType2["Members"] = "MEMBERS";
  return EntityPageSocialProofType2;
})(EntityPageSocialProofType || {});
var EntityPageSupportedContentObjectTypes = /* @__PURE__ */ ((EntityPageSupportedContentObjectTypes2) => {
  EntityPageSupportedContentObjectTypes2["PlainTextPosting"] = "PLAIN_TEXT_POSTING";
  EntityPageSupportedContentObjectTypes2["ArticlePosting"] = "ARTICLE_POSTING";
  EntityPageSupportedContentObjectTypes2["ImagePosting"] = "IMAGE_POSTING";
  EntityPageSupportedContentObjectTypes2["LinkSharePosting"] = "LINK_SHARE_POSTING";
  EntityPageSupportedContentObjectTypes2["VideoPosting"] = "VIDEO_POSTING";
  EntityPageSupportedContentObjectTypes2["ContentPageArticle"] = "CONTENT_PAGE_ARTICLE";
  EntityPageSupportedContentObjectTypes2["CompanyPageArticle"] = "COMPANY_PAGE_ARTICLE";
  return EntityPageSupportedContentObjectTypes2;
})(EntityPageSupportedContentObjectTypes || {});
var EntityPageTrackVisitorPlatform = /* @__PURE__ */ ((EntityPageTrackVisitorPlatform2) => {
  EntityPageTrackVisitorPlatform2["Web"] = "WEB";
  EntityPageTrackVisitorPlatform2["Android"] = "ANDROID";
  EntityPageTrackVisitorPlatform2["Ios"] = "IOS";
  return EntityPageTrackVisitorPlatform2;
})(EntityPageTrackVisitorPlatform || {});
var EntityPageUserRole = /* @__PURE__ */ ((EntityPageUserRole2) => {
  EntityPageUserRole2["Administrator"] = "ADMINISTRATOR";
  EntityPageUserRole2["Editor"] = "EDITOR";
  EntityPageUserRole2["Member"] = "MEMBER";
  EntityPageUserRole2["Owner"] = "OWNER";
  return EntityPageUserRole2;
})(EntityPageUserRole || {});
var EntityPageVisibility = /* @__PURE__ */ ((EntityPageVisibility2) => {
  EntityPageVisibility2["Public"] = "PUBLIC";
  EntityPageVisibility2["Private"] = "PRIVATE";
  return EntityPageVisibility2;
})(EntityPageVisibility || {});
var EntityTypeValue = /* @__PURE__ */ ((EntityTypeValue2) => {
  EntityTypeValue2["Page"] = "PAGE";
  EntityTypeValue2["Insider"] = "INSIDER";
  EntityTypeValue2["Article"] = "ARTICLE";
  return EntityTypeValue2;
})(EntityTypeValue || {});
var ErecruitingSourcingServiceBriefingWeightFactors = /* @__PURE__ */ ((ErecruitingSourcingServiceBriefingWeightFactors2) => {
  ErecruitingSourcingServiceBriefingWeightFactors2["Skills"] = "SKILLS";
  ErecruitingSourcingServiceBriefingWeightFactors2["CareerLevel"] = "CAREER_LEVEL";
  ErecruitingSourcingServiceBriefingWeightFactors2["JobTitle"] = "JOB_TITLE";
  ErecruitingSourcingServiceBriefingWeightFactors2["Languages"] = "LANGUAGES";
  ErecruitingSourcingServiceBriefingWeightFactors2["Location"] = "LOCATION";
  return ErecruitingSourcingServiceBriefingWeightFactors2;
})(ErecruitingSourcingServiceBriefingWeightFactors || {});
var ErecruitingSourcingServiceMessageTone = /* @__PURE__ */ ((ErecruitingSourcingServiceMessageTone2) => {
  ErecruitingSourcingServiceMessageTone2["Formal"] = "FORMAL";
  ErecruitingSourcingServiceMessageTone2["Informal"] = "INFORMAL";
  return ErecruitingSourcingServiceMessageTone2;
})(ErecruitingSourcingServiceMessageTone || {});
var ErecruitingSourcingServiceProductType = /* @__PURE__ */ ((ErecruitingSourcingServiceProductType2) => {
  ErecruitingSourcingServiceProductType2["Shortlist"] = "SHORTLIST";
  ErecruitingSourcingServiceProductType2["Longlist"] = "LONGLIST";
  return ErecruitingSourcingServiceProductType2;
})(ErecruitingSourcingServiceProductType || {});
var ErecruitingSourcingServiceProductTypeLowCase = /* @__PURE__ */ ((ErecruitingSourcingServiceProductTypeLowCase2) => {
  ErecruitingSourcingServiceProductTypeLowCase2["Shortlist"] = "shortlist";
  ErecruitingSourcingServiceProductTypeLowCase2["Longlist"] = "longlist";
  return ErecruitingSourcingServiceProductTypeLowCase2;
})(ErecruitingSourcingServiceProductTypeLowCase || {});
var EventCategory = /* @__PURE__ */ ((EventCategory2) => {
  EventCategory2["CorpEventsAndMeetings"] = "CORP_EVENTS_AND_MEETINGS";
  EventCategory2["ConferencesAndExhibitions"] = "CONFERENCES_AND_EXHIBITIONS";
  EventCategory2["SeminarsWorkshopsAndLectures"] = "SEMINARS_WORKSHOPS_AND_LECTURES";
  EventCategory2["EntertainmentAndLeisure"] = "ENTERTAINMENT_AND_LEISURE";
  EventCategory2["NetworkingEvents"] = "NETWORKING_EVENTS";
  EventCategory2["OtherEvents"] = "OTHER_EVENTS";
  EventCategory2["TradeFairsAndExhibitions"] = "TRADE_FAIRS_AND_EXHIBITIONS";
  EventCategory2["PrivateEvents"] = "PRIVATE_EVENTS";
  return EventCategory2;
})(EventCategory || {});
var EventCommunityEventOrderBy = /* @__PURE__ */ ((EventCommunityEventOrderBy2) => {
  EventCommunityEventOrderBy2["Id"] = "ID";
  EventCommunityEventOrderBy2["StartsAt"] = "STARTS_AT";
  return EventCommunityEventOrderBy2;
})(EventCommunityEventOrderBy || {});
var EventContextFilter = /* @__PURE__ */ ((EventContextFilter2) => {
  EventContextFilter2["Organized"] = "ORGANIZED";
  EventContextFilter2["SaidYes"] = "SAID_YES";
  EventContextFilter2["SaidMaybe"] = "SAID_MAYBE";
  EventContextFilter2["MyEvents"] = "MY_EVENTS";
  EventContextFilter2["ProfileVisible"] = "PROFILE_VISIBLE";
  return EventContextFilter2;
})(EventContextFilter || {});
var EventDraftFilter = /* @__PURE__ */ ((EventDraftFilter2) => {
  EventDraftFilter2["All"] = "ALL";
  EventDraftFilter2["ExcludeDraftEvents"] = "EXCLUDE_DRAFT_EVENTS";
  EventDraftFilter2["OnlyDraftEvents"] = "ONLY_DRAFT_EVENTS";
  return EventDraftFilter2;
})(EventDraftFilter || {});
var EventGuestlistVisibilities = /* @__PURE__ */ ((EventGuestlistVisibilities2) => {
  EventGuestlistVisibilities2["XingMembers"] = "XING_MEMBERS";
  EventGuestlistVisibilities2["Invited"] = "INVITED";
  EventGuestlistVisibilities2["Organizer"] = "ORGANIZER";
  return EventGuestlistVisibilities2;
})(EventGuestlistVisibilities || {});
var EventInvitationReason = /* @__PURE__ */ ((EventInvitationReason2) => {
  EventInvitationReason2["Visitor"] = "VISITOR";
  EventInvitationReason2["Group"] = "GROUP";
  EventInvitationReason2["PastAttendees"] = "PAST_ATTENDEES";
  return EventInvitationReason2;
})(EventInvitationReason || {});
var EventInvitationToolCreateMutationErrorReason = /* @__PURE__ */ ((EventInvitationToolCreateMutationErrorReason2) => {
  EventInvitationToolCreateMutationErrorReason2["Length"] = "LENGTH";
  EventInvitationToolCreateMutationErrorReason2["Emojis"] = "EMOJIS";
  EventInvitationToolCreateMutationErrorReason2["Links"] = "LINKS";
  return EventInvitationToolCreateMutationErrorReason2;
})(EventInvitationToolCreateMutationErrorReason || {});
var EventInvitationToolTypes = /* @__PURE__ */ ((EventInvitationToolTypes2) => {
  EventInvitationToolTypes2["Contacts"] = "CONTACTS";
  EventInvitationToolTypes2["Groups"] = "GROUPS";
  EventInvitationToolTypes2["PastAttendees"] = "PAST_ATTENDEES";
  EventInvitationToolTypes2["PastEventAttendees"] = "PAST_EVENT_ATTENDEES";
  EventInvitationToolTypes2["PastAttendeesGroup"] = "PAST_ATTENDEES_GROUP";
  EventInvitationToolTypes2["Visitors"] = "VISITORS";
  return EventInvitationToolTypes2;
})(EventInvitationToolTypes || {});
var EventLastVisitLocation = /* @__PURE__ */ ((EventLastVisitLocation2) => {
  EventLastVisitLocation2["Visitors"] = "VISITORS";
  EventLastVisitLocation2["Guestlist"] = "GUESTLIST";
  return EventLastVisitLocation2;
})(EventLastVisitLocation || {});
var EventNoRsvpReason = /* @__PURE__ */ ((EventNoRsvpReason2) => {
  EventNoRsvpReason2["PastEvent"] = "PAST_EVENT";
  EventNoRsvpReason2["DeadlinePassed"] = "DEADLINE_PASSED";
  EventNoRsvpReason2["SoldOut"] = "SOLD_OUT";
  return EventNoRsvpReason2;
})(EventNoRsvpReason || {});
var EventOrganizerType = /* @__PURE__ */ ((EventOrganizerType2) => {
  EventOrganizerType2["User"] = "USER";
  EventOrganizerType2["Company"] = "COMPANY";
  EventOrganizerType2["Group"] = "GROUP";
  EventOrganizerType2["Name"] = "NAME";
  return EventOrganizerType2;
})(EventOrganizerType || {});
var EventParticipantsOrder = /* @__PURE__ */ ((EventParticipantsOrder2) => {
  EventParticipantsOrder2["RegistrationDate"] = "REGISTRATION_DATE";
  return EventParticipantsOrder2;
})(EventParticipantsOrder || {});
var EventParticipationKind = /* @__PURE__ */ ((EventParticipationKind2) => {
  EventParticipationKind2["Yes"] = "YES";
  EventParticipationKind2["No"] = "NO";
  EventParticipationKind2["Maybe"] = "MAYBE";
  EventParticipationKind2["Unanswered"] = "UNANSWERED";
  return EventParticipationKind2;
})(EventParticipationKind || {});
var EventRsvpOptionState = /* @__PURE__ */ ((EventRsvpOptionState2) => {
  EventRsvpOptionState2["Selected"] = "SELECTED";
  EventRsvpOptionState2["Available"] = "AVAILABLE";
  EventRsvpOptionState2["Unavailable"] = "UNAVAILABLE";
  return EventRsvpOptionState2;
})(EventRsvpOptionState || {});
var EventTicketingFilter = /* @__PURE__ */ ((EventTicketingFilter2) => {
  EventTicketingFilter2["All"] = "ALL";
  EventTicketingFilter2["ExcludeTicketingEvents"] = "EXCLUDE_TICKETING_EVENTS";
  EventTicketingFilter2["OnlyTicketingEvents"] = "ONLY_TICKETING_EVENTS";
  return EventTicketingFilter2;
})(EventTicketingFilter || {});
var EventTimeFilter = /* @__PURE__ */ ((EventTimeFilter2) => {
  EventTimeFilter2["Past"] = "PAST";
  EventTimeFilter2["Upcoming"] = "UPCOMING";
  return EventTimeFilter2;
})(EventTimeFilter || {});
var EventUserMessageReason = /* @__PURE__ */ ((EventUserMessageReason2) => {
  EventUserMessageReason2["Visitor"] = "VISITOR";
  EventUserMessageReason2["Group"] = "GROUP";
  EventUserMessageReason2["PastAttendees"] = "PAST_ATTENDEES";
  return EventUserMessageReason2;
})(EventUserMessageReason || {});
var EventUserMessageType = /* @__PURE__ */ ((EventUserMessageType2) => {
  EventUserMessageType2["Invitation"] = "INVITATION";
  EventUserMessageType2["Cancellation"] = "CANCELLATION";
  EventUserMessageType2["Disinvite"] = "DISINVITE";
  EventUserMessageType2["Guestlist"] = "GUESTLIST";
  EventUserMessageType2["Modification"] = "MODIFICATION";
  EventUserMessageType2["Rescheduling"] = "RESCHEDULING";
  return EventUserMessageType2;
})(EventUserMessageType || {});
var EventVisibilities = /* @__PURE__ */ ((EventVisibilities2) => {
  EventVisibilities2["Public"] = "PUBLIC";
  EventVisibilities2["Private"] = "PRIVATE";
  return EventVisibilities2;
})(EventVisibilities || {});
var EventVisitorsFilters = /* @__PURE__ */ ((EventVisitorsFilters2) => {
  EventVisitorsFilters2["All"] = "ALL";
  EventVisitorsFilters2["Invited"] = "INVITED";
  EventVisitorsFilters2["NotInvited"] = "NOT_INVITED";
  return EventVisitorsFilters2;
})(EventVisitorsFilters || {});
var EventVisitorsSorting = /* @__PURE__ */ ((EventVisitorsSorting2) => {
  EventVisitorsSorting2["LastVisit"] = "LAST_VISIT";
  EventVisitorsSorting2["VisitCount"] = "VISIT_COUNT";
  return EventVisitorsSorting2;
})(EventVisitorsSorting || {});
var EventWaitingListState = /* @__PURE__ */ ((EventWaitingListState2) => {
  EventWaitingListState2["Available"] = "AVAILABLE";
  EventWaitingListState2["NotAvailable"] = "NOT_AVAILABLE";
  EventWaitingListState2["Waiting"] = "WAITING";
  return EventWaitingListState2;
})(EventWaitingListState || {});
var EventWebinarLinkState = /* @__PURE__ */ ((EventWebinarLinkState2) => {
  EventWebinarLinkState2["Visible"] = "VISIBLE";
  EventWebinarLinkState2["ToCome"] = "TO_COME";
  EventWebinarLinkState2["None"] = "NONE";
  EventWebinarLinkState2["SignUp"] = "SIGN_UP";
  return EventWebinarLinkState2;
})(EventWebinarLinkState || {});
var EventsOrderBy = /* @__PURE__ */ ((EventsOrderBy2) => {
  EventsOrderBy2["Id"] = "ID";
  EventsOrderBy2["StartsAt"] = "STARTS_AT";
  EventsOrderBy2["UpdatedAt"] = "UPDATED_AT";
  return EventsOrderBy2;
})(EventsOrderBy || {});
var EventsType = /* @__PURE__ */ ((EventsType2) => {
  EventsType2["Group"] = "GROUP";
  EventsType2["GroupsGroup"] = "GROUPS_GROUP";
  EventsType2["Company"] = "COMPANY";
  return EventsType2;
})(EventsType || {});
var FollowersFollowingNamespace = /* @__PURE__ */ ((FollowersFollowingNamespace2) => {
  FollowersFollowingNamespace2["Companies"] = "COMPANIES";
  FollowersFollowingNamespace2["Disco"] = "DISCO";
  FollowersFollowingNamespace2["Entitypages"] = "ENTITYPAGES";
  return FollowersFollowingNamespace2;
})(FollowersFollowingNamespace || {});
var FollowersFollowingOrder = /* @__PURE__ */ ((FollowersFollowingOrder2) => {
  FollowersFollowingOrder2["Asc"] = "ASC";
  FollowersFollowingOrder2["Desc"] = "DESC";
  return FollowersFollowingOrder2;
})(FollowersFollowingOrder || {});
var FollowersFollowingSort = /* @__PURE__ */ ((FollowersFollowingSort2) => {
  FollowersFollowingSort2["UserId"] = "USER_ID";
  FollowersFollowingSort2["UpdatedAt"] = "UPDATED_AT";
  return FollowersFollowingSort2;
})(FollowersFollowingSort || {});
var FollowersFollowingType = /* @__PURE__ */ ((FollowersFollowingType2) => {
  FollowersFollowingType2["Company"] = "COMPANY";
  FollowersFollowingType2["Topic"] = "TOPIC";
  FollowersFollowingType2["Page"] = "PAGE";
  return FollowersFollowingType2;
})(FollowersFollowingType || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["Male"] = "MALE";
  Gender2["Female"] = "FEMALE";
  Gender2["Other"] = "OTHER";
  Gender2["None"] = "NONE";
  return Gender2;
})(Gender || {});
var GroupMode = /* @__PURE__ */ ((GroupMode2) => {
  GroupMode2["Local"] = "LOCAL";
  GroupMode2["Online"] = "ONLINE";
  return GroupMode2;
})(GroupMode || {});
var GroupsErrorType = /* @__PURE__ */ ((GroupsErrorType2) => {
  GroupsErrorType2["AccessDenied"] = "ACCESS_DENIED";
  GroupsErrorType2["Invalid"] = "INVALID";
  GroupsErrorType2["ParameterMissing"] = "PARAMETER_MISSING";
  GroupsErrorType2["RecordNotFound"] = "RECORD_NOT_FOUND";
  GroupsErrorType2["RecordNotDestroyed"] = "RECORD_NOT_DESTROYED";
  return GroupsErrorType2;
})(GroupsErrorType || {});
var GroupsGroupEventFrequency = /* @__PURE__ */ ((GroupsGroupEventFrequency2) => {
  GroupsGroupEventFrequency2["Once"] = "ONCE";
  GroupsGroupEventFrequency2["TwoOrThreeTimes"] = "TWO_OR_THREE_TIMES";
  GroupsGroupEventFrequency2["FourOrFiveTimes"] = "FOUR_OR_FIVE_TIMES";
  GroupsGroupEventFrequency2["SixOrMoreTimes"] = "SIX_OR_MORE_TIMES";
  return GroupsGroupEventFrequency2;
})(GroupsGroupEventFrequency || {});
var GroupsGroupEventsOrderBy = /* @__PURE__ */ ((GroupsGroupEventsOrderBy2) => {
  GroupsGroupEventsOrderBy2["Id"] = "ID";
  GroupsGroupEventsOrderBy2["StartsAt"] = "STARTS_AT";
  return GroupsGroupEventsOrderBy2;
})(GroupsGroupEventsOrderBy || {});
var GroupsGroupState = /* @__PURE__ */ ((GroupsGroupState2) => {
  GroupsGroupState2["Incomplete"] = "INCOMPLETE";
  GroupsGroupState2["PendingApproval"] = "PENDING_APPROVAL";
  GroupsGroupState2["Approved"] = "APPROVED";
  return GroupsGroupState2;
})(GroupsGroupState || {});
var GroupsGroupVisibility = /* @__PURE__ */ ((GroupsGroupVisibility2) => {
  GroupsGroupVisibility2["Private"] = "PRIVATE";
  GroupsGroupVisibility2["Public"] = "PUBLIC";
  return GroupsGroupVisibility2;
})(GroupsGroupVisibility || {});
var GroupsMembershipRole = /* @__PURE__ */ ((GroupsMembershipRole2) => {
  GroupsMembershipRole2["Owner"] = "OWNER";
  GroupsMembershipRole2["Moderator"] = "MODERATOR";
  GroupsMembershipRole2["Member"] = "MEMBER";
  return GroupsMembershipRole2;
})(GroupsMembershipRole || {});
var GroupsMembershipSettingKind = /* @__PURE__ */ ((GroupsMembershipSettingKind2) => {
  GroupsMembershipSettingKind2["NotInvitableForEvents"] = "NOT_INVITABLE_FOR_EVENTS";
  return GroupsMembershipSettingKind2;
})(GroupsMembershipSettingKind || {});
var GroupsMembershipState = /* @__PURE__ */ ((GroupsMembershipState2) => {
  GroupsMembershipState2["Blocked"] = "BLOCKED";
  GroupsMembershipState2["Excluded"] = "EXCLUDED";
  GroupsMembershipState2["Pending"] = "PENDING";
  GroupsMembershipState2["Approved"] = "APPROVED";
  return GroupsMembershipState2;
})(GroupsMembershipState || {});
var HasSeenSource = /* @__PURE__ */ ((HasSeenSource2) => {
  HasSeenSource2["Xtm"] = "XTM";
  return HasSeenSource2;
})(HasSeenSource || {});
var HelpCenterApplication = /* @__PURE__ */ ((HelpCenterApplication2) => {
  HelpCenterApplication2["Xtm"] = "XTM";
  return HelpCenterApplication2;
})(HelpCenterApplication || {});
var HelpCenterFilter = /* @__PURE__ */ ((HelpCenterFilter2) => {
  HelpCenterFilter2["Trainings"] = "TRAININGS";
  HelpCenterFilter2["Faq"] = "FAQ";
  HelpCenterFilter2["ProductUpdates"] = "PRODUCT_UPDATES";
  return HelpCenterFilter2;
})(HelpCenterFilter || {});
var HelpCenterKnowledgeLevel = /* @__PURE__ */ ((HelpCenterKnowledgeLevel2) => {
  HelpCenterKnowledgeLevel2["Experience"] = "EXPERIENCE";
  HelpCenterKnowledgeLevel2["NoExperience"] = "NO_EXPERIENCE";
  return HelpCenterKnowledgeLevel2;
})(HelpCenterKnowledgeLevel || {});
var HelpCenterLanguage = /* @__PURE__ */ ((HelpCenterLanguage2) => {
  HelpCenterLanguage2["De"] = "DE";
  HelpCenterLanguage2["En"] = "EN";
  return HelpCenterLanguage2;
})(HelpCenterLanguage || {});
var HelpCenterRole = /* @__PURE__ */ ((HelpCenterRole2) => {
  HelpCenterRole2["User"] = "USER";
  HelpCenterRole2["Admin"] = "ADMIN";
  return HelpCenterRole2;
})(HelpCenterRole || {});
var HelpCenterViewStatus = /* @__PURE__ */ ((HelpCenterViewStatus2) => {
  HelpCenterViewStatus2["New"] = "NEW";
  HelpCenterViewStatus2["Viewed"] = "VIEWED";
  HelpCenterViewStatus2["Read"] = "READ";
  return HelpCenterViewStatus2;
})(HelpCenterViewStatus || {});
var JobApplicationFormExternalDocType = /* @__PURE__ */ ((JobApplicationFormExternalDocType2) => {
  JobApplicationFormExternalDocType2["PrivacyPolicy"] = "PRIVACY_POLICY";
  JobApplicationFormExternalDocType2["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
  return JobApplicationFormExternalDocType2;
})(JobApplicationFormExternalDocType || {});
var JobApplicationFormFieldType = /* @__PURE__ */ ((JobApplicationFormFieldType2) => {
  JobApplicationFormFieldType2["Email"] = "EMAIL";
  JobApplicationFormFieldType2["Phone"] = "PHONE";
  JobApplicationFormFieldType2["Text"] = "TEXT";
  JobApplicationFormFieldType2["Files"] = "FILES";
  return JobApplicationFormFieldType2;
})(JobApplicationFormFieldType || {});
var JobBookmarkState = /* @__PURE__ */ ((JobBookmarkState2) => {
  JobBookmarkState2["NotBookmarked"] = "NOT_BOOKMARKED";
  JobBookmarkState2["Saved"] = "SAVED";
  JobBookmarkState2["Applied"] = "APPLIED";
  JobBookmarkState2["InterviewSet"] = "INTERVIEW_SET";
  return JobBookmarkState2;
})(JobBookmarkState || {});
var JobInteractionPlatform = /* @__PURE__ */ ((JobInteractionPlatform2) => {
  JobInteractionPlatform2["Web"] = "WEB";
  JobInteractionPlatform2["Mobile"] = "MOBILE";
  JobInteractionPlatform2["Ios"] = "IOS";
  JobInteractionPlatform2["Android"] = "ANDROID";
  return JobInteractionPlatform2;
})(JobInteractionPlatform || {});
var JobReportReason = /* @__PURE__ */ ((JobReportReason2) => {
  JobReportReason2["NoJobAd"] = "NO_JOB_AD";
  JobReportReason2["IllegalContent"] = "ILLEGAL_CONTENT";
  JobReportReason2["WrongInformation"] = "WRONG_INFORMATION";
  return JobReportReason2;
})(JobReportReason || {});
var JobReportableField = /* @__PURE__ */ ((JobReportableField2) => {
  JobReportableField2["Location"] = "LOCATION";
  JobReportableField2["CompanyName"] = "COMPANY_NAME";
  JobReportableField2["EmploymentType"] = "EMPLOYMENT_TYPE";
  JobReportableField2["CareerLevel"] = "CAREER_LEVEL";
  JobReportableField2["Other"] = "OTHER";
  return JobReportableField2;
})(JobReportableField || {});
var JobSeekerWillingnessToTravel = /* @__PURE__ */ ((JobSeekerWillingnessToTravel2) => {
  JobSeekerWillingnessToTravel2["None"] = "NONE";
  JobSeekerWillingnessToTravel2["Occasional"] = "OCCASIONAL";
  JobSeekerWillingnessToTravel2["Frequent"] = "FREQUENT";
  return JobSeekerWillingnessToTravel2;
})(JobSeekerWillingnessToTravel || {});
var JobUserXingApplicationStatus = /* @__PURE__ */ ((JobUserXingApplicationStatus2) => {
  JobUserXingApplicationStatus2["Error"] = "ERROR";
  JobUserXingApplicationStatus2["Pending"] = "PENDING";
  JobUserXingApplicationStatus2["Success"] = "SUCCESS";
  return JobUserXingApplicationStatus2;
})(JobUserXingApplicationStatus || {});
var LanguageCode = /* @__PURE__ */ ((LanguageCode2) => {
  LanguageCode2["De"] = "de";
  LanguageCode2["En"] = "en";
  return LanguageCode2;
})(LanguageCode || {});
var LeadAdFormFields = /* @__PURE__ */ ((LeadAdFormFields2) => {
  LeadAdFormFields2["Numeric"] = "numeric";
  LeadAdFormFields2["Boolean"] = "boolean";
  LeadAdFormFields2["Text"] = "text";
  LeadAdFormFields2["Address"] = "address";
  LeadAdFormFields2["Email"] = "email";
  LeadAdFormFields2["PhoneNumber"] = "phone_number";
  LeadAdFormFields2["Information"] = "information";
  LeadAdFormFields2["Date"] = "date";
  return LeadAdFormFields2;
})(LeadAdFormFields || {});
var LeadAdFormSections = /* @__PURE__ */ ((LeadAdFormSections2) => {
  LeadAdFormSections2["Address"] = "address";
  LeadAdFormSections2["CustomFields"] = "custom_fields";
  LeadAdFormSections2["TermsAndConditions"] = "terms_and_conditions";
  return LeadAdFormSections2;
})(LeadAdFormSections || {});
var LoginSecurityIssueReason = /* @__PURE__ */ ((LoginSecurityIssueReason2) => {
  LoginSecurityIssueReason2["Manual"] = "MANUAL";
  LoginSecurityIssueReason2["Eidi"] = "EIDI";
  LoginSecurityIssueReason2["OldVersion"] = "OLD_VERSION";
  LoginSecurityIssueReason2["LongInactive"] = "LONG_INACTIVE";
  LoginSecurityIssueReason2["EmailBounced"] = "EMAIL_BOUNCED";
  LoginSecurityIssueReason2["NoTwoFactorAuth"] = "NO_TWO_FACTOR_AUTH";
  return LoginSecurityIssueReason2;
})(LoginSecurityIssueReason || {});
var LoginState = /* @__PURE__ */ ((LoginState2) => {
  LoginState2["LoggedIn"] = "LOGGED_IN";
  LoginState2["LoggedOut"] = "LOGGED_OUT";
  LoginState2["SoftLoggedIn"] = "SOFT_LOGGED_IN";
  return LoginState2;
})(LoginState || {});
var MehubEntityType = /* @__PURE__ */ ((MehubEntityType2) => {
  MehubEntityType2["Comment"] = "COMMENT";
  MehubEntityType2["Event"] = "EVENT";
  MehubEntityType2["Post"] = "POST";
  MehubEntityType2["PostImage"] = "POST_IMAGE";
  MehubEntityType2["PostLinkShare"] = "POST_LINK_SHARE";
  MehubEntityType2["PostPlainText"] = "POST_PLAIN_TEXT";
  MehubEntityType2["PostVideo"] = "POST_VIDEO";
  return MehubEntityType2;
})(MehubEntityType || {});
var MehubUpdatesCommentSubType = /* @__PURE__ */ ((MehubUpdatesCommentSubType2) => {
  MehubUpdatesCommentSubType2["ReplyToOwnComment"] = "REPLY_TO_OWN_COMMENT";
  MehubUpdatesCommentSubType2["ReplyToOwnPost"] = "REPLY_TO_OWN_POST";
  MehubUpdatesCommentSubType2["ReplyToThread"] = "REPLY_TO_THREAD";
  MehubUpdatesCommentSubType2["CommentToOwnPost"] = "COMMENT_TO_OWN_POST";
  MehubUpdatesCommentSubType2["CommentToThread"] = "COMMENT_TO_THREAD";
  return MehubUpdatesCommentSubType2;
})(MehubUpdatesCommentSubType || {});
var MehubUpdatesDevice = /* @__PURE__ */ ((MehubUpdatesDevice2) => {
  MehubUpdatesDevice2["Ios"] = "IOS";
  MehubUpdatesDevice2["Android"] = "ANDROID";
  MehubUpdatesDevice2["Web"] = "WEB";
  return MehubUpdatesDevice2;
})(MehubUpdatesDevice || {});
var MehubUpdatesNotificationType = /* @__PURE__ */ ((MehubUpdatesNotificationType2) => {
  MehubUpdatesNotificationType2["JobSearchAlerts"] = "JOB_SEARCH_ALERTS";
  MehubUpdatesNotificationType2["PremiumStatistics"] = "PREMIUM_STATISTICS";
  MehubUpdatesNotificationType2["SocialLike"] = "SOCIAL_LIKE";
  MehubUpdatesNotificationType2["SocialShare"] = "SOCIAL_SHARE";
  MehubUpdatesNotificationType2["SocialComment"] = "SOCIAL_COMMENT";
  MehubUpdatesNotificationType2["SocialMention"] = "SOCIAL_MENTION";
  MehubUpdatesNotificationType2["VompStatistics"] = "VOMP_STATISTICS";
  return MehubUpdatesNotificationType2;
})(MehubUpdatesNotificationType || {});
var MessageType = /* @__PURE__ */ ((MessageType2) => {
  MessageType2["Attachment"] = "ATTACHMENT";
  MessageType2["ChatUpdated"] = "CHAT_UPDATED";
  MessageType2["ContactConfirmed"] = "CONTACT_CONFIRMED";
  MessageType2["ContactRequestCreated"] = "CONTACT_REQUEST_CREATED";
  MessageType2["ContactRequestDeclined"] = "CONTACT_REQUEST_DECLINED";
  MessageType2["Html"] = "HTML";
  MessageType2["Image"] = "IMAGE";
  MessageType2["Object"] = "OBJECT";
  MessageType2["ParticipantAdded"] = "PARTICIPANT_ADDED";
  MessageType2["ParticipantJoined"] = "PARTICIPANT_JOINED";
  MessageType2["ParticipantBirthday"] = "PARTICIPANT_BIRTHDAY";
  MessageType2["ParticipantKicked"] = "PARTICIPANT_KICKED";
  MessageType2["ParticipantLeft"] = "PARTICIPANT_LEFT";
  MessageType2["PositionShare"] = "POSITION_SHARE";
  MessageType2["Preview"] = "PREVIEW";
  MessageType2["ScheduledMessageCreated"] = "SCHEDULED_MESSAGE_CREATED";
  MessageType2["ScheduledMessageDeleted"] = "SCHEDULED_MESSAGE_DELETED";
  MessageType2["StoryReference"] = "STORY_REFERENCE";
  MessageType2["Secret"] = "SECRET";
  MessageType2["Text"] = "TEXT";
  MessageType2["TextLocalised"] = "TEXT_LOCALISED";
  return MessageType2;
})(MessageType || {});
var MessengerChatType = /* @__PURE__ */ ((MessengerChatType2) => {
  MessengerChatType2["BroadcastChat"] = "BROADCAST_CHAT";
  MessengerChatType2["GroupChat"] = "GROUP_CHAT";
  MessengerChatType2["KickedChat"] = "KICKED_CHAT";
  MessengerChatType2["LegacyChat"] = "LEGACY_CHAT";
  MessengerChatType2["OneOnOneChat"] = "ONE_ON_ONE_CHAT";
  MessengerChatType2["SecretOneOnOneChat"] = "SECRET_ONE_ON_ONE_CHAT";
  MessengerChatType2["SystemChat"] = "SYSTEM_CHAT";
  MessengerChatType2["XbpChat"] = "XBP_CHAT";
  MessengerChatType2["XingGuideChat"] = "XING_GUIDE_CHAT";
  MessengerChatType2["XtmChat"] = "XTM_CHAT";
  return MessengerChatType2;
})(MessengerChatType || {});
var MessengerChatsFilterTypes = /* @__PURE__ */ ((MessengerChatsFilterTypes2) => {
  MessengerChatsFilterTypes2["All"] = "ALL";
  MessengerChatsFilterTypes2["Unread"] = "UNREAD";
  return MessengerChatsFilterTypes2;
})(MessengerChatsFilterTypes || {});
var MessengerContextId = /* @__PURE__ */ ((MessengerContextId2) => {
  MessengerContextId2["RecruiterOfferjob"] = "RECRUITER_OFFERJOB";
  MessengerContextId2["RecruiterInterest"] = "RECRUITER_INTEREST";
  MessengerContextId2["Birthday"] = "BIRTHDAY";
  MessengerContextId2["ConversationStarter"] = "CONVERSATION_STARTER";
  MessengerContextId2["Profile"] = "PROFILE";
  MessengerContextId2["ChnjWelcome"] = "CHNJ_WELCOME";
  MessengerContextId2["ChnjMeet"] = "CHNJ_MEET";
  MessengerContextId2["ChnjCongrats"] = "CHNJ_CONGRATS";
  MessengerContextId2["ChnjGoodbye"] = "CHNJ_GOODBYE";
  MessengerContextId2["CoworkerWelcome"] = "COWORKER_WELCOME";
  MessengerContextId2["CoworkerMeet"] = "COWORKER_MEET";
  return MessengerContextId2;
})(MessengerContextId || {});
var MostVisitedCompaniesOrder = /* @__PURE__ */ ((MostVisitedCompaniesOrder2) => {
  MostVisitedCompaniesOrder2["VisitsCountDesc"] = "VISITS_COUNT_DESC";
  MostVisitedCompaniesOrder2["Random"] = "RANDOM";
  return MostVisitedCompaniesOrder2;
})(MostVisitedCompaniesOrder || {});
var MoveonAssessmentProcessingStatus = /* @__PURE__ */ ((MoveonAssessmentProcessingStatus2) => {
  MoveonAssessmentProcessingStatus2["Queued"] = "QUEUED";
  MoveonAssessmentProcessingStatus2["Processing"] = "PROCESSING";
  MoveonAssessmentProcessingStatus2["Completed"] = "COMPLETED";
  return MoveonAssessmentProcessingStatus2;
})(MoveonAssessmentProcessingStatus || {});
var NbaCardId = /* @__PURE__ */ ((NbaCardId2) => {
  NbaCardId2["WelcomeCard"] = "WELCOME_CARD";
  NbaCardId2["CreateBusinessLocationCard"] = "CREATE_BUSINESS_LOCATION_CARD";
  NbaCardId2["UpdateBusinessLocationCard"] = "UPDATE_BUSINESS_LOCATION_CARD";
  NbaCardId2["CreateBusinessCityCard"] = "CREATE_BUSINESS_CITY_CARD";
  NbaCardId2["UpdateBusinessCityCard"] = "UPDATE_BUSINESS_CITY_CARD";
  NbaCardId2["CreateBusinessAddressCard"] = "CREATE_BUSINESS_ADDRESS_CARD";
  NbaCardId2["CreateDisciplineCard"] = "CREATE_DISCIPLINE_CARD";
  NbaCardId2["UpdateDisciplineCard"] = "UPDATE_DISCIPLINE_CARD";
  NbaCardId2["ImproveHavesCard"] = "IMPROVE_HAVES_CARD";
  NbaCardId2["UpdateHavesCard"] = "UPDATE_HAVES_CARD";
  NbaCardId2["CreateHavesCard"] = "CREATE_HAVES_CARD";
  NbaCardId2["UpdateJobTitleCard"] = "UPDATE_JOB_TITLE_CARD";
  NbaCardId2["ImproveJobTitleCard"] = "IMPROVE_JOB_TITLE_CARD";
  NbaCardId2["ImprovePhotoCard"] = "IMPROVE_PHOTO_CARD";
  NbaCardId2["UpdatePhotoCard"] = "UPDATE_PHOTO_CARD";
  NbaCardId2["CreatePhotoCard"] = "CREATE_PHOTO_CARD";
  NbaCardId2["CreateMinCareerLevelCard"] = "CREATE_MIN_CAREER_LEVEL_CARD";
  NbaCardId2["UpdateMinCareerLevelCard"] = "UPDATE_MIN_CAREER_LEVEL_CARD";
  NbaCardId2["UpdateCompanyNameCard"] = "UPDATE_COMPANY_NAME_CARD";
  NbaCardId2["CreateBirthdayCard"] = "CREATE_BIRTHDAY_CARD";
  NbaCardId2["CreateCompleteEducationCard"] = "CREATE_COMPLETE_EDUCATION_CARD";
  NbaCardId2["CreateEducationCard"] = "CREATE_EDUCATION_CARD";
  NbaCardId2["PremiumPictureVoucher"] = "PREMIUM_PICTURE_VOUCHER";
  NbaCardId2["PremiumUpsell"] = "PREMIUM_UPSELL";
  NbaCardId2["SuccessCard"] = "SUCCESS_CARD";
  NbaCardId2["All"] = "ALL";
  return NbaCardId2;
})(NbaCardId || {});
var NetworkRelationshipErrorType = /* @__PURE__ */ ((NetworkRelationshipErrorType2) => {
  NetworkRelationshipErrorType2["UserNotFound"] = "USER_NOT_FOUND";
  NetworkRelationshipErrorType2["UserBlacklisted"] = "USER_BLACKLISTED";
  NetworkRelationshipErrorType2["SameId"] = "SAME_ID";
  return NetworkRelationshipErrorType2;
})(NetworkRelationshipErrorType || {});
var NetworkRelationshipPermissionType = /* @__PURE__ */ ((NetworkRelationshipPermissionType2) => {
  NetworkRelationshipPermissionType2["SendRequest"] = "SEND_REQUEST";
  NetworkRelationshipPermissionType2["DeleteContact"] = "DELETE_CONTACT";
  NetworkRelationshipPermissionType2["DeleteRequest"] = "DELETE_REQUEST";
  NetworkRelationshipPermissionType2["ConfirmRequest"] = "CONFIRM_REQUEST";
  NetworkRelationshipPermissionType2["DeclineRequest"] = "DECLINE_REQUEST";
  return NetworkRelationshipPermissionType2;
})(NetworkRelationshipPermissionType || {});
var NetworkRelationshipType = /* @__PURE__ */ ((NetworkRelationshipType2) => {
  NetworkRelationshipType2["None"] = "NONE";
  NetworkRelationshipType2["Contact"] = "CONTACT";
  NetworkRelationshipType2["Sent"] = "SENT";
  NetworkRelationshipType2["Received"] = "RECEIVED";
  NetworkRelationshipType2["ReceivedDeclined"] = "RECEIVED_DECLINED";
  return NetworkRelationshipType2;
})(NetworkRelationshipType || {});
var NetworkUpdatesFilter = /* @__PURE__ */ ((NetworkUpdatesFilter2) => {
  NetworkUpdatesFilter2["All"] = "ALL";
  NetworkUpdatesFilter2["Chats"] = "CHATS";
  NetworkUpdatesFilter2["Updates"] = "UPDATES";
  return NetworkUpdatesFilter2;
})(NetworkUpdatesFilter || {});
var NewVisitType = /* @__PURE__ */ ((NewVisitType2) => {
  NewVisitType2["NotVisible"] = "NOT_VISIBLE";
  NewVisitType2["Visible"] = "VISIBLE";
  return NewVisitType2;
})(NewVisitType || {});
var OnboardingFieldName = /* @__PURE__ */ ((OnboardingFieldName2) => {
  OnboardingFieldName2["BusinessCity"] = "business_city";
  OnboardingFieldName2["BusinessProvince"] = "business_province";
  OnboardingFieldName2["BusinessCountry"] = "business_country";
  OnboardingFieldName2["CareerLevel"] = "career_level";
  OnboardingFieldName2["Company"] = "company";
  OnboardingFieldName2["CompanyEndDate"] = "company_end_date";
  OnboardingFieldName2["CompanyStartDate"] = "company_start_date";
  OnboardingFieldName2["DisciplineId"] = "discipline_id";
  OnboardingFieldName2["EducationStartDate"] = "education_start_date";
  OnboardingFieldName2["EducationEndDate"] = "education_end_date";
  OnboardingFieldName2["EmploymentTypeId"] = "employment_type_id";
  OnboardingFieldName2["FieldOfStudy"] = "field_of_study";
  OnboardingFieldName2["IndustryId"] = "industry_id";
  OnboardingFieldName2["Intent"] = "intent";
  OnboardingFieldName2["JobTitle"] = "job_title";
  OnboardingFieldName2["JobseekerPhase"] = "jobseeker_phase";
  OnboardingFieldName2["Motivation"] = "motivation";
  OnboardingFieldName2["MotiveTags"] = "motive_tags";
  OnboardingFieldName2["Occupation"] = "occupation";
  OnboardingFieldName2["OtherProfessionalStatus"] = "other_professional_status";
  OnboardingFieldName2["ProfStatus"] = "prof_status";
  OnboardingFieldName2["ProfessionalStatus"] = "professional_status";
  OnboardingFieldName2["ProfessionalStatusOther"] = "professional_status_other";
  OnboardingFieldName2["University"] = "university";
  OnboardingFieldName2["FutureJobTitle"] = "future_job_title";
  OnboardingFieldName2["FutureJobCity"] = "future_job_city";
  OnboardingFieldName2["FutureJobProvince"] = "future_job_province";
  OnboardingFieldName2["FutureJobCountry"] = "future_job_country";
  return OnboardingFieldName2;
})(OnboardingFieldName || {});
var OrganizedEventsType = /* @__PURE__ */ ((OrganizedEventsType2) => {
  OrganizedEventsType2["Draft"] = "DRAFT";
  OrganizedEventsType2["Live"] = "LIVE";
  OrganizedEventsType2["Past"] = "PAST";
  OrganizedEventsType2["Canceled"] = "CANCELED";
  return OrganizedEventsType2;
})(OrganizedEventsType || {});
var PartnerMemberships = /* @__PURE__ */ ((PartnerMemberships2) => {
  PartnerMemberships2["Premium"] = "PREMIUM";
  PartnerMemberships2["Projobs"] = "PROJOBS";
  return PartnerMemberships2;
})(PartnerMemberships || {});
var PartnerTypes = /* @__PURE__ */ ((PartnerTypes2) => {
  PartnerTypes2["Xing"] = "XING";
  PartnerTypes2["Amiando"] = "AMIANDO";
  PartnerTypes2["Competitor"] = "COMPETITOR";
  return PartnerTypes2;
})(PartnerTypes || {});
var PaymentAccountType = /* @__PURE__ */ ((PaymentAccountType2) => {
  PaymentAccountType2["Invoice"] = "INVOICE";
  PaymentAccountType2["Sepa"] = "SEPA";
  PaymentAccountType2["CreditCard"] = "CREDIT_CARD";
  PaymentAccountType2["Paypal"] = "PAYPAL";
  return PaymentAccountType2;
})(PaymentAccountType || {});
var PaymentClientProductGroup = /* @__PURE__ */ ((PaymentClientProductGroup2) => {
  PaymentClientProductGroup2["Ad"] = "AD";
  PaymentClientProductGroup2["Bp"] = "BP";
  PaymentClientProductGroup2["Ev"] = "EV";
  PaymentClientProductGroup2["Gr"] = "GR";
  PaymentClientProductGroup2["Ja"] = "JA";
  PaymentClientProductGroup2["Pj"] = "PJ";
  PaymentClientProductGroup2["Pr"] = "PR";
  PaymentClientProductGroup2["Pp"] = "PP";
  PaymentClientProductGroup2["Pc"] = "PC";
  PaymentClientProductGroup2["Rm"] = "RM";
  PaymentClientProductGroup2["Tm"] = "TM";
  PaymentClientProductGroup2["Tp"] = "TP";
  PaymentClientProductGroup2["Ex"] = "EX";
  PaymentClientProductGroup2["Cd"] = "CD";
  PaymentClientProductGroup2["Pb"] = "PB";
  PaymentClientProductGroup2["Xf"] = "XF";
  return PaymentClientProductGroup2;
})(PaymentClientProductGroup || {});
var PaymentCurrency = /* @__PURE__ */ ((PaymentCurrency2) => {
  PaymentCurrency2["Eur"] = "EUR";
  PaymentCurrency2["Chf"] = "CHF";
  PaymentCurrency2["Usd"] = "USD";
  PaymentCurrency2["Unk"] = "UNK";
  return PaymentCurrency2;
})(PaymentCurrency || {});
var PaymentDurationType = /* @__PURE__ */ ((PaymentDurationType2) => {
  PaymentDurationType2["Days"] = "DAYS";
  PaymentDurationType2["Weeks"] = "WEEKS";
  PaymentDurationType2["Months"] = "MONTHS";
  return PaymentDurationType2;
})(PaymentDurationType || {});
var PaymentInvoiceLanguage = /* @__PURE__ */ ((PaymentInvoiceLanguage2) => {
  PaymentInvoiceLanguage2["En"] = "EN";
  PaymentInvoiceLanguage2["De"] = "DE";
  return PaymentInvoiceLanguage2;
})(PaymentInvoiceLanguage || {});
var PaymentInvoiceStatus = /* @__PURE__ */ ((PaymentInvoiceStatus2) => {
  PaymentInvoiceStatus2["Open"] = "OPEN";
  PaymentInvoiceStatus2["Paid"] = "PAID";
  PaymentInvoiceStatus2["Canceled"] = "CANCELED";
  PaymentInvoiceStatus2["Closed"] = "CLOSED";
  PaymentInvoiceStatus2["Collecting"] = "COLLECTING";
  PaymentInvoiceStatus2["Dunning"] = "DUNNING";
  PaymentInvoiceStatus2["Resolved"] = "RESOLVED";
  PaymentInvoiceStatus2["FirstReminder"] = "FIRST_REMINDER";
  PaymentInvoiceStatus2["SecondReminder"] = "SECOND_REMINDER";
  PaymentInvoiceStatus2["ThirdReminder"] = "THIRD_REMINDER";
  PaymentInvoiceStatus2["FourthReminder"] = "FOURTH_REMINDER";
  PaymentInvoiceStatus2["Encashment"] = "ENCASHMENT";
  PaymentInvoiceStatus2["EncashmentFailed"] = "ENCASHMENT_FAILED";
  return PaymentInvoiceStatus2;
})(PaymentInvoiceStatus || {});
var PaymentMobileMerchant = /* @__PURE__ */ ((PaymentMobileMerchant2) => {
  PaymentMobileMerchant2["Gplay"] = "Gplay";
  PaymentMobileMerchant2["ITunes"] = "iTunes";
  return PaymentMobileMerchant2;
})(PaymentMobileMerchant || {});
var PaymentSubscriptionStatus = /* @__PURE__ */ ((PaymentSubscriptionStatus2) => {
  PaymentSubscriptionStatus2["Past"] = "PAST";
  PaymentSubscriptionStatus2["Future"] = "FUTURE";
  PaymentSubscriptionStatus2["Canceled"] = "CANCELED";
  PaymentSubscriptionStatus2["InvoiceCanceled"] = "INVOICE_CANCELED";
  PaymentSubscriptionStatus2["Ended"] = "ENDED";
  PaymentSubscriptionStatus2["Paused"] = "PAUSED";
  PaymentSubscriptionStatus2["Current"] = "CURRENT";
  PaymentSubscriptionStatus2["Subscription"] = "SUBSCRIPTION";
  PaymentSubscriptionStatus2["ResumeDisabled"] = "RESUME_DISABLED";
  return PaymentSubscriptionStatus2;
})(PaymentSubscriptionStatus || {});
var PhonePreferenceDays = /* @__PURE__ */ ((PhonePreferenceDays2) => {
  PhonePreferenceDays2["EveryDay"] = "EVERY_DAY";
  PhonePreferenceDays2["WorkingDays"] = "WORKING_DAYS";
  PhonePreferenceDays2["Weekend"] = "WEEKEND";
  return PhonePreferenceDays2;
})(PhonePreferenceDays || {});
var PhonePreferencesOptions = /* @__PURE__ */ ((PhonePreferencesOptions2) => {
  PhonePreferencesOptions2["AnyTime"] = "ANY_TIME";
  PhonePreferencesOptions2["SpecificTime"] = "SPECIFIC_TIME";
  return PhonePreferencesOptions2;
})(PhonePreferencesOptions || {});
var PostingAdSubType = /* @__PURE__ */ ((PostingAdSubType2) => {
  PostingAdSubType2["LinkShare"] = "LINK_SHARE";
  PostingAdSubType2["Image"] = "IMAGE";
  return PostingAdSubType2;
})(PostingAdSubType || {});
var PostingPublicationState = /* @__PURE__ */ ((PostingPublicationState2) => {
  PostingPublicationState2["Draft"] = "DRAFT";
  PostingPublicationState2["Published"] = "PUBLISHED";
  PostingPublicationState2["Scheduled"] = "SCHEDULED";
  PostingPublicationState2["Hidden"] = "HIDDEN";
  return PostingPublicationState2;
})(PostingPublicationState || {});
var PostingPublicationStrategy = /* @__PURE__ */ ((PostingPublicationStrategy2) => {
  PostingPublicationStrategy2["Now"] = "NOW";
  PostingPublicationStrategy2["Later"] = "LATER";
  return PostingPublicationStrategy2;
})(PostingPublicationStrategy || {});
var PostingsAvailablePostingTypes = /* @__PURE__ */ ((PostingsAvailablePostingTypes2) => {
  PostingsAvailablePostingTypes2["PlainTextPosting"] = "PLAIN_TEXT_POSTING";
  PostingsAvailablePostingTypes2["ArticlePosting"] = "ARTICLE_POSTING";
  PostingsAvailablePostingTypes2["ImagePosting"] = "IMAGE_POSTING";
  PostingsAvailablePostingTypes2["LinkSharePosting"] = "LINK_SHARE_POSTING";
  PostingsAvailablePostingTypes2["VideoPosting"] = "VIDEO_POSTING";
  return PostingsAvailablePostingTypes2;
})(PostingsAvailablePostingTypes || {});
var PostingsVisibility = /* @__PURE__ */ ((PostingsVisibility2) => {
  PostingsVisibility2["Public"] = "PUBLIC";
  PostingsVisibility2["Private"] = "PRIVATE";
  return PostingsVisibility2;
})(PostingsVisibility || {});
var PotentialCandidatesInteraction = /* @__PURE__ */ ((PotentialCandidatesInteraction2) => {
  PotentialCandidatesInteraction2["Apply"] = "APPLY";
  PotentialCandidatesInteraction2["Visit"] = "VISIT";
  PotentialCandidatesInteraction2["Interest"] = "INTEREST";
  PotentialCandidatesInteraction2["Recommend"] = "RECOMMEND";
  return PotentialCandidatesInteraction2;
})(PotentialCandidatesInteraction || {});
var PotentialCandidatesOrder = /* @__PURE__ */ ((PotentialCandidatesOrder2) => {
  PotentialCandidatesOrder2["Asc"] = "ASC";
  PotentialCandidatesOrder2["Desc"] = "DESC";
  return PotentialCandidatesOrder2;
})(PotentialCandidatesOrder || {});
var PredictiveSearchSectionType = /* @__PURE__ */ ((PredictiveSearchSectionType2) => {
  PredictiveSearchSectionType2["IncrementalSearch"] = "INCREMENTAL_SEARCH";
  PredictiveSearchSectionType2["Recommendation"] = "RECOMMENDATION";
  PredictiveSearchSectionType2["QuerySuggestions"] = "QUERY_SUGGESTIONS";
  PredictiveSearchSectionType2["RecentSearches"] = "RECENT_SEARCHES";
  PredictiveSearchSectionType2["NavigationSuggestions"] = "NAVIGATION_SUGGESTIONS";
  PredictiveSearchSectionType2["RecentIteractions"] = "RECENT_ITERACTIONS";
  return PredictiveSearchSectionType2;
})(PredictiveSearchSectionType || {});
var PremiumFeaturesOverviewProducts = /* @__PURE__ */ ((PremiumFeaturesOverviewProducts2) => {
  PremiumFeaturesOverviewProducts2["Premium"] = "PREMIUM";
  PremiumFeaturesOverviewProducts2["Probusiness"] = "PROBUSINESS";
  PremiumFeaturesOverviewProducts2["Projobs"] = "PROJOBS";
  return PremiumFeaturesOverviewProducts2;
})(PremiumFeaturesOverviewProducts || {});
var PremiumPlatform = /* @__PURE__ */ ((PremiumPlatform2) => {
  PremiumPlatform2["Ios"] = "IOS";
  PremiumPlatform2["Android"] = "ANDROID";
  PremiumPlatform2["Web"] = "WEB";
  return PremiumPlatform2;
})(PremiumPlatform || {});
var PremiumSelfAssessmentStatusState = /* @__PURE__ */ ((PremiumSelfAssessmentStatusState2) => {
  PremiumSelfAssessmentStatusState2["NotStarted"] = "NOT_STARTED";
  PremiumSelfAssessmentStatusState2["Started"] = "STARTED";
  PremiumSelfAssessmentStatusState2["Finished"] = "FINISHED";
  return PremiumSelfAssessmentStatusState2;
})(PremiumSelfAssessmentStatusState || {});
var PremiumSelfDevelopmentCourseFilter = /* @__PURE__ */ ((PremiumSelfDevelopmentCourseFilter2) => {
  PremiumSelfDevelopmentCourseFilter2["Popular"] = "POPULAR";
  return PremiumSelfDevelopmentCourseFilter2;
})(PremiumSelfDevelopmentCourseFilter || {});
var ProfileImageSize = /* @__PURE__ */ ((ProfileImageSize2) => {
  ProfileImageSize2["Square_32"] = "SQUARE_32";
  ProfileImageSize2["Square_48"] = "SQUARE_48";
  ProfileImageSize2["Square_64"] = "SQUARE_64";
  ProfileImageSize2["Square_96"] = "SQUARE_96";
  ProfileImageSize2["Square_128"] = "SQUARE_128";
  ProfileImageSize2["Square_192"] = "SQUARE_192";
  ProfileImageSize2["Square_256"] = "SQUARE_256";
  ProfileImageSize2["Square_1024"] = "SQUARE_1024";
  ProfileImageSize2["Original"] = "ORIGINAL";
  return ProfileImageSize2;
})(ProfileImageSize || {});
var ProfileModuleIdentifier = /* @__PURE__ */ ((ProfileModuleIdentifier2) => {
  ProfileModuleIdentifier2["XingIdModule"] = "XING_ID_MODULE";
  ProfileModuleIdentifier2["NextBestActionModule"] = "NEXT_BEST_ACTION_MODULE";
  ProfileModuleIdentifier2["DisplayAdModule"] = "DISPLAY_AD_MODULE";
  ProfileModuleIdentifier2["VompModule"] = "VOMP_MODULE";
  ProfileModuleIdentifier2["NoteModule"] = "NOTE_MODULE";
  ProfileModuleIdentifier2["CareerSettingsModule"] = "CAREER_SETTINGS_MODULE";
  ProfileModuleIdentifier2["ContentInsiderModule"] = "CONTENT_INSIDER_MODULE";
  ProfileModuleIdentifier2["TimelineModule"] = "TIMELINE_MODULE";
  ProfileModuleIdentifier2["ContactsModule"] = "CONTACTS_MODULE";
  ProfileModuleIdentifier2["LegalImprintModule"] = "LEGAL_IMPRINT_MODULE";
  ProfileModuleIdentifier2["PatternsShowcaseModule"] = "PATTERNS_SHOWCASE_MODULE";
  ProfileModuleIdentifier2["PersonalDetailsModule"] = "PERSONAL_DETAILS_MODULE";
  ProfileModuleIdentifier2["EngagementModule"] = "ENGAGEMENT_MODULE";
  ProfileModuleIdentifier2["SkillsModule"] = "SKILLS_MODULE";
  ProfileModuleIdentifier2["WantsModule"] = "WANTS_MODULE";
  ProfileModuleIdentifier2["InterestsModule"] = "INTERESTS_MODULE";
  ProfileModuleIdentifier2["AboutMeModule"] = "ABOUT_ME_MODULE";
  return ProfileModuleIdentifier2;
})(ProfileModuleIdentifier || {});
var ProfileOccupationTypeCategoryIdentifier = /* @__PURE__ */ ((ProfileOccupationTypeCategoryIdentifier2) => {
  ProfileOccupationTypeCategoryIdentifier2["Professional"] = "PROFESSIONAL";
  ProfileOccupationTypeCategoryIdentifier2["EntryLevel"] = "ENTRY_LEVEL";
  ProfileOccupationTypeCategoryIdentifier2["Educational"] = "EDUCATIONAL";
  ProfileOccupationTypeCategoryIdentifier2["Other"] = "OTHER";
  return ProfileOccupationTypeCategoryIdentifier2;
})(ProfileOccupationTypeCategoryIdentifier || {});
var ProfileOccupationTypeIdentifier = /* @__PURE__ */ ((ProfileOccupationTypeIdentifier2) => {
  ProfileOccupationTypeIdentifier2["Employee"] = "EMPLOYEE";
  ProfileOccupationTypeIdentifier2["Intern"] = "INTERN";
  ProfileOccupationTypeIdentifier2["FreelancerSelfEmployed"] = "FREELANCER_SELF_EMPLOYED";
  ProfileOccupationTypeIdentifier2["Owner"] = "OWNER";
  ProfileOccupationTypeIdentifier2["PartnerShareholder"] = "PARTNER_SHAREHOLDER";
  ProfileOccupationTypeIdentifier2["BoardMember"] = "BOARD_MEMBER";
  ProfileOccupationTypeIdentifier2["Volunteer"] = "VOLUNTEER";
  ProfileOccupationTypeIdentifier2["SelfEmployed"] = "SELF_EMPLOYED";
  ProfileOccupationTypeIdentifier2["Shareholder"] = "SHAREHOLDER";
  ProfileOccupationTypeIdentifier2["CivilServant"] = "CIVIL_SERVANT";
  ProfileOccupationTypeIdentifier2["Freelancer"] = "FREELANCER";
  ProfileOccupationTypeIdentifier2["Partner"] = "PARTNER";
  ProfileOccupationTypeIdentifier2["UniversityStudent"] = "UNIVERSITY_STUDENT";
  ProfileOccupationTypeIdentifier2["Apprenticeship"] = "APPRENTICESHIP";
  ProfileOccupationTypeIdentifier2["ParentalLeave"] = "PARENTAL_LEAVE";
  return ProfileOccupationTypeIdentifier2;
})(ProfileOccupationTypeIdentifier || {});
var ProfilePersonalStatuses = /* @__PURE__ */ ((ProfilePersonalStatuses2) => {
  ProfilePersonalStatuses2["Custom"] = "CUSTOM";
  ProfilePersonalStatuses2["ParentalLeave"] = "PARENTAL_LEAVE";
  ProfilePersonalStatuses2["Sabbatical"] = "SABBATICAL";
  ProfilePersonalStatuses2["Travelling"] = "TRAVELLING";
  ProfilePersonalStatuses2["TrainingCourse"] = "TRAINING_COURSE";
  ProfilePersonalStatuses2["FurtherEducation"] = "FURTHER_EDUCATION";
  ProfilePersonalStatuses2["Holiday"] = "HOLIDAY";
  ProfilePersonalStatuses2["LookingForNewTeamMember"] = "LOOKING_FOR_NEW_TEAM_MEMBER";
  ProfilePersonalStatuses2["PracticalSemester"] = "PRACTICAL_SEMESTER";
  ProfilePersonalStatuses2["SemesterAbroad"] = "SEMESTER_ABROAD";
  ProfilePersonalStatuses2["SemesterOff"] = "SEMESTER_OFF";
  ProfilePersonalStatuses2["FinalThesis"] = "FINAL_THESIS";
  ProfilePersonalStatuses2["ExamPeriod"] = "EXAM_PERIOD";
  ProfilePersonalStatuses2["Available"] = "AVAILABLE";
  ProfilePersonalStatuses2["AvailableSoon"] = "AVAILABLE_SOON";
  ProfilePersonalStatuses2["AvailablePartially"] = "AVAILABLE_PARTIALLY";
  ProfilePersonalStatuses2["Booked"] = "BOOKED";
  ProfilePersonalStatuses2["NotInterested"] = "NOT_INTERESTED";
  ProfilePersonalStatuses2["StayingAtHome"] = "STAYING_AT_HOME";
  ProfilePersonalStatuses2["WorkingFromHome"] = "WORKING_FROM_HOME";
  ProfilePersonalStatuses2["WouldLikeToHelp"] = "WOULD_LIKE_TO_HELP";
  ProfilePersonalStatuses2["LookingForVolunteers"] = "LOOKING_FOR_VOLUNTEERS";
  ProfilePersonalStatuses2["OpenForProjects"] = "OPEN_FOR_PROJECTS";
  ProfilePersonalStatuses2["FineAndHealthy"] = "FINE_AND_HEALTHY";
  ProfilePersonalStatuses2["WouldAppreciateSocialContacts"] = "WOULD_APPRECIATE_SOCIAL_CONTACTS";
  return ProfilePersonalStatuses2;
})(ProfilePersonalStatuses || {});
var ProfileTimelineAction = /* @__PURE__ */ ((ProfileTimelineAction2) => {
  ProfileTimelineAction2["AddEntry"] = "ADD_ENTRY";
  ProfileTimelineAction2["EditEntry"] = "EDIT_ENTRY";
  return ProfileTimelineAction2;
})(ProfileTimelineAction || {});
var ProfileTimelineFieldName = /* @__PURE__ */ ((ProfileTimelineFieldName2) => {
  ProfileTimelineFieldName2["JobTitle"] = "JOB_TITLE";
  ProfileTimelineFieldName2["Employment"] = "EMPLOYMENT";
  ProfileTimelineFieldName2["CareerLevel"] = "CAREER_LEVEL";
  ProfileTimelineFieldName2["PartTime"] = "PART_TIME";
  ProfileTimelineFieldName2["ProjobsStaffResponsibility"] = "PROJOBS_STAFF_RESPONSIBILITY";
  ProfileTimelineFieldName2["ProjobsStaff"] = "PROJOBS_STAFF";
  ProfileTimelineFieldName2["ProjobsBudget"] = "PROJOBS_BUDGET";
  ProfileTimelineFieldName2["ProjobsRevenue"] = "PROJOBS_REVENUE";
  ProfileTimelineFieldName2["CompanyName"] = "COMPANY_NAME";
  ProfileTimelineFieldName2["LegalForm"] = "LEGAL_FORM";
  ProfileTimelineFieldName2["Employees"] = "EMPLOYEES";
  ProfileTimelineFieldName2["Industry"] = "INDUSTRY";
  ProfileTimelineFieldName2["Location"] = "LOCATION";
  ProfileTimelineFieldName2["Discipline"] = "DISCIPLINE";
  ProfileTimelineFieldName2["Website"] = "WEBSITE";
  ProfileTimelineFieldName2["Description"] = "DESCRIPTION";
  ProfileTimelineFieldName2["CourseOfStudy"] = "COURSE_OF_STUDY";
  ProfileTimelineFieldName2["Subject"] = "SUBJECT";
  ProfileTimelineFieldName2["University"] = "UNIVERSITY";
  ProfileTimelineFieldName2["VocationalSchool"] = "VOCATIONAL_SCHOOL";
  ProfileTimelineFieldName2["TimePeriod"] = "TIME_PERIOD";
  ProfileTimelineFieldName2["Degree"] = "DEGREE";
  ProfileTimelineFieldName2["Qualification"] = "QUALIFICATION";
  ProfileTimelineFieldName2["PrimaryOccupation"] = "PRIMARY_OCCUPATION";
  return ProfileTimelineFieldName2;
})(ProfileTimelineFieldName || {});
var ProjobsConsumer = /* @__PURE__ */ ((ProjobsConsumer2) => {
  ProjobsConsumer2["Android"] = "ANDROID";
  ProjobsConsumer2["Ios"] = "IOS";
  ProjobsConsumer2["Web"] = "WEB";
  return ProjobsConsumer2;
})(ProjobsConsumer || {});
var PurchaseMobilePlatform = /* @__PURE__ */ ((PurchaseMobilePlatform2) => {
  PurchaseMobilePlatform2["Ios"] = "IOS";
  PurchaseMobilePlatform2["Android"] = "ANDROID";
  return PurchaseMobilePlatform2;
})(PurchaseMobilePlatform || {});
var PurchaseOrderType = /* @__PURE__ */ ((PurchaseOrderType2) => {
  PurchaseOrderType2["Upsell"] = "UPSELL";
  PurchaseOrderType2["Revoke"] = "REVOKE";
  return PurchaseOrderType2;
})(PurchaseOrderType || {});
var PurchasePlatform = /* @__PURE__ */ ((PurchasePlatform2) => {
  PurchasePlatform2["Ios"] = "IOS";
  PurchasePlatform2["Android"] = "ANDROID";
  PurchasePlatform2["Web"] = "WEB";
  return PurchasePlatform2;
})(PurchasePlatform || {});
var PurchaseProduct = /* @__PURE__ */ ((PurchaseProduct2) => {
  PurchaseProduct2["Premium"] = "PREMIUM";
  PurchaseProduct2["Projobs"] = "PROJOBS";
  return PurchaseProduct2;
})(PurchaseProduct || {});
var PurchaseWebCampaignType = /* @__PURE__ */ ((PurchaseWebCampaignType2) => {
  PurchaseWebCampaignType2["Default"] = "DEFAULT";
  PurchaseWebCampaignType2["Special"] = "SPECIAL";
  PurchaseWebCampaignType2["Winback"] = "WINBACK";
  PurchaseWebCampaignType2["Trigger"] = "TRIGGER";
  PurchaseWebCampaignType2["Revoke"] = "REVOKE";
  PurchaseWebCampaignType2["Student"] = "STUDENT";
  return PurchaseWebCampaignType2;
})(PurchaseWebCampaignType || {});
var PurchaseWebCurrency = /* @__PURE__ */ ((PurchaseWebCurrency2) => {
  PurchaseWebCurrency2["Eur"] = "EUR";
  PurchaseWebCurrency2["Chf"] = "CHF";
  PurchaseWebCurrency2["Usd"] = "USD";
  return PurchaseWebCurrency2;
})(PurchaseWebCurrency || {});
var Range = /* @__PURE__ */ ((Range2) => {
  Range2["NextTwoWeeks"] = "NEXT_TWO_WEEKS";
  Range2["Today"] = "TODAY";
  return Range2;
})(Range || {});
var ScheduledMessageStatus = /* @__PURE__ */ ((ScheduledMessageStatus2) => {
  ScheduledMessageStatus2["Scheduled"] = "SCHEDULED";
  ScheduledMessageStatus2["Sent"] = "SENT";
  ScheduledMessageStatus2["Failed"] = "FAILED";
  return ScheduledMessageStatus2;
})(ScheduledMessageStatus || {});
var SeekingStatus = /* @__PURE__ */ ((SeekingStatus2) => {
  SeekingStatus2["Seeking"] = "SEEKING";
  SeekingStatus2["Interested"] = "INTERESTED";
  SeekingStatus2["NotSeeking"] = "NOT_SEEKING";
  return SeekingStatus2;
})(SeekingStatus || {});
var SignalsFilter = /* @__PURE__ */ ((SignalsFilter2) => {
  SignalsFilter2["Birthday"] = "BIRTHDAY";
  SignalsFilter2["ContactsRequest"] = "CONTACTS_REQUEST";
  SignalsFilter2["WorkExperienceUpdate"] = "WORK_EXPERIENCE_UPDATE";
  SignalsFilter2["Vomp"] = "VOMP";
  SignalsFilter2["NewContact"] = "NEW_CONTACT";
  SignalsFilter2["ContactRecommendation"] = "CONTACT_RECOMMENDATION";
  SignalsFilter2["SocialLike"] = "SOCIAL_LIKE";
  SignalsFilter2["SocialComment"] = "SOCIAL_COMMENT";
  return SignalsFilter2;
})(SignalsFilter || {});
var SocialReactionType = /* @__PURE__ */ ((SocialReactionType2) => {
  SocialReactionType2["Like"] = "LIKE";
  return SocialReactionType2;
})(SocialReactionType || {});
var SocialShareToMessengerRecipientType = /* @__PURE__ */ ((SocialShareToMessengerRecipientType2) => {
  SocialShareToMessengerRecipientType2["Chat"] = "CHAT";
  SocialShareToMessengerRecipientType2["Participant"] = "PARTICIPANT";
  return SocialShareToMessengerRecipientType2;
})(SocialShareToMessengerRecipientType || {});
var SocialShareToStartpageVerb = /* @__PURE__ */ ((SocialShareToStartpageVerb2) => {
  SocialShareToStartpageVerb2["Share"] = "SHARE";
  SocialShareToStartpageVerb2["Post"] = "POST";
  return SocialShareToStartpageVerb2;
})(SocialShareToStartpageVerb || {});
var SocialShareToStartpageVisibility = /* @__PURE__ */ ((SocialShareToStartpageVisibility2) => {
  SocialShareToStartpageVisibility2["Public"] = "PUBLIC";
  SocialShareToStartpageVisibility2["Private"] = "PRIVATE";
  return SocialShareToStartpageVisibility2;
})(SocialShareToStartpageVisibility || {});
var StatisticsType = /* @__PURE__ */ ((StatisticsType2) => {
  StatisticsType2["Bar"] = "BAR";
  StatisticsType2["Pie"] = "PIE";
  return StatisticsType2;
})(StatisticsType || {});
var StatusVisibility = /* @__PURE__ */ ((StatusVisibility2) => {
  StatusVisibility2["Recruiter"] = "RECRUITER";
  StatusVisibility2["RecruiterAndContacts"] = "RECRUITER_AND_CONTACTS";
  StatusVisibility2["XingMembers"] = "XING_MEMBERS";
  return StatusVisibility2;
})(StatusVisibility || {});
var StorySupportedActors = /* @__PURE__ */ ((StorySupportedActors2) => {
  StorySupportedActors2["XingId"] = "XING_ID";
  StorySupportedActors2["EntityPage"] = "ENTITY_PAGE";
  StorySupportedActors2["DemoActor"] = "DEMO_ACTOR";
  return StorySupportedActors2;
})(StorySupportedActors || {});
var StoryType = /* @__PURE__ */ ((StoryType2) => {
  StoryType2["Image"] = "IMAGE";
  StoryType2["Text"] = "TEXT";
  StoryType2["Video"] = "VIDEO";
  return StoryType2;
})(StoryType || {});
var TeamPermissionsResourceType = /* @__PURE__ */ ((TeamPermissionsResourceType2) => {
  TeamPermissionsResourceType2["Companies"] = "COMPANIES";
  TeamPermissionsResourceType2["Pages"] = "PAGES";
  TeamPermissionsResourceType2["Talentmanager"] = "TALENTMANAGER";
  TeamPermissionsResourceType2["Talentpoolmanager"] = "TALENTPOOLMANAGER";
  TeamPermissionsResourceType2["Jobmanager"] = "JOBMANAGER";
  TeamPermissionsResourceType2["Referralmanager"] = "REFERRALMANAGER";
  TeamPermissionsResourceType2["Briefings"] = "BRIEFINGS";
  return TeamPermissionsResourceType2;
})(TeamPermissionsResourceType || {});
var TicketCurrencies = /* @__PURE__ */ ((TicketCurrencies2) => {
  TicketCurrencies2["Eur"] = "EUR";
  TicketCurrencies2["Gbp"] = "GBP";
  TicketCurrencies2["Usd"] = "USD";
  TicketCurrencies2["Chf"] = "CHF";
  return TicketCurrencies2;
})(TicketCurrencies || {});
var TicketingTypes = /* @__PURE__ */ ((TicketingTypes2) => {
  TicketingTypes2["NoPriceRange"] = "NO_PRICE_RANGE";
  TicketingTypes2["Free"] = "FREE";
  TicketingTypes2["WithPriceRange"] = "WITH_PRICE_RANGE";
  return TicketingTypes2;
})(TicketingTypes || {});
var TimeFrameFilterOptions = /* @__PURE__ */ ((TimeFrameFilterOptions2) => {
  TimeFrameFilterOptions2["SevenDays"] = "SEVEN_DAYS";
  TimeFrameFilterOptions2["ThirtyDays"] = "THIRTY_DAYS";
  TimeFrameFilterOptions2["NinetyDays"] = "NINETY_DAYS";
  return TimeFrameFilterOptions2;
})(TimeFrameFilterOptions || {});
var TrackingSource = /* @__PURE__ */ ((TrackingSource2) => {
  TrackingSource2["Stan"] = "STAN";
  TrackingSource2["UserLocation"] = "USER_LOCATION";
  TrackingSource2["StreamTrack"] = "STREAM_TRACK";
  TrackingSource2["Itjfm"] = "ITJFM";
  TrackingSource2["Messages"] = "MESSAGES";
  TrackingSource2["SearchKeywords"] = "SEARCH_KEYWORDS";
  TrackingSource2["Calendar"] = "CALENDAR";
  return TrackingSource2;
})(TrackingSource || {});
var TwoFaSettingsMethod = /* @__PURE__ */ ((TwoFaSettingsMethod2) => {
  TwoFaSettingsMethod2["None"] = "NONE";
  TwoFaSettingsMethod2["Sms"] = "SMS";
  TwoFaSettingsMethod2["Authenticator"] = "AUTHENTICATOR";
  return TwoFaSettingsMethod2;
})(TwoFaSettingsMethod || {});
var UnauthorizedJobReason = /* @__PURE__ */ ((UnauthorizedJobReason2) => {
  UnauthorizedJobReason2["Private"] = "PRIVATE";
  UnauthorizedJobReason2["Projobs"] = "PROJOBS";
  return UnauthorizedJobReason2;
})(UnauthorizedJobReason || {});
var UploadApplication = /* @__PURE__ */ ((UploadApplication2) => {
  UploadApplication2["StartPage"] = "START_PAGE";
  UploadApplication2["Profile"] = "PROFILE";
  UploadApplication2["Postings"] = "POSTINGS";
  UploadApplication2["EntityPages"] = "ENTITY_PAGES";
  UploadApplication2["Jobs"] = "JOBS";
  UploadApplication2["Events"] = "EVENTS";
  UploadApplication2["Articles"] = "ARTICLES";
  UploadApplication2["Messenger"] = "MESSENGER";
  return UploadApplication2;
})(UploadApplication || {});
var UpsellIosOfferType = /* @__PURE__ */ ((UpsellIosOfferType2) => {
  UpsellIosOfferType2["Intro"] = "INTRO";
  UpsellIosOfferType2["Promo"] = "PROMO";
  UpsellIosOfferType2["Regular"] = "REGULAR";
  return UpsellIosOfferType2;
})(UpsellIosOfferType || {});
var UpsellProduct = /* @__PURE__ */ ((UpsellProduct2) => {
  UpsellProduct2["Premium"] = "premium";
  UpsellProduct2["Projobs"] = "projobs";
  return UpsellProduct2;
})(UpsellProduct || {});
var UserDataInquiryNotificationType = /* @__PURE__ */ ((UserDataInquiryNotificationType2) => {
  UserDataInquiryNotificationType2["Information"] = "INFORMATION";
  UserDataInquiryNotificationType2["Error"] = "ERROR";
  return UserDataInquiryNotificationType2;
})(UserDataInquiryNotificationType || {});
var UserDataInquiryStatus = /* @__PURE__ */ ((UserDataInquiryStatus2) => {
  UserDataInquiryStatus2["Processing"] = "PROCESSING";
  UserDataInquiryStatus2["Ready"] = "READY";
  return UserDataInquiryStatus2;
})(UserDataInquiryStatus || {});
var UserFlagsDisplayFlag = /* @__PURE__ */ ((UserFlagsDisplayFlag2) => {
  UserFlagsDisplayFlag2["Executive"] = "EXECUTIVE";
  UserFlagsDisplayFlag2["Ambassador"] = "AMBASSADOR";
  UserFlagsDisplayFlag2["Insider"] = "INSIDER";
  UserFlagsDisplayFlag2["ProTrainer"] = "PRO_TRAINER";
  UserFlagsDisplayFlag2["ProCoach"] = "PRO_COACH";
  UserFlagsDisplayFlag2["Moderator"] = "MODERATOR";
  UserFlagsDisplayFlag2["Premium"] = "PREMIUM";
  UserFlagsDisplayFlag2["Basic"] = "BASIC";
  return UserFlagsDisplayFlag2;
})(UserFlagsDisplayFlag || {});
var VideoEncodingTriggerMode = /* @__PURE__ */ ((VideoEncodingTriggerMode2) => {
  VideoEncodingTriggerMode2["Immediate"] = "IMMEDIATE";
  VideoEncodingTriggerMode2["Explicit"] = "EXPLICIT";
  return VideoEncodingTriggerMode2;
})(VideoEncodingTriggerMode || {});
var VideoImageAttachmentUnit = /* @__PURE__ */ ((VideoImageAttachmentUnit2) => {
  VideoImageAttachmentUnit2["Pixels"] = "PIXELS";
  VideoImageAttachmentUnit2["Percentage"] = "PERCENTAGE";
  return VideoImageAttachmentUnit2;
})(VideoImageAttachmentUnit || {});
var VideoResourceFormat = /* @__PURE__ */ ((VideoResourceFormat2) => {
  VideoResourceFormat2["Png"] = "PNG";
  return VideoResourceFormat2;
})(VideoResourceFormat || {});
var VideoStatus = /* @__PURE__ */ ((VideoStatus2) => {
  VideoStatus2["Enqueued"] = "ENQUEUED";
  VideoStatus2["Encoding"] = "ENCODING";
  VideoStatus2["Available"] = "AVAILABLE";
  VideoStatus2["Failed"] = "FAILED";
  return VideoStatus2;
})(VideoStatus || {});
var VideoSubtitleType = /* @__PURE__ */ ((VideoSubtitleType2) => {
  VideoSubtitleType2["Webvtt"] = "WEBVTT";
  VideoSubtitleType2["Srt"] = "SRT";
  return VideoSubtitleType2;
})(VideoSubtitleType || {});
var VideoTrackingEventType = /* @__PURE__ */ ((VideoTrackingEventType2) => {
  VideoTrackingEventType2["Ready"] = "READY";
  VideoTrackingEventType2["Start"] = "START";
  VideoTrackingEventType2["ActiveView"] = "ACTIVE_VIEW";
  VideoTrackingEventType2["Mute"] = "MUTE";
  VideoTrackingEventType2["Unmute"] = "UNMUTE";
  VideoTrackingEventType2["FullscreenStart"] = "FULLSCREEN_START";
  VideoTrackingEventType2["FullscreenExit"] = "FULLSCREEN_EXIT";
  VideoTrackingEventType2["ThreeSeconds"] = "THREE_SECONDS";
  VideoTrackingEventType2["TenSeconds"] = "TEN_SECONDS";
  VideoTrackingEventType2["TwentyFivePercent"] = "TWENTY_FIVE_PERCENT";
  VideoTrackingEventType2["FiftyPercent"] = "FIFTY_PERCENT";
  VideoTrackingEventType2["SeventyFivePercent"] = "SEVENTY_FIVE_PERCENT";
  VideoTrackingEventType2["NinetyFivePercent"] = "NINETY_FIVE_PERCENT";
  VideoTrackingEventType2["OneHundredPercent"] = "ONE_HUNDRED_PERCENT";
  VideoTrackingEventType2["PlayerError"] = "PLAYER_ERROR";
  VideoTrackingEventType2["SetupError"] = "SETUP_ERROR";
  return VideoTrackingEventType2;
})(VideoTrackingEventType || {});
var VideoV2Status = /* @__PURE__ */ ((VideoV2Status2) => {
  VideoV2Status2["Created"] = "CREATED";
  VideoV2Status2["Encoding"] = "ENCODING";
  VideoV2Status2["Available"] = "AVAILABLE";
  VideoV2Status2["Failed"] = "FAILED";
  return VideoV2Status2;
})(VideoV2Status || {});
var VompNotificationUnitTime = /* @__PURE__ */ ((VompNotificationUnitTime2) => {
  VompNotificationUnitTime2["Hours"] = "HOURS";
  VompNotificationUnitTime2["Days"] = "DAYS";
  return VompNotificationUnitTime2;
})(VompNotificationUnitTime || {});
var VompPlatformEnum = /* @__PURE__ */ ((VompPlatformEnum2) => {
  VompPlatformEnum2["Android"] = "ANDROID";
  VompPlatformEnum2["Ios"] = "IOS";
  VompPlatformEnum2["WebSmallScreen"] = "WEB_SMALL_SCREEN";
  VompPlatformEnum2["WebLargeScreen"] = "WEB_LARGE_SCREEN";
  VompPlatformEnum2["Web"] = "WEB";
  return VompPlatformEnum2;
})(VompPlatformEnum || {});
var XingIdLayout = /* @__PURE__ */ ((XingIdLayout2) => {
  XingIdLayout2["Basic"] = "BASIC";
  XingIdLayout2["Premium"] = "PREMIUM";
  return XingIdLayout2;
})(XingIdLayout || {});
var XingIdOccupationCategory = /* @__PURE__ */ ((XingIdOccupationCategory2) => {
  XingIdOccupationCategory2["Education"] = "EDUCATION";
  XingIdOccupationCategory2["WorkExperience"] = "WORK_EXPERIENCE";
  XingIdOccupationCategory2["Inactive"] = "INACTIVE";
  XingIdOccupationCategory2["Role"] = "ROLE";
  XingIdOccupationCategory2["Other"] = "OTHER";
  return XingIdOccupationCategory2;
})(XingIdOccupationCategory || {});
var XingIdOccupationsBucketType = /* @__PURE__ */ ((XingIdOccupationsBucketType2) => {
  XingIdOccupationsBucketType2["Visible"] = "VISIBLE";
  XingIdOccupationsBucketType2["Current"] = "CURRENT";
  XingIdOccupationsBucketType2["Past"] = "PAST";
  XingIdOccupationsBucketType2["Roles"] = "ROLES";
  XingIdOccupationsBucketType2["Degrees"] = "DEGREES";
  return XingIdOccupationsBucketType2;
})(XingIdOccupationsBucketType || {});
var XingIdPlatform = /* @__PURE__ */ ((XingIdPlatform2) => {
  XingIdPlatform2["None"] = "NONE";
  XingIdPlatform2["Mobile"] = "MOBILE";
  XingIdPlatform2["Web"] = "WEB";
  return XingIdPlatform2;
})(XingIdPlatform || {});
var OrderDirection = /* @__PURE__ */ ((OrderDirection2) => {
  OrderDirection2["Asc"] = "ASC";
  OrderDirection2["Desc"] = "DESC";
  return OrderDirection2;
})(OrderDirection || {});
var VompTypeEnum = /* @__PURE__ */ ((VompTypeEnum2) => {
  VompTypeEnum2["Internal"] = "INTERNAL";
  VompTypeEnum2["External"] = "EXTERNAL";
  return VompTypeEnum2;
})(VompTypeEnum || {});
export {
  AcademicTitle,
  Accessibility,
  AdSenderTypes,
  AdTypes,
  ArticleMediaInputType,
  ArticlePublicationState,
  ArticleSupportedBlockTypes,
  AvailableAction,
  BpayPaymentMethodTypeInput,
  BriefingCandidateClientStatus,
  ClickReasonsEnum,
  ClientPaymentInvoiceStatus,
  CommunityCategory,
  CommunityCommentTypes,
  CommunityInterationDialogType,
  CommunityInterationMethod,
  CommunityInterationType,
  CommunityMeetupFrequency,
  CommunityMemberState,
  CommunityMigrationState,
  CommunityPostCrosspostingStatus,
  CommunityStatus,
  CommunityTileStates,
  CommunityTileTypes,
  CompaniesIndustriesSortOptions,
  CompaniesRecentlyClaimedOrder,
  CompanyAffiliateCategory,
  CompanyContractPackage,
  CompanyCreateFeedErrorType,
  CompanyDemographicsKpi,
  CompanyEmployeesContactLevel,
  CompanyEmployeesSort,
  CompanyFeedType,
  CompanyInsightsGranularity,
  CompanyKununuReviewJobStatus,
  CompanyMappedBenefitType,
  CompanyMembership,
  CompanyOffers,
  CompanyUpdateAdStatus,
  CompanyUpdateInformationErrorType,
  CompanyUpdateOrder,
  CompanyUserRole,
  ContactsListOrderBy,
  ContactsMatchField,
  ContentArticleStatus,
  ContentChannelFollowState,
  ContentPageType,
  ContentPurchaseType,
  ContentResourceType,
  CountryCodesAlpha2,
  CountryFilter,
  Currency,
  DataSharingExclusionType,
  DiscoFeature,
  DiscoLoggingReason,
  DiscoModuleRenderingType,
  DiscoPlatform,
  DiscoTopicSearchSorting,
  DisplayFlag,
  EntityMediaType,
  EntityPageContractType,
  EntityPageCoverMediaType,
  EntityPageDemographicsKpi,
  EntityPageFocusType,
  EntityPageInsightsGranularity,
  EntityPageParentPage,
  EntityPagePublicationStatus,
  EntityPageSocialProofType,
  EntityPageSupportedContentObjectTypes,
  EntityPageTrackVisitorPlatform,
  EntityPageUserRole,
  EntityPageVisibility,
  EntityTypeValue,
  ErecruitingSourcingServiceBriefingWeightFactors,
  ErecruitingSourcingServiceMessageTone,
  ErecruitingSourcingServiceProductType,
  ErecruitingSourcingServiceProductTypeLowCase,
  EventCategory,
  EventCommunityEventOrderBy,
  EventContextFilter,
  EventDraftFilter,
  EventGuestlistVisibilities,
  EventInvitationReason,
  EventInvitationToolCreateMutationErrorReason,
  EventInvitationToolTypes,
  EventLastVisitLocation,
  EventNoRsvpReason,
  EventOrganizerType,
  EventParticipantsOrder,
  EventParticipationKind,
  EventRsvpOptionState,
  EventTicketingFilter,
  EventTimeFilter,
  EventUserMessageReason,
  EventUserMessageType,
  EventVisibilities,
  EventVisitorsFilters,
  EventVisitorsSorting,
  EventWaitingListState,
  EventWebinarLinkState,
  EventsOrderBy,
  EventsType,
  FollowersFollowingNamespace,
  FollowersFollowingOrder,
  FollowersFollowingSort,
  FollowersFollowingType,
  Gender,
  GroupMode,
  GroupsErrorType,
  GroupsGroupEventFrequency,
  GroupsGroupEventsOrderBy,
  GroupsGroupState,
  GroupsGroupVisibility,
  GroupsMembershipRole,
  GroupsMembershipSettingKind,
  GroupsMembershipState,
  HasSeenSource,
  HelpCenterApplication,
  HelpCenterFilter,
  HelpCenterKnowledgeLevel,
  HelpCenterLanguage,
  HelpCenterRole,
  HelpCenterViewStatus,
  JobApplicationFormExternalDocType,
  JobApplicationFormFieldType,
  JobBookmarkState,
  JobInteractionPlatform,
  JobReportReason,
  JobReportableField,
  JobSeekerWillingnessToTravel,
  JobUserXingApplicationStatus,
  LanguageCode,
  LeadAdFormFields,
  LeadAdFormSections,
  LoginSecurityIssueReason,
  LoginState,
  MehubEntityType,
  MehubUpdatesCommentSubType,
  MehubUpdatesDevice,
  MehubUpdatesNotificationType,
  MessageType,
  MessengerChatType,
  MessengerChatsFilterTypes,
  MessengerContextId,
  MostVisitedCompaniesOrder,
  MoveonAssessmentProcessingStatus,
  NbaCardId,
  NetworkRelationshipErrorType,
  NetworkRelationshipPermissionType,
  NetworkRelationshipType,
  NetworkUpdatesFilter,
  NewVisitType,
  OnboardingFieldName,
  OrderDirection,
  OrganizedEventsType,
  PartnerMemberships,
  PartnerTypes,
  PaymentAccountType,
  PaymentClientProductGroup,
  PaymentCurrency,
  PaymentDurationType,
  PaymentInvoiceLanguage,
  PaymentInvoiceStatus,
  PaymentMobileMerchant,
  PaymentSubscriptionStatus,
  PhonePreferenceDays,
  PhonePreferencesOptions,
  PostingAdSubType,
  PostingPublicationState,
  PostingPublicationStrategy,
  PostingsAvailablePostingTypes,
  PostingsVisibility,
  PotentialCandidatesInteraction,
  PotentialCandidatesOrder,
  PredictiveSearchSectionType,
  PremiumFeaturesOverviewProducts,
  PremiumPlatform,
  PremiumSelfAssessmentStatusState,
  PremiumSelfDevelopmentCourseFilter,
  ProfileImageSize,
  ProfileModuleIdentifier,
  ProfileOccupationTypeCategoryIdentifier,
  ProfileOccupationTypeIdentifier,
  ProfilePersonalStatuses,
  ProfileTimelineAction,
  ProfileTimelineFieldName,
  ProjobsConsumer,
  PurchaseMobilePlatform,
  PurchaseOrderType,
  PurchasePlatform,
  PurchaseProduct,
  PurchaseWebCampaignType,
  PurchaseWebCurrency,
  Range,
  ScheduledMessageStatus,
  SeekingStatus,
  SignalsFilter,
  SocialReactionType,
  SocialShareToMessengerRecipientType,
  SocialShareToStartpageVerb,
  SocialShareToStartpageVisibility,
  StatisticsType,
  StatusVisibility,
  StorySupportedActors,
  StoryType,
  TeamPermissionsResourceType,
  TicketCurrencies,
  TicketingTypes,
  TimeFrameFilterOptions,
  TrackingSource,
  TwoFaSettingsMethod,
  UnauthorizedJobReason,
  UploadApplication,
  UpsellIosOfferType,
  UpsellProduct,
  UserDataInquiryNotificationType,
  UserDataInquiryStatus,
  UserFlagsDisplayFlag,
  VideoEncodingTriggerMode,
  VideoImageAttachmentUnit,
  VideoResourceFormat,
  VideoStatus,
  VideoSubtitleType,
  VideoTrackingEventType,
  VideoV2Status,
  VompNotificationUnitTime,
  VompPlatformEnum,
  VompTypeEnum,
  XingIdLayout,
  XingIdOccupationCategory,
  XingIdOccupationsBucketType,
  XingIdPlatform
};
